import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date; output: Date; }
  /** An arbitrary-precision Decimal type */
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AccessLink = {
  __typename?: 'AccessLink';
  _count: AccessLinkCount;
  accessCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  linkFirstAccount: Scalars['Boolean']['output'];
  masterClassId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  objId: Scalars['String']['output'];
  patientCaseId?: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageCountLeft: Scalars['Int']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type AccessLinkAvgAggregate = {
  __typename?: 'AccessLinkAvgAggregate';
  usageCountLeft?: Maybe<Scalars['Float']['output']>;
};

export type AccessLinkConnection = {
  __typename?: 'AccessLinkConnection';
  edges: Array<AccessLinkEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccessLinkCount = {
  __typename?: 'AccessLinkCount';
  explicitUserAccesses: Scalars['Int']['output'];
};

export type AccessLinkCountAggregate = {
  __typename?: 'AccessLinkCountAggregate';
  _all: Scalars['Int']['output'];
  accessCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Int']['output'];
  linkFirstAccount: Scalars['Int']['output'];
  masterClassId: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  objId: Scalars['Int']['output'];
  patientCaseId: Scalars['Int']['output'];
  purpose: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usageCountLeft: Scalars['Int']['output'];
  validUntil: Scalars['Int']['output'];
};

export type AccessLinkEdge = {
  __typename?: 'AccessLinkEdge';
  cursor: Scalars['String']['output'];
  node: AccessLink;
};

export type AccessLinkListRelationFilter = {
  every?: InputMaybe<AccessLinkWhereInput>;
  none?: InputMaybe<AccessLinkWhereInput>;
  some?: InputMaybe<AccessLinkWhereInput>;
};

export type AccessLinkMaxAggregate = {
  __typename?: 'AccessLinkMaxAggregate';
  accessCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  linkFirstAccount?: Maybe<Scalars['Boolean']['output']>;
  masterClassId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  objId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageCountLeft?: Maybe<Scalars['Int']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type AccessLinkMinAggregate = {
  __typename?: 'AccessLinkMinAggregate';
  accessCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  linkFirstAccount?: Maybe<Scalars['Boolean']['output']>;
  masterClassId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  objId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageCountLeft?: Maybe<Scalars['Int']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type AccessLinkNullableScalarRelationFilter = {
  is?: InputMaybe<AccessLinkWhereInput>;
  isNot?: InputMaybe<AccessLinkWhereInput>;
};

export type AccessLinkSumAggregate = {
  __typename?: 'AccessLinkSumAggregate';
  usageCountLeft?: Maybe<Scalars['Int']['output']>;
};

/** The type of access link (e.g., MEETING_READ_ACCESS, MASTERCLASS_READ_ACCESS, CASE_PREVIEW) */
export enum AccessLinkTypes {
  CasePreview = 'CASE_PREVIEW',
  ClientRegistration = 'CLIENT_REGISTRATION',
  MasterclassReadAccess = 'MASTERCLASS_READ_ACCESS',
  MeetingReadAccess = 'MEETING_READ_ACCESS'
}

export type AccessLinkWhereInput = {
  AND?: InputMaybe<Array<AccessLinkWhereInput>>;
  NOT?: InputMaybe<Array<AccessLinkWhereInput>>;
  OR?: InputMaybe<Array<AccessLinkWhereInput>>;
  accessCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  explicitUserAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isEnabled?: InputMaybe<BoolFilter>;
  linkFirstAccount?: InputMaybe<BoolFilter>;
  masterClass?: InputMaybe<MasterClassNullableScalarRelationFilter>;
  masterClassId?: InputMaybe<StringNullableFilter>;
  meeting?: InputMaybe<MeetingNullableScalarRelationFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonFilter>;
  objId?: InputMaybe<StringFilter>;
  patientCase?: InputMaybe<PatientCaseNullableScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringNullableFilter>;
  purpose?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usageCountLeft?: InputMaybe<IntFilter>;
  validUntil?: InputMaybe<DateTimeFilter>;
};

export type AccessLinkWhereUniqueInput = {
  AND?: InputMaybe<Array<AccessLinkWhereInput>>;
  NOT?: InputMaybe<Array<AccessLinkWhereInput>>;
  OR?: InputMaybe<Array<AccessLinkWhereInput>>;
  accessCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  explicitUserAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<BoolFilter>;
  linkFirstAccount?: InputMaybe<BoolFilter>;
  masterClass?: InputMaybe<MasterClassNullableScalarRelationFilter>;
  masterClassId?: InputMaybe<StringNullableFilter>;
  meeting?: InputMaybe<MeetingNullableScalarRelationFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonFilter>;
  objId?: InputMaybe<StringFilter>;
  patientCase?: InputMaybe<PatientCaseNullableScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringNullableFilter>;
  purpose?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usageCountLeft?: InputMaybe<IntFilter>;
  validUntil?: InputMaybe<DateTimeFilter>;
};

export type Answer = {
  __typename?: 'Answer';
  answerIndexes?: Maybe<Array<Scalars['String']['output']>>;
  answerTexts?: Maybe<Array<Scalars['String']['output']>>;
  contextType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  masterClassUserSessionId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId: Scalars['String']['output'];
  slideId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type AnswerConnection = {
  __typename?: 'AnswerConnection';
  edges: Array<AnswerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnswerCountAggregate = {
  __typename?: 'AnswerCountAggregate';
  _all: Scalars['Int']['output'];
  answerIndexes: Scalars['Int']['output'];
  answerTexts: Scalars['Int']['output'];
  contextType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  masterClassUserSessionId: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  patientCaseId: Scalars['Int']['output'];
  slideId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type AnswerCreateanswerIndexesInput = {
  set: Array<Scalars['String']['input']>;
};

export type AnswerCreateanswerTextsInput = {
  set: Array<Scalars['String']['input']>;
};

export type AnswerEdge = {
  __typename?: 'AnswerEdge';
  cursor: Scalars['String']['output'];
  node: Answer;
};

export type AnswerListRelationFilter = {
  every?: InputMaybe<AnswerWhereInput>;
  none?: InputMaybe<AnswerWhereInput>;
  some?: InputMaybe<AnswerWhereInput>;
};

export type AnswerMaxAggregate = {
  __typename?: 'AnswerMaxAggregate';
  contextType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterClassUserSessionId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  slideId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AnswerMinAggregate = {
  __typename?: 'AnswerMinAggregate';
  contextType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterClassUserSessionId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  slideId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AnswerUpdateanswerIndexesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnswerUpdateanswerTextsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnswerWhereInput = {
  AND?: InputMaybe<Array<AnswerWhereInput>>;
  NOT?: InputMaybe<Array<AnswerWhereInput>>;
  OR?: InputMaybe<Array<AnswerWhereInput>>;
  answerIndexes?: InputMaybe<StringNullableListFilter>;
  answerTexts?: InputMaybe<StringNullableListFilter>;
  contextType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  masterClassUserSession?: InputMaybe<MasterClassUserSessionNullableScalarRelationFilter>;
  masterClassUserSessionId?: InputMaybe<StringNullableFilter>;
  meeting?: InputMaybe<MeetingNullableScalarRelationFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  patientCase?: InputMaybe<PatientCaseScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringFilter>;
  slideId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ApproveMeetingInputDto = {
  meetingId: Scalars['String']['input'];
};

export type AssetView = {
  __typename?: 'AssetView';
  assetId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  patientCaseId: Scalars['String']['output'];
  timeWatched: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type AssetViewAvgAggregate = {
  __typename?: 'AssetViewAvgAggregate';
  timeWatched?: Maybe<Scalars['Float']['output']>;
};

export type AssetViewConnection = {
  __typename?: 'AssetViewConnection';
  edges: Array<AssetViewEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetViewCountAggregate = {
  __typename?: 'AssetViewCountAggregate';
  _all: Scalars['Int']['output'];
  assetId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  patientCaseId: Scalars['Int']['output'];
  timeWatched: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type AssetViewEdge = {
  __typename?: 'AssetViewEdge';
  cursor: Scalars['String']['output'];
  node: AssetView;
};

export type AssetViewListRelationFilter = {
  every?: InputMaybe<AssetViewWhereInput>;
  none?: InputMaybe<AssetViewWhereInput>;
  some?: InputMaybe<AssetViewWhereInput>;
};

export type AssetViewMaxAggregate = {
  __typename?: 'AssetViewMaxAggregate';
  assetId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  timeWatched?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AssetViewMinAggregate = {
  __typename?: 'AssetViewMinAggregate';
  assetId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  timeWatched?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AssetViewSumAggregate = {
  __typename?: 'AssetViewSumAggregate';
  timeWatched?: Maybe<Scalars['Int']['output']>;
};

export type AssetViewWhereInput = {
  AND?: InputMaybe<Array<AssetViewWhereInput>>;
  NOT?: InputMaybe<Array<AssetViewWhereInput>>;
  OR?: InputMaybe<Array<AssetViewWhereInput>>;
  assetId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  patientCase?: InputMaybe<PatientCaseScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringFilter>;
  timeWatched?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BatchCreateAccessLinksInputDto = {
  dtos: Array<CreateReadAccessLinkInputDto>;
};

export type BatchUpdateReadAccessLinksInputDto = {
  dtos: Array<UpdateReadAccessLinkInputDto>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type CaseCluster = {
  __typename?: 'CaseCluster';
  _count: CaseClusterCount;
  cases: PatientCaseConnection;
  clients: ClientConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMock: Scalars['Boolean']['output'];
  meetings: MeetingConnection;
  name: Scalars['String']['output'];
  patientCaseIds?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CaseClusterCasesArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type CaseClusterClientsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type CaseClusterMeetingsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type CaseClusterConnection = {
  __typename?: 'CaseClusterConnection';
  edges: Array<CaseClusterEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseClusterCount = {
  __typename?: 'CaseClusterCount';
  cases: Scalars['Int']['output'];
  clients: Scalars['Int']['output'];
  meetings: Scalars['Int']['output'];
};

export type CaseClusterCountAggregate = {
  __typename?: 'CaseClusterCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMock: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  patientCaseIds: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CaseClusterEdge = {
  __typename?: 'CaseClusterEdge';
  cursor: Scalars['String']['output'];
  node: CaseCluster;
};

export type CaseClusterListRelationFilter = {
  every?: InputMaybe<CaseClusterWhereInput>;
  none?: InputMaybe<CaseClusterWhereInput>;
  some?: InputMaybe<CaseClusterWhereInput>;
};

export type CaseClusterMaxAggregate = {
  __typename?: 'CaseClusterMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMock?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseClusterMinAggregate = {
  __typename?: 'CaseClusterMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMock?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseClusterScalarRelationFilter = {
  is?: InputMaybe<CaseClusterWhereInput>;
  isNot?: InputMaybe<CaseClusterWhereInput>;
};

export type CaseClusterWhereInput = {
  AND?: InputMaybe<Array<CaseClusterWhereInput>>;
  NOT?: InputMaybe<Array<CaseClusterWhereInput>>;
  OR?: InputMaybe<Array<CaseClusterWhereInput>>;
  cases?: InputMaybe<PatientCaseListRelationFilter>;
  clients?: InputMaybe<ClientListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isMock?: InputMaybe<BoolFilter>;
  meetings?: InputMaybe<MeetingListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  patientCaseIds?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CaseClusterWhereUniqueInput = {
  AND?: InputMaybe<Array<CaseClusterWhereInput>>;
  NOT?: InputMaybe<Array<CaseClusterWhereInput>>;
  OR?: InputMaybe<Array<CaseClusterWhereInput>>;
  cases?: InputMaybe<PatientCaseListRelationFilter>;
  clients?: InputMaybe<ClientListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMock?: InputMaybe<BoolFilter>;
  meetings?: InputMaybe<MeetingListRelationFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientCaseIds?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CaseStatsAggregation = {
  __typename?: 'CaseStatsAggregation';
  caseId: Scalars['String']['output'];
  caseName?: Maybe<Scalars['String']['output']>;
  summary: CaseStatsSummary;
  userStats: Array<CaseUserStats>;
};

export type CaseStatsSummary = {
  __typename?: 'CaseStatsSummary';
  averageRating?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  passRate?: Maybe<Scalars['Float']['output']>;
  totalUsers: Scalars['Int']['output'];
  usersWhoAccessed: Scalars['Int']['output'];
  usersWhoCompleted: Scalars['Int']['output'];
  usersWhoPassed: Scalars['Int']['output'];
};

export type CaseUserStats = {
  __typename?: 'CaseUserStats';
  averageRating?: Maybe<Scalars['Float']['output']>;
  bestCertificationScore?: Maybe<Scalars['Float']['output']>;
  caseClicks: Scalars['Int']['output'];
  caseSelectorVisits: Scalars['Int']['output'];
  certificationAttempts: Scalars['Int']['output'];
  certificationStatus: CertificationStatus;
  completions: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstAccessDate?: Maybe<Scalars['DateTime']['output']>;
  hasAccessed: Scalars['Boolean']['output'];
  hasCompleted: Scalars['Boolean']['output'];
  lastAccessDate?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type CertificationData = {
  __typename?: 'CertificationData';
  case_id: Scalars['String']['output'];
  case_key: Scalars['String']['output'];
  certification_questions: Array<CertificationQuestion>;
  passing_score?: Maybe<Scalars['Int']['output']>;
};

export type CertificationProgress = {
  __typename?: 'CertificationProgress';
  _count: CertificationProgressCount;
  answers?: Maybe<Scalars['JSON']['output']>;
  attemptNumber: Scalars['Int']['output'];
  caseId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentQuestion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  masterclassId: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
  ratings: MasterclassRatingsConnection;
  score?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};


export type CertificationProgressRatingsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type CertificationProgressAvgAggregate = {
  __typename?: 'CertificationProgressAvgAggregate';
  attemptNumber?: Maybe<Scalars['Float']['output']>;
  currentQuestion?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type CertificationProgressConnection = {
  __typename?: 'CertificationProgressConnection';
  edges: Array<CertificationProgressEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CertificationProgressCount = {
  __typename?: 'CertificationProgressCount';
  ratings: Scalars['Int']['output'];
};

export type CertificationProgressCountAggregate = {
  __typename?: 'CertificationProgressCountAggregate';
  _all: Scalars['Int']['output'];
  answers: Scalars['Int']['output'];
  attemptNumber: Scalars['Int']['output'];
  caseId: Scalars['Int']['output'];
  completedAt: Scalars['Int']['output'];
  currentQuestion: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  masterclassId: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  startedAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CertificationProgressEdge = {
  __typename?: 'CertificationProgressEdge';
  cursor: Scalars['String']['output'];
  node: CertificationProgress;
};

export type CertificationProgressListRelationFilter = {
  every?: InputMaybe<CertificationProgressWhereInput>;
  none?: InputMaybe<CertificationProgressWhereInput>;
  some?: InputMaybe<CertificationProgressWhereInput>;
};

export type CertificationProgressMaxAggregate = {
  __typename?: 'CertificationProgressMaxAggregate';
  attemptNumber?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentQuestion?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterclassId?: Maybe<Scalars['String']['output']>;
  passed?: Maybe<Scalars['Boolean']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CertificationProgressMinAggregate = {
  __typename?: 'CertificationProgressMinAggregate';
  attemptNumber?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentQuestion?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterclassId?: Maybe<Scalars['String']['output']>;
  passed?: Maybe<Scalars['Boolean']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CertificationProgressScalarRelationFilter = {
  is?: InputMaybe<CertificationProgressWhereInput>;
  isNot?: InputMaybe<CertificationProgressWhereInput>;
};

export type CertificationProgressSumAggregate = {
  __typename?: 'CertificationProgressSumAggregate';
  attemptNumber?: Maybe<Scalars['Int']['output']>;
  currentQuestion?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type CertificationProgressUserIdMasterclassIdCaseIdAttemptNumberCompoundUniqueInput = {
  attemptNumber: Scalars['Int']['input'];
  caseId: Scalars['String']['input'];
  masterclassId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CertificationProgressWhereInput = {
  AND?: InputMaybe<Array<CertificationProgressWhereInput>>;
  NOT?: InputMaybe<Array<CertificationProgressWhereInput>>;
  OR?: InputMaybe<Array<CertificationProgressWhereInput>>;
  answers?: InputMaybe<JsonNullableFilter>;
  attemptNumber?: InputMaybe<IntFilter>;
  caseId?: InputMaybe<StringFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  currentQuestion?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  masterclass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterclassId?: InputMaybe<StringFilter>;
  passed?: InputMaybe<BoolFilter>;
  ratings?: InputMaybe<MasterclassRatingsListRelationFilter>;
  score?: InputMaybe<IntNullableFilter>;
  startedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CertificationProgressWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificationProgressWhereInput>>;
  NOT?: InputMaybe<Array<CertificationProgressWhereInput>>;
  OR?: InputMaybe<Array<CertificationProgressWhereInput>>;
  answers?: InputMaybe<JsonNullableFilter>;
  attemptNumber?: InputMaybe<IntFilter>;
  caseId?: InputMaybe<StringFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  currentQuestion?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterclass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterclassId?: InputMaybe<StringFilter>;
  passed?: InputMaybe<BoolFilter>;
  ratings?: InputMaybe<MasterclassRatingsListRelationFilter>;
  score?: InputMaybe<IntNullableFilter>;
  startedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_masterclassId_caseId_attemptNumber?: InputMaybe<CertificationProgressUserIdMasterclassIdCaseIdAttemptNumberCompoundUniqueInput>;
};

export type CertificationQuestion = {
  __typename?: 'CertificationQuestion';
  correct_answer: Scalars['Int']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  question_text: Scalars['String']['output'];
};

/** User certification status for a case */
export enum CertificationStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Passed = 'PASSED'
}

export type ChangeUserToClientInputDto = {
  clientId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ChangeUserToTeamInputDto = {
  teamId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Client = {
  __typename?: 'Client';
  _count: ClientCount;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetings: MeetingConnection;
  members: UserConnection;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ClientMeetingsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type ClientMembersArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type ClientConnection = {
  __typename?: 'ClientConnection';
  edges: Array<ClientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClientCount = {
  __typename?: 'ClientCount';
  caseClusters: Scalars['Int']['output'];
  masterclasses: Scalars['Int']['output'];
  meetings: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  patientCases: Scalars['Int']['output'];
};

export type ClientCountAggregate = {
  __typename?: 'ClientCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ClientEdge = {
  __typename?: 'ClientEdge';
  cursor: Scalars['String']['output'];
  node: Client;
};

export type ClientListRelationFilter = {
  every?: InputMaybe<ClientWhereInput>;
  none?: InputMaybe<ClientWhereInput>;
  some?: InputMaybe<ClientWhereInput>;
};

export type ClientMaxAggregate = {
  __typename?: 'ClientMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientMinAggregate = {
  __typename?: 'ClientMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientNullableScalarRelationFilter = {
  is?: InputMaybe<ClientWhereInput>;
  isNot?: InputMaybe<ClientWhereInput>;
};

export type ClientWhereInput = {
  AND?: InputMaybe<Array<ClientWhereInput>>;
  NOT?: InputMaybe<Array<ClientWhereInput>>;
  OR?: InputMaybe<Array<ClientWhereInput>>;
  caseClusters?: InputMaybe<CaseClusterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  masterclasses?: InputMaybe<MasterClassListRelationFilter>;
  meetings?: InputMaybe<MeetingListRelationFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  patientCases?: InputMaybe<PatientCaseListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientWhereInput>>;
  NOT?: InputMaybe<Array<ClientWhereInput>>;
  OR?: InputMaybe<Array<ClientWhereInput>>;
  caseClusters?: InputMaybe<CaseClusterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterclasses?: InputMaybe<MasterClassListRelationFilter>;
  meetings?: InputMaybe<MeetingListRelationFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientCases?: InputMaybe<PatientCaseListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** The type of context the object is associated with (e.g., MEETING, MASTERCLASS) */
export enum ContextType {
  Masterclass = 'MASTERCLASS',
  Meeting = 'MEETING'
}

export type CreateAnswerInputDto = {
  answerIndexes?: InputMaybe<AnswerCreateanswerIndexesInput>;
  answerTexts?: InputMaybe<AnswerCreateanswerTextsInput>;
  contextType: ContextType;
  objId: Scalars['String']['input'];
  patientCaseId: Scalars['String']['input'];
  slideId: Scalars['String']['input'];
};

export type CreateAssetViewInputDto = {
  assetId: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
  patientCaseId: Scalars['String']['input'];
  timeWatched: Scalars['Int']['input'];
};

export type CreateCaseClusterInputDto = {
  clientIds: Array<Scalars['String']['input']>;
  isMock?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  patientCaseIds: Array<Scalars['String']['input']>;
};

export type CreateClientInputDto = {
  name: Scalars['String']['input'];
};

export type CreateExplicitUserAccessInputDto = {
  objId: Scalars['String']['input'];
  permission?: InputMaybe<ExplicitUserAccessPermissionType>;
  type: ExplicitUserAccessType;
  userId: Scalars['String']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type CreateMasterClassInputDto = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientCaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateMasterClassUserSessionInputDto = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  masterClassId: Scalars['String']['input'];
};

export type CreateMasterclassRatingsInputDto = {
  applicationRating: Scalars['Float']['input'];
  caseId: Scalars['String']['input'];
  certificationProgressId: Scalars['String']['input'];
  masterclassId: Scalars['String']['input'];
  masterclassRating: Scalars['Float']['input'];
};

export type CreateMeetingInputDto = {
  administrativeStatus?: InputMaybe<MeetingAdministrativeStatus>;
  caseClusterId: Scalars['String']['input'];
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventDate: Scalars['DateTime']['input'];
  eventLocation: Scalars['String']['input'];
  hostFullName: Scalars['String']['input'];
  hostId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isInTesting?: InputMaybe<Scalars['Boolean']['input']>;
  isMock?: InputMaybe<Scalars['Boolean']['input']>;
  meetingNotes: Scalars['String']['input'];
  meetingType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  purchaseOrderNbr: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  streamUrl?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMessageInputDto = {
  body: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
};

export type CreateNpsScoreInputDto = {
  meetingId: Scalars['String']['input'];
  scores: Array<Scalars['Float']['input']>;
};

export type CreateOrUpdateAnswerInputDto = {
  answerIndexes?: InputMaybe<AnswerUpdateanswerIndexesInput>;
  answerTexts?: InputMaybe<AnswerUpdateanswerTextsInput>;
  contextType: ContextType;
  objId: Scalars['String']['input'];
  patientCaseId: Scalars['String']['input'];
  slideId: Scalars['String']['input'];
};

export type CreateOrUpdateSlideStatsDto = {
  meetingId: Scalars['String']['input'];
  patientCaseId: Scalars['String']['input'];
  slideId: Scalars['String']['input'];
  time?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CreateReadAccessLinkInputDto = {
  forcedUsername?: InputMaybe<Scalars['String']['input']>;
  linkFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  metadata: Scalars['JSON']['input'];
  objId: Scalars['String']['input'];
  type: AccessLinkTypes;
  usageCountLeft: Scalars['Int']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type CreateRegistrationLinkInputDto = {
  clientId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type CreateTeamInputDto = {
  name: Scalars['String']['input'];
};

export type CreateUserInputDto = {
  email: Scalars['String']['input'];
};

export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  temporaryPassword: Scalars['String']['output'];
  user: User;
};

export type DateAvailability = {
  __typename?: 'DateAvailability';
  availableTeams: Scalars['Int']['output'];
  bookedTeams: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  isFullyBooked: Scalars['Boolean']['output'];
  totalTeams: Scalars['Int']['output'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type EnumMeetingAdministrativeStatusFilter = {
  equals?: InputMaybe<MeetingAdministrativeStatus>;
  in?: InputMaybe<Array<MeetingAdministrativeStatus>>;
  not?: InputMaybe<NestedEnumMeetingAdministrativeStatusFilter>;
  notIn?: InputMaybe<Array<MeetingAdministrativeStatus>>;
};

export type ExplicitUserAccess = {
  __typename?: 'ExplicitUserAccess';
  accessGranterId?: Maybe<Scalars['String']['output']>;
  accessLinkId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  masterClassId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  permission: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type ExplicitUserAccessConnection = {
  __typename?: 'ExplicitUserAccessConnection';
  edges: Array<ExplicitUserAccessEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExplicitUserAccessCountAggregate = {
  __typename?: 'ExplicitUserAccessCountAggregate';
  _all: Scalars['Int']['output'];
  accessGranterId: Scalars['Int']['output'];
  accessLinkId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  masterClassId: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  patientCaseId: Scalars['Int']['output'];
  permission: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  validUntil: Scalars['Int']['output'];
};

export type ExplicitUserAccessEdge = {
  __typename?: 'ExplicitUserAccessEdge';
  cursor: Scalars['String']['output'];
  node: ExplicitUserAccess;
};

export type ExplicitUserAccessListRelationFilter = {
  every?: InputMaybe<ExplicitUserAccessWhereInput>;
  none?: InputMaybe<ExplicitUserAccessWhereInput>;
  some?: InputMaybe<ExplicitUserAccessWhereInput>;
};

export type ExplicitUserAccessMaxAggregate = {
  __typename?: 'ExplicitUserAccessMaxAggregate';
  accessGranterId?: Maybe<Scalars['String']['output']>;
  accessLinkId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterClassId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type ExplicitUserAccessMinAggregate = {
  __typename?: 'ExplicitUserAccessMinAggregate';
  accessGranterId?: Maybe<Scalars['String']['output']>;
  accessLinkId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterClassId?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

/** Permission level for explicit user access */
export enum ExplicitUserAccessPermissionType {
  Read = 'READ',
  Reviewer = 'REVIEWER'
}

/** The type of the object this gives access to (e.g., MEETING, MASTERCLASS, PATIENT_CASE) */
export enum ExplicitUserAccessType {
  Masterclass = 'MASTERCLASS',
  Meeting = 'MEETING',
  PatientCase = 'PATIENT_CASE'
}

export type ExplicitUserAccessUserIdMasterClassIdCompoundUniqueInput = {
  masterClassId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ExplicitUserAccessUserIdMeetingIdCompoundUniqueInput = {
  meetingId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ExplicitUserAccessUserIdPatientCaseIdCompoundUniqueInput = {
  patientCaseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ExplicitUserAccessWhereInput = {
  AND?: InputMaybe<Array<ExplicitUserAccessWhereInput>>;
  NOT?: InputMaybe<Array<ExplicitUserAccessWhereInput>>;
  OR?: InputMaybe<Array<ExplicitUserAccessWhereInput>>;
  accessGranter?: InputMaybe<UserNullableScalarRelationFilter>;
  accessGranterId?: InputMaybe<StringNullableFilter>;
  accessLink?: InputMaybe<AccessLinkNullableScalarRelationFilter>;
  accessLinkId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  masterClass?: InputMaybe<MasterClassNullableScalarRelationFilter>;
  masterClassId?: InputMaybe<StringNullableFilter>;
  meeting?: InputMaybe<MeetingNullableScalarRelationFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  patientCase?: InputMaybe<PatientCaseNullableScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringNullableFilter>;
  permission?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  validUntil?: InputMaybe<DateTimeFilter>;
};

export type ExplicitUserAccessWhereUniqueInput = {
  AND?: InputMaybe<Array<ExplicitUserAccessWhereInput>>;
  NOT?: InputMaybe<Array<ExplicitUserAccessWhereInput>>;
  OR?: InputMaybe<Array<ExplicitUserAccessWhereInput>>;
  accessGranter?: InputMaybe<UserNullableScalarRelationFilter>;
  accessGranterId?: InputMaybe<StringNullableFilter>;
  accessLink?: InputMaybe<AccessLinkNullableScalarRelationFilter>;
  accessLinkId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterClass?: InputMaybe<MasterClassNullableScalarRelationFilter>;
  masterClassId?: InputMaybe<StringNullableFilter>;
  meeting?: InputMaybe<MeetingNullableScalarRelationFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  patientCase?: InputMaybe<PatientCaseNullableScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringNullableFilter>;
  permission?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_masterClassId?: InputMaybe<ExplicitUserAccessUserIdMasterClassIdCompoundUniqueInput>;
  userId_meetingId?: InputMaybe<ExplicitUserAccessUserIdMeetingIdCompoundUniqueInput>;
  userId_patientCaseId?: InputMaybe<ExplicitUserAccessUserIdPatientCaseIdCompoundUniqueInput>;
  validUntil?: InputMaybe<DateTimeFilter>;
};

export type GetAvailableDatesInputDto = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};

export type HostFields = {
  __typename?: 'HostFields';
  createdAt: Scalars['DateTime']['output'];
  currentAssetID?: Maybe<Scalars['String']['output']>;
  currentCase?: Maybe<Scalars['String']['output']>;
  currentSlide: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HostFieldsAvgAggregate = {
  __typename?: 'HostFieldsAvgAggregate';
  currentSlide?: Maybe<Scalars['Float']['output']>;
};

export type HostFieldsCountAggregate = {
  __typename?: 'HostFieldsCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currentAssetID: Scalars['Int']['output'];
  currentCase: Scalars['Int']['output'];
  currentSlide: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type HostFieldsEdge = {
  __typename?: 'HostFieldsEdge';
  cursor: Scalars['String']['output'];
  node: HostFields;
};

export type HostFieldsMaxAggregate = {
  __typename?: 'HostFieldsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentAssetID?: Maybe<Scalars['String']['output']>;
  currentCase?: Maybe<Scalars['String']['output']>;
  currentSlide?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HostFieldsMinAggregate = {
  __typename?: 'HostFieldsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentAssetID?: Maybe<Scalars['String']['output']>;
  currentCase?: Maybe<Scalars['String']['output']>;
  currentSlide?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HostFieldsNullableScalarRelationFilter = {
  is?: InputMaybe<HostFieldsWhereInput>;
  isNot?: InputMaybe<HostFieldsWhereInput>;
};

export type HostFieldsSumAggregate = {
  __typename?: 'HostFieldsSumAggregate';
  currentSlide?: Maybe<Scalars['Int']['output']>;
};

export type HostFieldsWhereInput = {
  AND?: InputMaybe<Array<HostFieldsWhereInput>>;
  NOT?: InputMaybe<Array<HostFieldsWhereInput>>;
  OR?: InputMaybe<Array<HostFieldsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentAssetID?: InputMaybe<StringNullableFilter>;
  currentCase?: InputMaybe<StringNullableFilter>;
  currentSlide?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HostFieldsWhereUniqueInput = {
  AND?: InputMaybe<Array<HostFieldsWhereInput>>;
  NOT?: InputMaybe<Array<HostFieldsWhereInput>>;
  OR?: InputMaybe<Array<HostFieldsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentAssetID?: InputMaybe<StringNullableFilter>;
  currentCase?: InputMaybe<StringNullableFilter>;
  currentSlide?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']['input']>>;
  has?: InputMaybe<Scalars['Int']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type LiveMeetingParticipants = {
  __typename?: 'LiveMeetingParticipants';
  count: Scalars['Int']['output'];
  meetingId: Scalars['String']['output'];
  participants: Array<User>;
};

export type MasterClass = {
  __typename?: 'MasterClass';
  _count: MasterClassCount;
  accessLinks: AccessLinkConnection;
  clients: ClientConnection;
  createdAt: Scalars['DateTime']['output'];
  hasReviewerAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mySessionStats: MySessionStats;
  mySessions: MasterClassUserSessionConnection;
  patientCases: PatientCaseConnection;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type MasterClassAccessLinksArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type MasterClassClientsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type MasterClassMySessionsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type MasterClassPatientCasesArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type MasterClassConnection = {
  __typename?: 'MasterClassConnection';
  edges: Array<MasterClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterClassCount = {
  __typename?: 'MasterClassCount';
  accessLinks: Scalars['Int']['output'];
  certificationProgress: Scalars['Int']['output'];
  clients: Scalars['Int']['output'];
  explicitReadAccesses: Scalars['Int']['output'];
  masterClassUserSessions: Scalars['Int']['output'];
  masterclassRatings: Scalars['Int']['output'];
  masterclassUserStatistics: Scalars['Int']['output'];
  patientCases: Scalars['Int']['output'];
};

export type MasterClassCountAggregate = {
  __typename?: 'MasterClassCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MasterClassEdge = {
  __typename?: 'MasterClassEdge';
  cursor: Scalars['String']['output'];
  node: MasterClass;
};

export type MasterClassListRelationFilter = {
  every?: InputMaybe<MasterClassWhereInput>;
  none?: InputMaybe<MasterClassWhereInput>;
  some?: InputMaybe<MasterClassWhereInput>;
};

export type MasterClassMaxAggregate = {
  __typename?: 'MasterClassMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MasterClassMinAggregate = {
  __typename?: 'MasterClassMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MasterClassNullableScalarRelationFilter = {
  is?: InputMaybe<MasterClassWhereInput>;
  isNot?: InputMaybe<MasterClassWhereInput>;
};

export type MasterClassScalarRelationFilter = {
  is?: InputMaybe<MasterClassWhereInput>;
  isNot?: InputMaybe<MasterClassWhereInput>;
};

export type MasterClassUserSession = {
  __typename?: 'MasterClassUserSession';
  _count: MasterClassUserSessionCount;
  caseId?: Maybe<Scalars['String']['output']>;
  celebrationShown: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  currentCaseId?: Maybe<Scalars['String']['output']>;
  currentSlideId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  masterClassId: Scalars['String']['output'];
  scorePercentage: Scalars['Decimal']['output'];
  userId: Scalars['String']['output'];
  visitedSlideIds: Scalars['JSON']['output'];
};

export type MasterClassUserSessionAvgAggregate = {
  __typename?: 'MasterClassUserSessionAvgAggregate';
  scorePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type MasterClassUserSessionConnection = {
  __typename?: 'MasterClassUserSessionConnection';
  edges: Array<MasterClassUserSessionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterClassUserSessionCount = {
  __typename?: 'MasterClassUserSessionCount';
  answers: Scalars['Int']['output'];
};

export type MasterClassUserSessionCountAggregate = {
  __typename?: 'MasterClassUserSessionCountAggregate';
  _all: Scalars['Int']['output'];
  caseId: Scalars['Int']['output'];
  celebrationShown: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  currentCaseId: Scalars['Int']['output'];
  currentSlideId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  masterClassId: Scalars['Int']['output'];
  scorePercentage: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  visitedSlideIds: Scalars['Int']['output'];
};

export type MasterClassUserSessionEdge = {
  __typename?: 'MasterClassUserSessionEdge';
  cursor: Scalars['String']['output'];
  node: MasterClassUserSession;
};

export type MasterClassUserSessionListRelationFilter = {
  every?: InputMaybe<MasterClassUserSessionWhereInput>;
  none?: InputMaybe<MasterClassUserSessionWhereInput>;
  some?: InputMaybe<MasterClassUserSessionWhereInput>;
};

export type MasterClassUserSessionMasterClassIdUserIdCaseIdCompoundUniqueInput = {
  caseId: Scalars['String']['input'];
  masterClassId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MasterClassUserSessionMaxAggregate = {
  __typename?: 'MasterClassUserSessionMaxAggregate';
  caseId?: Maybe<Scalars['String']['output']>;
  celebrationShown?: Maybe<Scalars['Boolean']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  currentCaseId?: Maybe<Scalars['String']['output']>;
  currentSlideId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterClassId?: Maybe<Scalars['String']['output']>;
  scorePercentage?: Maybe<Scalars['Decimal']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterClassUserSessionMinAggregate = {
  __typename?: 'MasterClassUserSessionMinAggregate';
  caseId?: Maybe<Scalars['String']['output']>;
  celebrationShown?: Maybe<Scalars['Boolean']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  currentCaseId?: Maybe<Scalars['String']['output']>;
  currentSlideId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterClassId?: Maybe<Scalars['String']['output']>;
  scorePercentage?: Maybe<Scalars['Decimal']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterClassUserSessionNullableScalarRelationFilter = {
  is?: InputMaybe<MasterClassUserSessionWhereInput>;
  isNot?: InputMaybe<MasterClassUserSessionWhereInput>;
};

export type MasterClassUserSessionSumAggregate = {
  __typename?: 'MasterClassUserSessionSumAggregate';
  scorePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type MasterClassUserSessionWhereInput = {
  AND?: InputMaybe<Array<MasterClassUserSessionWhereInput>>;
  NOT?: InputMaybe<Array<MasterClassUserSessionWhereInput>>;
  OR?: InputMaybe<Array<MasterClassUserSessionWhereInput>>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  case?: InputMaybe<PatientCaseNullableScalarRelationFilter>;
  caseId?: InputMaybe<StringNullableFilter>;
  celebrationShown?: InputMaybe<BoolFilter>;
  completed?: InputMaybe<BoolFilter>;
  currentCaseId?: InputMaybe<StringNullableFilter>;
  currentSlideId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  masterClass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterClassId?: InputMaybe<StringFilter>;
  scorePercentage?: InputMaybe<DecimalFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  visitedSlideIds?: InputMaybe<JsonFilter>;
};

export type MasterClassUserSessionWhereUniqueInput = {
  AND?: InputMaybe<Array<MasterClassUserSessionWhereInput>>;
  NOT?: InputMaybe<Array<MasterClassUserSessionWhereInput>>;
  OR?: InputMaybe<Array<MasterClassUserSessionWhereInput>>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  case?: InputMaybe<PatientCaseNullableScalarRelationFilter>;
  caseId?: InputMaybe<StringNullableFilter>;
  celebrationShown?: InputMaybe<BoolFilter>;
  completed?: InputMaybe<BoolFilter>;
  currentCaseId?: InputMaybe<StringNullableFilter>;
  currentSlideId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterClass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterClassId?: InputMaybe<StringFilter>;
  masterClassId_userId_caseId?: InputMaybe<MasterClassUserSessionMasterClassIdUserIdCaseIdCompoundUniqueInput>;
  scorePercentage?: InputMaybe<DecimalFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  visitedSlideIds?: InputMaybe<JsonFilter>;
};

export type MasterClassWhereInput = {
  AND?: InputMaybe<Array<MasterClassWhereInput>>;
  NOT?: InputMaybe<Array<MasterClassWhereInput>>;
  OR?: InputMaybe<Array<MasterClassWhereInput>>;
  accessLinks?: InputMaybe<AccessLinkListRelationFilter>;
  certificationProgress?: InputMaybe<CertificationProgressListRelationFilter>;
  clients?: InputMaybe<ClientListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  explicitReadAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  masterClassUserSessions?: InputMaybe<MasterClassUserSessionListRelationFilter>;
  masterclassRatings?: InputMaybe<MasterclassRatingsListRelationFilter>;
  masterclassUserStatistics?: InputMaybe<MasterclassUserStatisticsListRelationFilter>;
  patientCases?: InputMaybe<PatientCaseListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MasterClassWhereUniqueInput = {
  AND?: InputMaybe<Array<MasterClassWhereInput>>;
  NOT?: InputMaybe<Array<MasterClassWhereInput>>;
  OR?: InputMaybe<Array<MasterClassWhereInput>>;
  accessLinks?: InputMaybe<AccessLinkListRelationFilter>;
  certificationProgress?: InputMaybe<CertificationProgressListRelationFilter>;
  clients?: InputMaybe<ClientListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  explicitReadAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterClassUserSessions?: InputMaybe<MasterClassUserSessionListRelationFilter>;
  masterclassRatings?: InputMaybe<MasterclassRatingsListRelationFilter>;
  masterclassUserStatistics?: InputMaybe<MasterclassUserStatisticsListRelationFilter>;
  patientCases?: InputMaybe<PatientCaseListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MasterclassLoginLogs = {
  __typename?: 'MasterclassLoginLogs';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  loggedInAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type MasterclassLoginLogsConnection = {
  __typename?: 'MasterclassLoginLogsConnection';
  edges: Array<MasterclassLoginLogsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterclassLoginLogsCountAggregate = {
  __typename?: 'MasterclassLoginLogsCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  loggedInAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MasterclassLoginLogsEdge = {
  __typename?: 'MasterclassLoginLogsEdge';
  cursor: Scalars['String']['output'];
  node: MasterclassLoginLogs;
};

export type MasterclassLoginLogsListRelationFilter = {
  every?: InputMaybe<MasterclassLoginLogsWhereInput>;
  none?: InputMaybe<MasterclassLoginLogsWhereInput>;
  some?: InputMaybe<MasterclassLoginLogsWhereInput>;
};

export type MasterclassLoginLogsMaxAggregate = {
  __typename?: 'MasterclassLoginLogsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  loggedInAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterclassLoginLogsMinAggregate = {
  __typename?: 'MasterclassLoginLogsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  loggedInAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterclassLoginLogsWhereInput = {
  AND?: InputMaybe<Array<MasterclassLoginLogsWhereInput>>;
  NOT?: InputMaybe<Array<MasterclassLoginLogsWhereInput>>;
  OR?: InputMaybe<Array<MasterclassLoginLogsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  loggedInAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MasterclassLoginLogsWhereUniqueInput = {
  AND?: InputMaybe<Array<MasterclassLoginLogsWhereInput>>;
  NOT?: InputMaybe<Array<MasterclassLoginLogsWhereInput>>;
  OR?: InputMaybe<Array<MasterclassLoginLogsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  loggedInAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MasterclassRatings = {
  __typename?: 'MasterclassRatings';
  applicationRating: Scalars['Int']['output'];
  caseId: Scalars['String']['output'];
  certificationProgressId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  masterclassId: Scalars['String']['output'];
  masterclassRating: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type MasterclassRatingsAvgAggregate = {
  __typename?: 'MasterclassRatingsAvgAggregate';
  applicationRating?: Maybe<Scalars['Float']['output']>;
  masterclassRating?: Maybe<Scalars['Float']['output']>;
};

export type MasterclassRatingsConnection = {
  __typename?: 'MasterclassRatingsConnection';
  edges: Array<MasterclassRatingsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterclassRatingsCountAggregate = {
  __typename?: 'MasterclassRatingsCountAggregate';
  _all: Scalars['Int']['output'];
  applicationRating: Scalars['Int']['output'];
  caseId: Scalars['Int']['output'];
  certificationProgressId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  masterclassId: Scalars['Int']['output'];
  masterclassRating: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MasterclassRatingsEdge = {
  __typename?: 'MasterclassRatingsEdge';
  cursor: Scalars['String']['output'];
  node: MasterclassRatings;
};

export type MasterclassRatingsListRelationFilter = {
  every?: InputMaybe<MasterclassRatingsWhereInput>;
  none?: InputMaybe<MasterclassRatingsWhereInput>;
  some?: InputMaybe<MasterclassRatingsWhereInput>;
};

export type MasterclassRatingsMaxAggregate = {
  __typename?: 'MasterclassRatingsMaxAggregate';
  applicationRating?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  certificationProgressId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterclassId?: Maybe<Scalars['String']['output']>;
  masterclassRating?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterclassRatingsMinAggregate = {
  __typename?: 'MasterclassRatingsMinAggregate';
  applicationRating?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  certificationProgressId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterclassId?: Maybe<Scalars['String']['output']>;
  masterclassRating?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterclassRatingsSumAggregate = {
  __typename?: 'MasterclassRatingsSumAggregate';
  applicationRating?: Maybe<Scalars['Int']['output']>;
  masterclassRating?: Maybe<Scalars['Int']['output']>;
};

export type MasterclassRatingsUserIdMasterclassIdCaseIdCompoundUniqueInput = {
  caseId: Scalars['String']['input'];
  masterclassId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MasterclassRatingsWhereInput = {
  AND?: InputMaybe<Array<MasterclassRatingsWhereInput>>;
  NOT?: InputMaybe<Array<MasterclassRatingsWhereInput>>;
  OR?: InputMaybe<Array<MasterclassRatingsWhereInput>>;
  applicationRating?: InputMaybe<IntFilter>;
  caseId?: InputMaybe<StringFilter>;
  certificationProgress?: InputMaybe<CertificationProgressScalarRelationFilter>;
  certificationProgressId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  masterclass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterclassId?: InputMaybe<StringFilter>;
  masterclassRating?: InputMaybe<IntFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MasterclassRatingsWhereUniqueInput = {
  AND?: InputMaybe<Array<MasterclassRatingsWhereInput>>;
  NOT?: InputMaybe<Array<MasterclassRatingsWhereInput>>;
  OR?: InputMaybe<Array<MasterclassRatingsWhereInput>>;
  applicationRating?: InputMaybe<IntFilter>;
  caseId?: InputMaybe<StringFilter>;
  certificationProgress?: InputMaybe<CertificationProgressScalarRelationFilter>;
  certificationProgressId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterclass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterclassId?: InputMaybe<StringFilter>;
  masterclassRating?: InputMaybe<IntFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_masterclassId_caseId?: InputMaybe<MasterclassRatingsUserIdMasterclassIdCaseIdCompoundUniqueInput>;
};

export type MasterclassUserStatistics = {
  __typename?: 'MasterclassUserStatistics';
  caseClicks: Scalars['Int']['output'];
  caseId: Scalars['String']['output'];
  caseSelectorVisits: Scalars['Int']['output'];
  completions: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  masterclassId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type MasterclassUserStatisticsAvgAggregate = {
  __typename?: 'MasterclassUserStatisticsAvgAggregate';
  caseClicks?: Maybe<Scalars['Float']['output']>;
  caseSelectorVisits?: Maybe<Scalars['Float']['output']>;
  completions?: Maybe<Scalars['Float']['output']>;
};

export type MasterclassUserStatisticsConnection = {
  __typename?: 'MasterclassUserStatisticsConnection';
  edges: Array<MasterclassUserStatisticsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterclassUserStatisticsCountAggregate = {
  __typename?: 'MasterclassUserStatisticsCountAggregate';
  _all: Scalars['Int']['output'];
  caseClicks: Scalars['Int']['output'];
  caseId: Scalars['Int']['output'];
  caseSelectorVisits: Scalars['Int']['output'];
  completions: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  masterclassId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MasterclassUserStatisticsEdge = {
  __typename?: 'MasterclassUserStatisticsEdge';
  cursor: Scalars['String']['output'];
  node: MasterclassUserStatistics;
};

export type MasterclassUserStatisticsListRelationFilter = {
  every?: InputMaybe<MasterclassUserStatisticsWhereInput>;
  none?: InputMaybe<MasterclassUserStatisticsWhereInput>;
  some?: InputMaybe<MasterclassUserStatisticsWhereInput>;
};

export type MasterclassUserStatisticsMaxAggregate = {
  __typename?: 'MasterclassUserStatisticsMaxAggregate';
  caseClicks?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  caseSelectorVisits?: Maybe<Scalars['Int']['output']>;
  completions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterclassId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterclassUserStatisticsMinAggregate = {
  __typename?: 'MasterclassUserStatisticsMinAggregate';
  caseClicks?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  caseSelectorVisits?: Maybe<Scalars['Int']['output']>;
  completions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterclassId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MasterclassUserStatisticsSumAggregate = {
  __typename?: 'MasterclassUserStatisticsSumAggregate';
  caseClicks?: Maybe<Scalars['Int']['output']>;
  caseSelectorVisits?: Maybe<Scalars['Int']['output']>;
  completions?: Maybe<Scalars['Int']['output']>;
};

export type MasterclassUserStatisticsUserIdMasterclassIdCaseIdCompoundUniqueInput = {
  caseId: Scalars['String']['input'];
  masterclassId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MasterclassUserStatisticsWhereInput = {
  AND?: InputMaybe<Array<MasterclassUserStatisticsWhereInput>>;
  NOT?: InputMaybe<Array<MasterclassUserStatisticsWhereInput>>;
  OR?: InputMaybe<Array<MasterclassUserStatisticsWhereInput>>;
  caseClicks?: InputMaybe<IntFilter>;
  caseId?: InputMaybe<StringFilter>;
  caseSelectorVisits?: InputMaybe<IntFilter>;
  completions?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  masterclass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterclassId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MasterclassUserStatisticsWhereUniqueInput = {
  AND?: InputMaybe<Array<MasterclassUserStatisticsWhereInput>>;
  NOT?: InputMaybe<Array<MasterclassUserStatisticsWhereInput>>;
  OR?: InputMaybe<Array<MasterclassUserStatisticsWhereInput>>;
  caseClicks?: InputMaybe<IntFilter>;
  caseId?: InputMaybe<StringFilter>;
  caseSelectorVisits?: InputMaybe<IntFilter>;
  completions?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterclass?: InputMaybe<MasterClassScalarRelationFilter>;
  masterclassId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_masterclassId_caseId?: InputMaybe<MasterclassUserStatisticsUserIdMasterclassIdCaseIdCompoundUniqueInput>;
};

export type Meeting = {
  __typename?: 'Meeting';
  _count: MeetingCount;
  accessLinks: AccessLinkConnection;
  administrativeStatus: MeetingAdministrativeStatus;
  caseCluster: CaseCluster;
  caseClusterId: Scalars['String']['output'];
  clients: ClientConnection;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventDate: Scalars['DateTime']['output'];
  eventLocation: Scalars['String']['output'];
  host: User;
  hostFields: HostFields;
  hostFullName: Scalars['String']['output'];
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDemo: Scalars['Boolean']['output'];
  isInTesting: Scalars['Boolean']['output'];
  isMock: Scalars['Boolean']['output'];
  meetingNotes: Scalars['String']['output'];
  meetingType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  purchaseOrderNbr: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats?: Maybe<MeetingStats>;
  streamUrl?: Maybe<Scalars['String']['output']>;
  teams: TeamConnection;
  updatedAt: Scalars['DateTime']['output'];
  userMeetingJoins: UserMeetingJoinConnection;
};


export type MeetingAccessLinksArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type MeetingClientsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type MeetingTeamsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type MeetingUserMeetingJoinsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export enum MeetingAdministrativeStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export type MeetingConnection = {
  __typename?: 'MeetingConnection';
  edges: Array<MeetingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MeetingCount = {
  __typename?: 'MeetingCount';
  accessLinks: Scalars['Int']['output'];
  answers: Scalars['Int']['output'];
  assetViews: Scalars['Int']['output'];
  clients: Scalars['Int']['output'];
  explicitMeetingReadAccess: Scalars['Int']['output'];
  messages: Scalars['Int']['output'];
  npsScores: Scalars['Int']['output'];
  slideStats: Scalars['Int']['output'];
  teams: Scalars['Int']['output'];
  userMeetingJoins: Scalars['Int']['output'];
};

export type MeetingCountAggregate = {
  __typename?: 'MeetingCountAggregate';
  _all: Scalars['Int']['output'];
  administrativeStatus: Scalars['Int']['output'];
  caseClusterId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdById: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  eventDate: Scalars['Int']['output'];
  eventLocation: Scalars['Int']['output'];
  hostFullName: Scalars['Int']['output'];
  hostId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Int']['output'];
  isDemo: Scalars['Int']['output'];
  isInTesting: Scalars['Int']['output'];
  isMock: Scalars['Int']['output'];
  meetingNotes: Scalars['Int']['output'];
  meetingType: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  purchaseOrderNbr: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  streamUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MeetingEdge = {
  __typename?: 'MeetingEdge';
  cursor: Scalars['String']['output'];
  node: Meeting;
};

export type MeetingListRelationFilter = {
  every?: InputMaybe<MeetingWhereInput>;
  none?: InputMaybe<MeetingWhereInput>;
  some?: InputMaybe<MeetingWhereInput>;
};

export type MeetingMaxAggregate = {
  __typename?: 'MeetingMaxAggregate';
  administrativeStatus?: Maybe<MeetingAdministrativeStatus>;
  caseClusterId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  eventLocation?: Maybe<Scalars['String']['output']>;
  hostFullName?: Maybe<Scalars['String']['output']>;
  hostId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  isInTesting?: Maybe<Scalars['Boolean']['output']>;
  isMock?: Maybe<Scalars['Boolean']['output']>;
  meetingNotes?: Maybe<Scalars['String']['output']>;
  meetingType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchaseOrderNbr?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  streamUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeetingMinAggregate = {
  __typename?: 'MeetingMinAggregate';
  administrativeStatus?: Maybe<MeetingAdministrativeStatus>;
  caseClusterId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  eventLocation?: Maybe<Scalars['String']['output']>;
  hostFullName?: Maybe<Scalars['String']['output']>;
  hostId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  isInTesting?: Maybe<Scalars['Boolean']['output']>;
  isMock?: Maybe<Scalars['Boolean']['output']>;
  meetingNotes?: Maybe<Scalars['String']['output']>;
  meetingType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchaseOrderNbr?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  streamUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeetingNullableScalarRelationFilter = {
  is?: InputMaybe<MeetingWhereInput>;
  isNot?: InputMaybe<MeetingWhereInput>;
};

export type MeetingParticipantsChangePacket = {
  __typename?: 'MeetingParticipantsChangePacket';
  type: MeetingParticipantsChangeType;
  user: User;
};

export enum MeetingParticipantsChangeType {
  Joined = 'JOINED',
  Left = 'LEFT'
}

export type MeetingScalarRelationFilter = {
  is?: InputMaybe<MeetingWhereInput>;
  isNot?: InputMaybe<MeetingWhereInput>;
};

export type MeetingStats = {
  __typename?: 'MeetingStats';
  amountParticipants: Scalars['Int']['output'];
  casePresentationHistory?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MeetingStatsAvgAggregate = {
  __typename?: 'MeetingStatsAvgAggregate';
  amountParticipants?: Maybe<Scalars['Float']['output']>;
};

export type MeetingStatsCountAggregate = {
  __typename?: 'MeetingStatsCountAggregate';
  _all: Scalars['Int']['output'];
  amountParticipants: Scalars['Int']['output'];
  casePresentationHistory: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MeetingStatsEdge = {
  __typename?: 'MeetingStatsEdge';
  cursor: Scalars['String']['output'];
  node: MeetingStats;
};

export type MeetingStatsMaxAggregate = {
  __typename?: 'MeetingStatsMaxAggregate';
  amountParticipants?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeetingStatsMinAggregate = {
  __typename?: 'MeetingStatsMinAggregate';
  amountParticipants?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeetingStatsNullableScalarRelationFilter = {
  is?: InputMaybe<MeetingStatsWhereInput>;
  isNot?: InputMaybe<MeetingStatsWhereInput>;
};

export type MeetingStatsSumAggregate = {
  __typename?: 'MeetingStatsSumAggregate';
  amountParticipants?: Maybe<Scalars['Int']['output']>;
};

export type MeetingStatsUpdatecasePresentationHistoryInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MeetingStatsWhereInput = {
  AND?: InputMaybe<Array<MeetingStatsWhereInput>>;
  NOT?: InputMaybe<Array<MeetingStatsWhereInput>>;
  OR?: InputMaybe<Array<MeetingStatsWhereInput>>;
  amountParticipants?: InputMaybe<IntFilter>;
  casePresentationHistory?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MeetingStatsWhereUniqueInput = {
  AND?: InputMaybe<Array<MeetingStatsWhereInput>>;
  NOT?: InputMaybe<Array<MeetingStatsWhereInput>>;
  OR?: InputMaybe<Array<MeetingStatsWhereInput>>;
  amountParticipants?: InputMaybe<IntFilter>;
  casePresentationHistory?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MeetingWhereInput = {
  AND?: InputMaybe<Array<MeetingWhereInput>>;
  NOT?: InputMaybe<Array<MeetingWhereInput>>;
  OR?: InputMaybe<Array<MeetingWhereInput>>;
  accessLinks?: InputMaybe<AccessLinkListRelationFilter>;
  administrativeStatus?: InputMaybe<EnumMeetingAdministrativeStatusFilter>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  assetViews?: InputMaybe<AssetViewListRelationFilter>;
  caseCluster?: InputMaybe<CaseClusterScalarRelationFilter>;
  caseClusterId?: InputMaybe<StringFilter>;
  clients?: InputMaybe<ClientListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  eventDate?: InputMaybe<DateTimeFilter>;
  eventLocation?: InputMaybe<StringFilter>;
  explicitMeetingReadAccess?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  host?: InputMaybe<UserScalarRelationFilter>;
  hostFields?: InputMaybe<HostFieldsNullableScalarRelationFilter>;
  hostFullName?: InputMaybe<StringFilter>;
  hostId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isDemo?: InputMaybe<BoolFilter>;
  isInTesting?: InputMaybe<BoolFilter>;
  isMock?: InputMaybe<BoolFilter>;
  meetingNotes?: InputMaybe<StringFilter>;
  meetingType?: InputMaybe<StringFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  npsScores?: InputMaybe<NpsScoreListRelationFilter>;
  purchaseOrderNbr?: InputMaybe<StringFilter>;
  slideStats?: InputMaybe<SlideStatsListRelationFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  stats?: InputMaybe<MeetingStatsNullableScalarRelationFilter>;
  streamUrl?: InputMaybe<StringNullableFilter>;
  teams?: InputMaybe<TeamListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userMeetingJoins?: InputMaybe<UserMeetingJoinListRelationFilter>;
};

export type MeetingWhereUniqueInput = {
  AND?: InputMaybe<Array<MeetingWhereInput>>;
  NOT?: InputMaybe<Array<MeetingWhereInput>>;
  OR?: InputMaybe<Array<MeetingWhereInput>>;
  accessLinks?: InputMaybe<AccessLinkListRelationFilter>;
  administrativeStatus?: InputMaybe<EnumMeetingAdministrativeStatusFilter>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  assetViews?: InputMaybe<AssetViewListRelationFilter>;
  caseCluster?: InputMaybe<CaseClusterScalarRelationFilter>;
  caseClusterId?: InputMaybe<StringFilter>;
  clients?: InputMaybe<ClientListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  eventDate?: InputMaybe<DateTimeFilter>;
  eventLocation?: InputMaybe<StringFilter>;
  explicitMeetingReadAccess?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  host?: InputMaybe<UserScalarRelationFilter>;
  hostFields?: InputMaybe<HostFieldsNullableScalarRelationFilter>;
  hostFullName?: InputMaybe<StringFilter>;
  hostId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<BoolFilter>;
  isDemo?: InputMaybe<BoolFilter>;
  isInTesting?: InputMaybe<BoolFilter>;
  isMock?: InputMaybe<BoolFilter>;
  meetingNotes?: InputMaybe<StringFilter>;
  meetingType?: InputMaybe<StringFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  npsScores?: InputMaybe<NpsScoreListRelationFilter>;
  purchaseOrderNbr?: InputMaybe<StringFilter>;
  slideStats?: InputMaybe<SlideStatsListRelationFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  stats?: InputMaybe<MeetingStatsNullableScalarRelationFilter>;
  streamUrl?: InputMaybe<StringNullableFilter>;
  teams?: InputMaybe<TeamListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userMeetingJoins?: InputMaybe<UserMeetingJoinListRelationFilter>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageCountAggregate = {
  __typename?: 'MessageCountAggregate';
  _all: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type MessageListRelationFilter = {
  every?: InputMaybe<MessageWhereInput>;
  none?: InputMaybe<MessageWhereInput>;
  some?: InputMaybe<MessageWhereInput>;
};

export type MessageMaxAggregate = {
  __typename?: 'MessageMaxAggregate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MessageMinAggregate = {
  __typename?: 'MessageMinAggregate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserToClient: Client;
  addUserToTeam: Team;
  approveMeeting: Meeting;
  batchCreateAccessLinks: Array<AccessLink>;
  batchUpdateAccessLinks: Array<AccessLink>;
  cancelMeeting: Scalars['Boolean']['output'];
  createAccessLink: AccessLink;
  createAnswer: Answer;
  createAssetView: AssetView;
  createCaseCluster: CaseCluster;
  createClient: Client;
  createExplicitUserAccess: ExplicitUserAccess;
  createMasterClass: MasterClass;
  createMasterClassUserSession: MasterClassUserSession;
  createMasterclassLoginLogs: MasterclassLoginLogs;
  createMasterclassRatings: MasterclassRatings;
  createMeeting: Meeting;
  createMessage: Message;
  createNPSScore: NpsScore;
  createOrUpdateAnswer: Answer;
  createOrUpdateSlideStats: SlideStats;
  createRegistrationLink: AccessLink;
  createTeam: Team;
  createUser: CreateUserResult;
  deleteAccessLink: AccessLink;
  deleteCaseCluster: CaseCluster;
  deleteCertificationProgress: CertificationProgress;
  deleteClient: Client;
  deleteExplicitUserAccess: ExplicitUserAccess;
  deleteMasterClass: MasterClass;
  deleteMasterclassLoginLogs: MasterclassLoginLogs;
  deleteMasterclassRatings: MasterclassRatings;
  deleteMeeting: Meeting;
  deleteMessages: Array<Message>;
  deleteTeam: Team;
  joinMeetingParticipants: LiveMeetingParticipants;
  leaveMeetingParticipants?: Maybe<LiveMeetingParticipants>;
  meetingParticipantsHeartbeat: Scalars['Boolean']['output'];
  refreshPatientCases: Scalars['Boolean']['output'];
  removeUserFromClient: Client;
  removeUserFromTeam: Team;
  requestReadAccess: AccessLink;
  resetCaseProgress?: Maybe<MasterClassUserSession>;
  resetMeeting: Scalars['Boolean']['output'];
  setClientRole: User;
  setTechnicalManager: Team;
  updateAnswer: Answer;
  updateCaseCluster: CaseCluster;
  updateHostFields: HostFields;
  updateMasterClass: MasterClass;
  updateMasterClassUserSession: MasterClassUserSession;
  updateMasterclassUserStatistics: MasterclassUserStatistics;
  updateMeeting: Meeting;
  updateMeetingStats: MeetingStats;
  updateTeam: Team;
  upsertCertificationProgress: CertificationProgress;
};


export type MutationAddUserToClientArgs = {
  data: ChangeUserToClientInputDto;
};


export type MutationAddUserToTeamArgs = {
  data: ChangeUserToTeamInputDto;
};


export type MutationApproveMeetingArgs = {
  data: ApproveMeetingInputDto;
};


export type MutationBatchCreateAccessLinksArgs = {
  data: BatchCreateAccessLinksInputDto;
};


export type MutationBatchUpdateAccessLinksArgs = {
  data: BatchUpdateReadAccessLinksInputDto;
};


export type MutationCancelMeetingArgs = {
  where: MeetingWhereUniqueInput;
};


export type MutationCreateAccessLinkArgs = {
  data: CreateReadAccessLinkInputDto;
};


export type MutationCreateAnswerArgs = {
  data: CreateAnswerInputDto;
};


export type MutationCreateAssetViewArgs = {
  data: CreateAssetViewInputDto;
};


export type MutationCreateCaseClusterArgs = {
  data: CreateCaseClusterInputDto;
};


export type MutationCreateClientArgs = {
  data: CreateClientInputDto;
};


export type MutationCreateExplicitUserAccessArgs = {
  data: CreateExplicitUserAccessInputDto;
};


export type MutationCreateMasterClassArgs = {
  data: CreateMasterClassInputDto;
};


export type MutationCreateMasterClassUserSessionArgs = {
  data: CreateMasterClassUserSessionInputDto;
};


export type MutationCreateMasterclassRatingsArgs = {
  data: CreateMasterclassRatingsInputDto;
};


export type MutationCreateMeetingArgs = {
  data: CreateMeetingInputDto;
};


export type MutationCreateMessageArgs = {
  data: CreateMessageInputDto;
};


export type MutationCreateNpsScoreArgs = {
  data: CreateNpsScoreInputDto;
};


export type MutationCreateOrUpdateAnswerArgs = {
  data: CreateOrUpdateAnswerInputDto;
};


export type MutationCreateOrUpdateSlideStatsArgs = {
  data: CreateOrUpdateSlideStatsDto;
};


export type MutationCreateRegistrationLinkArgs = {
  data: CreateRegistrationLinkInputDto;
};


export type MutationCreateTeamArgs = {
  data: CreateTeamInputDto;
};


export type MutationCreateUserArgs = {
  data: CreateUserInputDto;
};


export type MutationDeleteAccessLinkArgs = {
  where: AccessLinkWhereUniqueInput;
};


export type MutationDeleteCaseClusterArgs = {
  where: CaseClusterWhereUniqueInput;
};


export type MutationDeleteCertificationProgressArgs = {
  where: CertificationProgressWhereUniqueInput;
};


export type MutationDeleteClientArgs = {
  where: ClientWhereUniqueInput;
};


export type MutationDeleteExplicitUserAccessArgs = {
  where: ExplicitUserAccessWhereUniqueInput;
};


export type MutationDeleteMasterClassArgs = {
  where: MasterClassWhereUniqueInput;
};


export type MutationDeleteMasterclassLoginLogsArgs = {
  where: MasterclassLoginLogsWhereUniqueInput;
};


export type MutationDeleteMasterclassRatingsArgs = {
  where: MasterclassRatingsWhereUniqueInput;
};


export type MutationDeleteMeetingArgs = {
  where: MeetingWhereUniqueInput;
};


export type MutationDeleteMessagesArgs = {
  where: MessageWhereInput;
};


export type MutationDeleteTeamArgs = {
  where: TeamWhereUniqueInput;
};


export type MutationJoinMeetingParticipantsArgs = {
  meetingId: Scalars['String']['input'];
};


export type MutationLeaveMeetingParticipantsArgs = {
  meetingId: Scalars['String']['input'];
};


export type MutationMeetingParticipantsHeartbeatArgs = {
  meetingId: Scalars['String']['input'];
};


export type MutationRemoveUserFromClientArgs = {
  data: ChangeUserToClientInputDto;
};


export type MutationRemoveUserFromTeamArgs = {
  data: ChangeUserToTeamInputDto;
};


export type MutationRequestReadAccessArgs = {
  data: RequestAccessInputDto;
};


export type MutationResetCaseProgressArgs = {
  data: ResetCaseProgressInputDto;
};


export type MutationResetMeetingArgs = {
  data: ResetMeetingInputDto;
  where: MeetingWhereUniqueInput;
};


export type MutationSetClientRoleArgs = {
  data: SetClientRoleInputDto;
};


export type MutationSetTechnicalManagerArgs = {
  data: SetTechnicalManagerInputDto;
};


export type MutationUpdateAnswerArgs = {
  data: UpdateAnswerInputDto;
};


export type MutationUpdateCaseClusterArgs = {
  data: UpdateCaseClusterInputDto;
};


export type MutationUpdateHostFieldsArgs = {
  data: UpdateHostFieldsInputDto;
};


export type MutationUpdateMasterClassArgs = {
  data: UpdateMasterClassInputDto;
};


export type MutationUpdateMasterClassUserSessionArgs = {
  data: UpdateMasterClassUserSessionInputDto;
};


export type MutationUpdateMasterclassUserStatisticsArgs = {
  data: UpdateMasterclassUserStatisticsInputDto;
};


export type MutationUpdateMeetingArgs = {
  data: UpdateMeetingInputDto;
};


export type MutationUpdateMeetingStatsArgs = {
  data: UpdateMeetingStatsInputDto;
};


export type MutationUpdateTeamArgs = {
  data: UpdateTeamInputDto;
};


export type MutationUpsertCertificationProgressArgs = {
  data: UpsertCertificationProgressInputDto;
};

export type MySessionStats = {
  __typename?: 'MySessionStats';
  completedCasesCount: Scalars['Int']['output'];
  hasStartedAny: Scalars['Boolean']['output'];
  isFullyCompleted: Scalars['Boolean']['output'];
  startedCasesCount: Scalars['Int']['output'];
  totalCases: Scalars['Int']['output'];
};

export type NpsScore = {
  __typename?: 'NPSScore';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  scores?: Maybe<Array<Scalars['Int']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type NpsScoreAvgAggregate = {
  __typename?: 'NPSScoreAvgAggregate';
  scores?: Maybe<Scalars['Float']['output']>;
};

export type NpsScoreConnection = {
  __typename?: 'NPSScoreConnection';
  edges: Array<NpsScoreEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NpsScoreCountAggregate = {
  __typename?: 'NPSScoreCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  scores: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type NpsScoreEdge = {
  __typename?: 'NPSScoreEdge';
  cursor: Scalars['String']['output'];
  node: NpsScore;
};

export type NpsScoreListRelationFilter = {
  every?: InputMaybe<NpsScoreWhereInput>;
  none?: InputMaybe<NpsScoreWhereInput>;
  some?: InputMaybe<NpsScoreWhereInput>;
};

export type NpsScoreMaxAggregate = {
  __typename?: 'NPSScoreMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NpsScoreMinAggregate = {
  __typename?: 'NPSScoreMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NpsScoreSumAggregate = {
  __typename?: 'NPSScoreSumAggregate';
  scores?: Maybe<Array<Scalars['Int']['output']>>;
};

export type NpsScoreUserIdMeetingIdCompoundUniqueInput = {
  meetingId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type NpsScoreWhereInput = {
  AND?: InputMaybe<Array<NpsScoreWhereInput>>;
  NOT?: InputMaybe<Array<NpsScoreWhereInput>>;
  OR?: InputMaybe<Array<NpsScoreWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  scores?: InputMaybe<IntNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type NpsScoreWhereUniqueInput = {
  AND?: InputMaybe<Array<NpsScoreWhereInput>>;
  NOT?: InputMaybe<Array<NpsScoreWhereInput>>;
  OR?: InputMaybe<Array<NpsScoreWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  scores?: InputMaybe<IntNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_meetingId?: InputMaybe<NpsScoreUserIdMeetingIdCompoundUniqueInput>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumMeetingAdministrativeStatusFilter = {
  equals?: InputMaybe<MeetingAdministrativeStatus>;
  in?: InputMaybe<Array<MeetingAdministrativeStatus>>;
  not?: InputMaybe<NestedEnumMeetingAdministrativeStatusFilter>;
  notIn?: InputMaybe<Array<MeetingAdministrativeStatus>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type OrderByArgs = {
  direction: Scalars['String']['input'];
  orderByField: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientCase = {
  __typename?: 'PatientCase';
  _count: PatientCaseCount;
  caseClusters: CaseClusterConnection;
  client?: Maybe<Client>;
  clientName?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMasterClass: Scalars['Boolean']['output'];
  lastFetchedAt: Scalars['DateTime']['output'];
  legacyCaseId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  purchaseOrderNbr?: Maybe<Scalars['String']['output']>;
  stringifiedContent: Scalars['String']['output'];
};


export type PatientCaseCaseClustersArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type PatientCaseConnection = {
  __typename?: 'PatientCaseConnection';
  edges: Array<PatientCaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientCaseCount = {
  __typename?: 'PatientCaseCount';
  accessLinks: Scalars['Int']['output'];
  answers: Scalars['Int']['output'];
  assetViews: Scalars['Int']['output'];
  caseClusters: Scalars['Int']['output'];
  explicitUserAccesses: Scalars['Int']['output'];
  masterClassUserSessions: Scalars['Int']['output'];
  masterclasses: Scalars['Int']['output'];
  slideStats: Scalars['Int']['output'];
};

export type PatientCaseCountAggregate = {
  __typename?: 'PatientCaseCountAggregate';
  _all: Scalars['Int']['output'];
  clientName: Scalars['Int']['output'];
  creationDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isMasterClass: Scalars['Int']['output'];
  lastFetchedAt: Scalars['Int']['output'];
  legacyCaseId: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  purchaseOrderNbr: Scalars['Int']['output'];
  stringifiedContent: Scalars['Int']['output'];
};

export type PatientCaseEdge = {
  __typename?: 'PatientCaseEdge';
  cursor: Scalars['String']['output'];
  node: PatientCase;
};

export type PatientCaseFilter = {
  patientCaseId: Scalars['String']['input'];
};

export type PatientCaseListRelationFilter = {
  every?: InputMaybe<PatientCaseWhereInput>;
  none?: InputMaybe<PatientCaseWhereInput>;
  some?: InputMaybe<PatientCaseWhereInput>;
};

export type PatientCaseMaxAggregate = {
  __typename?: 'PatientCaseMaxAggregate';
  clientName?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMasterClass?: Maybe<Scalars['Boolean']['output']>;
  lastFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  legacyCaseId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchaseOrderNbr?: Maybe<Scalars['String']['output']>;
  stringifiedContent?: Maybe<Scalars['String']['output']>;
};

export type PatientCaseMinAggregate = {
  __typename?: 'PatientCaseMinAggregate';
  clientName?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isMasterClass?: Maybe<Scalars['Boolean']['output']>;
  lastFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  legacyCaseId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchaseOrderNbr?: Maybe<Scalars['String']['output']>;
  stringifiedContent?: Maybe<Scalars['String']['output']>;
};

export type PatientCaseNullableScalarRelationFilter = {
  is?: InputMaybe<PatientCaseWhereInput>;
  isNot?: InputMaybe<PatientCaseWhereInput>;
};

export type PatientCaseScalarRelationFilter = {
  is?: InputMaybe<PatientCaseWhereInput>;
  isNot?: InputMaybe<PatientCaseWhereInput>;
};

export type PatientCaseWhereInput = {
  AND?: InputMaybe<Array<PatientCaseWhereInput>>;
  NOT?: InputMaybe<Array<PatientCaseWhereInput>>;
  OR?: InputMaybe<Array<PatientCaseWhereInput>>;
  accessLinks?: InputMaybe<AccessLinkListRelationFilter>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  assetViews?: InputMaybe<AssetViewListRelationFilter>;
  caseClusters?: InputMaybe<CaseClusterListRelationFilter>;
  client?: InputMaybe<ClientNullableScalarRelationFilter>;
  clientName?: InputMaybe<StringNullableFilter>;
  creationDate?: InputMaybe<DateTimeFilter>;
  explicitUserAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isMasterClass?: InputMaybe<BoolFilter>;
  lastFetchedAt?: InputMaybe<DateTimeFilter>;
  legacyCaseId?: InputMaybe<StringFilter>;
  masterClassUserSessions?: InputMaybe<MasterClassUserSessionListRelationFilter>;
  masterclasses?: InputMaybe<MasterClassListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  purchaseOrderNbr?: InputMaybe<StringNullableFilter>;
  slideStats?: InputMaybe<SlideStatsListRelationFilter>;
  stringifiedContent?: InputMaybe<StringFilter>;
};

export type Query = {
  __typename?: 'Query';
  getAvailableDates: Array<DateAvailability>;
  getCaseCluster?: Maybe<CaseCluster>;
  getCaseStatsAggregation: CaseStatsAggregation;
  getCertificationProgress?: Maybe<CertificationProgress>;
  getCertificationQuestions: CertificationData;
  getClickupLiveEventTasks: Scalars['JSON']['output'];
  getClient?: Maybe<Client>;
  getHostFields?: Maybe<HostFields>;
  getMasterClass?: Maybe<MasterClass>;
  getMasterClassUserSession?: Maybe<MasterClassUserSession>;
  getMasterclassLoginLogs?: Maybe<MasterclassLoginLogs>;
  getMasterclassRatings?: Maybe<MasterclassRatings>;
  getMasterclassUserStatistics?: Maybe<MasterclassUserStatistics>;
  getMeeting?: Maybe<Meeting>;
  getMeetingStats?: Maybe<MeetingStats>;
  getNPSScore?: Maybe<NpsScore>;
  getPatientCase: PatientCase;
  getSlideStats?: Maybe<SlideStats>;
  getTeam?: Maybe<Team>;
  getUser?: Maybe<User>;
  isValidAccessLink?: Maybe<AccessLink>;
  listAccessLinks: AccessLinkConnection;
  listAnswers: AnswerConnection;
  listAssetViews: AssetViewConnection;
  listCaseClusters: CaseClusterConnection;
  listCertificationProgress: CertificationProgressConnection;
  listClients: ClientConnection;
  listExplicitUserAccesses: ExplicitUserAccessConnection;
  listMasterClasses: MasterClassConnection;
  listMasterclassLoginLogs: MasterclassLoginLogsConnection;
  listMasterclassRatings: MasterclassRatingsConnection;
  listMasterclassUserStatistics: MasterclassUserStatisticsConnection;
  listMeetingLiveParticipants: LiveMeetingParticipants;
  listMeetings: MeetingConnection;
  listMessages: MessageConnection;
  listNPSScores: NpsScoreConnection;
  listPatientCases: PatientCaseConnection;
  listSlideStats: SlideStatsConnection;
  listTeams: TeamConnection;
  listUserMeetingJoins: UserMeetingJoinConnection;
  listUsers: UserConnection;
  me: User;
};


export type QueryGetAvailableDatesArgs = {
  data: GetAvailableDatesInputDto;
};


export type QueryGetCaseClusterArgs = {
  where: CaseClusterWhereUniqueInput;
};


export type QueryGetCaseStatsAggregationArgs = {
  caseId: Scalars['String']['input'];
  masterclassId: Scalars['String']['input'];
};


export type QueryGetCertificationProgressArgs = {
  where: CertificationProgressWhereUniqueInput;
};


export type QueryGetCertificationQuestionsArgs = {
  input: PatientCaseFilter;
};


export type QueryGetClientArgs = {
  where: ClientWhereUniqueInput;
};


export type QueryGetHostFieldsArgs = {
  where: HostFieldsWhereUniqueInput;
};


export type QueryGetMasterClassArgs = {
  where: MasterClassWhereUniqueInput;
};


export type QueryGetMasterClassUserSessionArgs = {
  where: MasterClassUserSessionWhereUniqueInput;
};


export type QueryGetMasterclassLoginLogsArgs = {
  where: MasterclassLoginLogsWhereUniqueInput;
};


export type QueryGetMasterclassRatingsArgs = {
  where: MasterclassRatingsWhereUniqueInput;
};


export type QueryGetMasterclassUserStatisticsArgs = {
  where: MasterclassUserStatisticsWhereUniqueInput;
};


export type QueryGetMeetingArgs = {
  where: MeetingWhereUniqueInput;
};


export type QueryGetMeetingStatsArgs = {
  where: MeetingStatsWhereUniqueInput;
};


export type QueryGetNpsScoreArgs = {
  where: NpsScoreWhereUniqueInput;
};


export type QueryGetPatientCaseArgs = {
  input: PatientCaseFilter;
};


export type QueryGetSlideStatsArgs = {
  where: SlideStatsWhereUniqueInput;
};


export type QueryGetTeamArgs = {
  where: TeamWhereUniqueInput;
};


export type QueryGetUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryIsValidAccessLinkArgs = {
  code: Scalars['String']['input'];
};


export type QueryListAccessLinksArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<AccessLinkWhereInput>;
};


export type QueryListAnswersArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<AnswerWhereInput>;
};


export type QueryListAssetViewsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<AssetViewWhereInput>;
};


export type QueryListCaseClustersArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<CaseClusterWhereInput>;
};


export type QueryListCertificationProgressArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<CertificationProgressWhereInput>;
};


export type QueryListClientsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<ClientWhereInput>;
};


export type QueryListExplicitUserAccessesArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<ExplicitUserAccessWhereInput>;
};


export type QueryListMasterClassesArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<MasterClassWhereInput>;
};


export type QueryListMasterclassLoginLogsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<MasterclassLoginLogsWhereInput>;
};


export type QueryListMasterclassRatingsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<MasterclassRatingsWhereInput>;
};


export type QueryListMasterclassUserStatisticsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<MasterclassUserStatisticsWhereInput>;
};


export type QueryListMeetingLiveParticipantsArgs = {
  meetingId: Scalars['String']['input'];
};


export type QueryListMeetingsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<MeetingWhereInput>;
};


export type QueryListMessagesArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<MessageWhereInput>;
};


export type QueryListNpsScoresArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<NpsScoreWhereInput>;
};


export type QueryListPatientCasesArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<PatientCaseWhereInput>;
};


export type QueryListSlideStatsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<SlideStatsWhereInput>;
};


export type QueryListTeamsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryListUserMeetingJoinsArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<UserMeetingJoinWhereInput>;
};


export type QueryListUsersArgs = {
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<UserWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RequestAccessInputDto = {
  code: Scalars['String']['input'];
};

export type ResetCaseProgressInputDto = {
  caseId: Scalars['String']['input'];
  masterClassId: Scalars['String']['input'];
};

export type ResetMeetingInputDto = {
  setStartDate: Scalars['Boolean']['input'];
};

export type SetClientRoleInputDto = {
  clientId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SetTechnicalManagerInputDto = {
  teamId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SlideStats = {
  __typename?: 'SlideStats';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  patientCaseId: Scalars['String']['output'];
  slideId: Scalars['String']['output'];
  time: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SlideStatsAvgAggregate = {
  __typename?: 'SlideStatsAvgAggregate';
  time?: Maybe<Scalars['Float']['output']>;
};

export type SlideStatsConnection = {
  __typename?: 'SlideStatsConnection';
  edges: Array<SlideStatsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SlideStatsCountAggregate = {
  __typename?: 'SlideStatsCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  patientCaseId: Scalars['Int']['output'];
  slideId: Scalars['Int']['output'];
  time: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SlideStatsEdge = {
  __typename?: 'SlideStatsEdge';
  cursor: Scalars['String']['output'];
  node: SlideStats;
};

export type SlideStatsListRelationFilter = {
  every?: InputMaybe<SlideStatsWhereInput>;
  none?: InputMaybe<SlideStatsWhereInput>;
  some?: InputMaybe<SlideStatsWhereInput>;
};

export type SlideStatsMaxAggregate = {
  __typename?: 'SlideStatsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  slideId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SlideStatsMinAggregate = {
  __typename?: 'SlideStatsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  patientCaseId?: Maybe<Scalars['String']['output']>;
  slideId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SlideStatsPatientCaseIdSlideIdMeetingIdCompoundUniqueInput = {
  meetingId: Scalars['String']['input'];
  patientCaseId: Scalars['String']['input'];
  slideId: Scalars['String']['input'];
};

export type SlideStatsSumAggregate = {
  __typename?: 'SlideStatsSumAggregate';
  time?: Maybe<Scalars['Int']['output']>;
};

export type SlideStatsWhereInput = {
  AND?: InputMaybe<Array<SlideStatsWhereInput>>;
  NOT?: InputMaybe<Array<SlideStatsWhereInput>>;
  OR?: InputMaybe<Array<SlideStatsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  patientCase?: InputMaybe<PatientCaseScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringFilter>;
  slideId?: InputMaybe<StringFilter>;
  time?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SlideStatsWhereUniqueInput = {
  AND?: InputMaybe<Array<SlideStatsWhereInput>>;
  NOT?: InputMaybe<Array<SlideStatsWhereInput>>;
  OR?: InputMaybe<Array<SlideStatsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  patientCase?: InputMaybe<PatientCaseScalarRelationFilter>;
  patientCaseId?: InputMaybe<StringFilter>;
  patientCaseId_slideId_meetingId?: InputMaybe<SlideStatsPatientCaseIdSlideIdMeetingIdCompoundUniqueInput>;
  slideId?: InputMaybe<StringFilter>;
  time?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateAccessLink: AccessLink;
  onCreateAnswer: Answer;
  onCreateAssetView: AssetView;
  onCreateCaseCluster: CaseCluster;
  onCreateCertificationProgress: CertificationProgress;
  onCreateClient: Client;
  onCreateExplicitUserAccess: ExplicitUserAccess;
  onCreateHostFields: HostFields;
  onCreateMasterClass: MasterClass;
  onCreateMasterClassUserSession: MasterClassUserSession;
  onCreateMasterclassLoginLogs: MasterclassLoginLogs;
  onCreateMasterclassRatings: MasterclassRatings;
  onCreateMasterclassUserStatistics: MasterclassUserStatistics;
  onCreateMeeting: Meeting;
  onCreateMeetingStats: MeetingStats;
  onCreateMessage: Message;
  onCreateNPSScore: NpsScore;
  onCreateSlideStats: SlideStats;
  onCreateTeam: Team;
  onCreateUser: User;
  onCreateUserMeetingJoin: UserMeetingJoin;
  onDeleteAccessLink: AccessLink;
  onDeleteAnswer: Answer;
  onDeleteAssetView: AssetView;
  onDeleteCaseCluster: CaseCluster;
  onDeleteCertificationProgress: CertificationProgress;
  onDeleteClient: Client;
  onDeleteExplicitUserAccess: ExplicitUserAccess;
  onDeleteHostFields: HostFields;
  onDeleteMasterClass: MasterClass;
  onDeleteMasterClassUserSession: MasterClassUserSession;
  onDeleteMasterclassLoginLogs: MasterclassLoginLogs;
  onDeleteMasterclassRatings: MasterclassRatings;
  onDeleteMasterclassUserStatistics: MasterclassUserStatistics;
  onDeleteMeeting: Meeting;
  onDeleteMeetingStats: MeetingStats;
  onDeleteMessage: Message;
  onDeleteNPSScore: NpsScore;
  onDeleteSlideStats: SlideStats;
  onDeleteTeam: Team;
  onDeleteUser: User;
  onDeleteUserMeetingJoin: UserMeetingJoin;
  onMeetingLiveParticipantsChange: MeetingParticipantsChangePacket;
  onUpdateAccessLink: AccessLink;
  onUpdateAnswer: Answer;
  onUpdateAssetView: AssetView;
  onUpdateCaseCluster: CaseCluster;
  onUpdateCertificationProgress: CertificationProgress;
  onUpdateClient: Client;
  onUpdateExplicitUserAccess: ExplicitUserAccess;
  onUpdateHostFields: HostFields;
  onUpdateMasterClass: MasterClass;
  onUpdateMasterClassUserSession: MasterClassUserSession;
  onUpdateMasterclassLoginLogs: MasterclassLoginLogs;
  onUpdateMasterclassRatings: MasterclassRatings;
  onUpdateMasterclassUserStatistics: MasterclassUserStatistics;
  onUpdateMeeting: Meeting;
  onUpdateMeetingStats: MeetingStats;
  onUpdateMessage: Message;
  onUpdateNPSScore: NpsScore;
  onUpdateSlideStats: SlideStats;
  onUpdateTeam: Team;
  onUpdateUser: User;
  onUpdateUserMeetingJoin: UserMeetingJoin;
};


export type SubscriptionOnCreateAccessLinkArgs = {
  where?: InputMaybe<AccessLinkWhereInput>;
};


export type SubscriptionOnCreateAnswerArgs = {
  where?: InputMaybe<AnswerWhereInput>;
};


export type SubscriptionOnCreateAssetViewArgs = {
  where?: InputMaybe<AssetViewWhereInput>;
};


export type SubscriptionOnCreateCaseClusterArgs = {
  where?: InputMaybe<CaseClusterWhereInput>;
};


export type SubscriptionOnCreateCertificationProgressArgs = {
  where?: InputMaybe<CertificationProgressWhereInput>;
};


export type SubscriptionOnCreateClientArgs = {
  where?: InputMaybe<ClientWhereInput>;
};


export type SubscriptionOnCreateExplicitUserAccessArgs = {
  where?: InputMaybe<ExplicitUserAccessWhereInput>;
};


export type SubscriptionOnCreateHostFieldsArgs = {
  where?: InputMaybe<HostFieldsWhereInput>;
};


export type SubscriptionOnCreateMasterClassArgs = {
  where?: InputMaybe<MasterClassWhereInput>;
};


export type SubscriptionOnCreateMasterClassUserSessionArgs = {
  where?: InputMaybe<MasterClassUserSessionWhereInput>;
};


export type SubscriptionOnCreateMasterclassLoginLogsArgs = {
  where?: InputMaybe<MasterclassLoginLogsWhereInput>;
};


export type SubscriptionOnCreateMasterclassRatingsArgs = {
  where?: InputMaybe<MasterclassRatingsWhereInput>;
};


export type SubscriptionOnCreateMasterclassUserStatisticsArgs = {
  where?: InputMaybe<MasterclassUserStatisticsWhereInput>;
};


export type SubscriptionOnCreateMeetingArgs = {
  where?: InputMaybe<MeetingWhereInput>;
};


export type SubscriptionOnCreateMeetingStatsArgs = {
  where?: InputMaybe<MeetingStatsWhereInput>;
};


export type SubscriptionOnCreateMessageArgs = {
  where?: InputMaybe<MessageWhereInput>;
};


export type SubscriptionOnCreateNpsScoreArgs = {
  where?: InputMaybe<NpsScoreWhereInput>;
};


export type SubscriptionOnCreateSlideStatsArgs = {
  where?: InputMaybe<SlideStatsWhereInput>;
};


export type SubscriptionOnCreateTeamArgs = {
  where?: InputMaybe<TeamWhereInput>;
};


export type SubscriptionOnCreateUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type SubscriptionOnCreateUserMeetingJoinArgs = {
  where?: InputMaybe<UserMeetingJoinWhereInput>;
};


export type SubscriptionOnMeetingLiveParticipantsChangeArgs = {
  meetingId: Scalars['String']['input'];
};


export type SubscriptionOnUpdateAccessLinkArgs = {
  where?: InputMaybe<AccessLinkWhereInput>;
};


export type SubscriptionOnUpdateAnswerArgs = {
  where?: InputMaybe<AnswerWhereInput>;
};


export type SubscriptionOnUpdateAssetViewArgs = {
  where?: InputMaybe<AssetViewWhereInput>;
};


export type SubscriptionOnUpdateCaseClusterArgs = {
  where?: InputMaybe<CaseClusterWhereInput>;
};


export type SubscriptionOnUpdateCertificationProgressArgs = {
  where?: InputMaybe<CertificationProgressWhereInput>;
};


export type SubscriptionOnUpdateClientArgs = {
  where?: InputMaybe<ClientWhereInput>;
};


export type SubscriptionOnUpdateExplicitUserAccessArgs = {
  where?: InputMaybe<ExplicitUserAccessWhereInput>;
};


export type SubscriptionOnUpdateHostFieldsArgs = {
  where?: InputMaybe<HostFieldsWhereInput>;
};


export type SubscriptionOnUpdateMasterClassArgs = {
  where?: InputMaybe<MasterClassWhereInput>;
};


export type SubscriptionOnUpdateMasterClassUserSessionArgs = {
  where?: InputMaybe<MasterClassUserSessionWhereInput>;
};


export type SubscriptionOnUpdateMasterclassLoginLogsArgs = {
  where?: InputMaybe<MasterclassLoginLogsWhereInput>;
};


export type SubscriptionOnUpdateMasterclassRatingsArgs = {
  where?: InputMaybe<MasterclassRatingsWhereInput>;
};


export type SubscriptionOnUpdateMasterclassUserStatisticsArgs = {
  where?: InputMaybe<MasterclassUserStatisticsWhereInput>;
};


export type SubscriptionOnUpdateMeetingArgs = {
  where?: InputMaybe<MeetingWhereInput>;
};


export type SubscriptionOnUpdateMeetingStatsArgs = {
  where?: InputMaybe<MeetingStatsWhereInput>;
};


export type SubscriptionOnUpdateMessageArgs = {
  where?: InputMaybe<MessageWhereInput>;
};


export type SubscriptionOnUpdateNpsScoreArgs = {
  where?: InputMaybe<NpsScoreWhereInput>;
};


export type SubscriptionOnUpdateSlideStatsArgs = {
  where?: InputMaybe<SlideStatsWhereInput>;
};


export type SubscriptionOnUpdateTeamArgs = {
  where?: InputMaybe<TeamWhereInput>;
};


export type SubscriptionOnUpdateUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type SubscriptionOnUpdateUserMeetingJoinArgs = {
  where?: InputMaybe<UserMeetingJoinWhereInput>;
};

export type Team = {
  __typename?: 'Team';
  _count: TeamCount;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetings: MeetingConnection;
  members: UserConnection;
  name: Scalars['String']['output'];
  technicalManager?: Maybe<User>;
  technicalManagerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type TeamMeetingsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type TeamMembersArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  edges: Array<TeamEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeamCount = {
  __typename?: 'TeamCount';
  meetings: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
};

export type TeamCountAggregate = {
  __typename?: 'TeamCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  technicalManagerId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  cursor: Scalars['String']['output'];
  node: Team;
};

export type TeamListRelationFilter = {
  every?: InputMaybe<TeamWhereInput>;
  none?: InputMaybe<TeamWhereInput>;
  some?: InputMaybe<TeamWhereInput>;
};

export type TeamMaxAggregate = {
  __typename?: 'TeamMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  technicalManagerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamMinAggregate = {
  __typename?: 'TeamMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  technicalManagerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamNullableScalarRelationFilter = {
  is?: InputMaybe<TeamWhereInput>;
  isNot?: InputMaybe<TeamWhereInput>;
};

export type TeamWhereInput = {
  AND?: InputMaybe<Array<TeamWhereInput>>;
  NOT?: InputMaybe<Array<TeamWhereInput>>;
  OR?: InputMaybe<Array<TeamWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meetings?: InputMaybe<MeetingListRelationFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  technicalManager?: InputMaybe<UserNullableScalarRelationFilter>;
  technicalManagerId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TeamWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamWhereInput>>;
  NOT?: InputMaybe<Array<TeamWhereInput>>;
  OR?: InputMaybe<Array<TeamWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  meetings?: InputMaybe<MeetingListRelationFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  technicalManager?: InputMaybe<UserNullableScalarRelationFilter>;
  technicalManagerId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UpdateAnswerInputDto = {
  answerIndexes?: InputMaybe<AnswerUpdateanswerIndexesInput>;
  answerTexts?: InputMaybe<AnswerUpdateanswerTextsInput>;
  id: Scalars['String']['input'];
};

export type UpdateCaseClusterInputDto = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  isMock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UpdateHostFieldsInputDto = {
  currentAssetID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currentCase?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currentSlide?: InputMaybe<IntFieldUpdateOperationsInput>;
  meetingId: Scalars['String']['input'];
};

export type UpdateMasterClassInputDto = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMasterClassUserSessionInputDto = {
  celebrationShown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  currentCaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currentSlideId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id: Scalars['String']['input'];
  scorePercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  visitedSlideIds?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateMasterclassUserStatisticsInputDto = {
  caseId: Scalars['String']['input'];
  increaseCaseClicks?: Scalars['Boolean']['input'];
  increaseCaseSelectorVisit?: Scalars['Boolean']['input'];
  increaseCompletions?: Scalars['Boolean']['input'];
  masterclassId: Scalars['String']['input'];
};

export type UpdateMeetingInputDto = {
  administrativeStatus?: InputMaybe<MeetingAdministrativeStatus>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  hostFullName?: InputMaybe<Scalars['String']['input']>;
  hostId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isInTesting?: InputMaybe<Scalars['Boolean']['input']>;
  isMock?: InputMaybe<Scalars['Boolean']['input']>;
  meetingNotes?: InputMaybe<Scalars['String']['input']>;
  meetingType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNbr?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  streamUrl?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateMeetingStatsInputDto = {
  amountParticipants?: InputMaybe<IntFieldUpdateOperationsInput>;
  casePresentationHistory?: InputMaybe<MeetingStatsUpdatecasePresentationHistoryInput>;
  meetingId: Scalars['String']['input'];
};

export type UpdateReadAccessLinkInputDto = {
  id: Scalars['String']['input'];
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usageCountLeft?: InputMaybe<IntFieldUpdateOperationsInput>;
  validUntil?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UpdateTeamInputDto = {
  id: Scalars['String']['input'];
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UpsertCertificationProgressInputDto = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  attemptNumber: Scalars['Int']['input'];
  caseId: Scalars['String']['input'];
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentQuestion?: InputMaybe<Scalars['Int']['input']>;
  masterclassId: Scalars['String']['input'];
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type User = {
  __typename?: 'User';
  _count: UserCount;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientRole: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  explicitReadAccesses: ExplicitUserAccessConnection;
  id: Scalars['ID']['output'];
  isGuest: Scalars['Boolean']['output'];
  isMocked: Scalars['Boolean']['output'];
  meetings: MeetingConnection;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserExplicitReadAccessesArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};


export type UserMeetingsArgs = {
  paginationArgs?: InputMaybe<PaginationArgs>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserCount = {
  __typename?: 'UserCount';
  answers: Scalars['Int']['output'];
  assetViews: Scalars['Int']['output'];
  certificationProgress: Scalars['Int']['output'];
  explicitReadAccesses: Scalars['Int']['output'];
  masterClassSessions: Scalars['Int']['output'];
  masterclassLoginLogs: Scalars['Int']['output'];
  masterclassRatings: Scalars['Int']['output'];
  masterclassUserStatistics: Scalars['Int']['output'];
  meetingsCreatedBy: Scalars['Int']['output'];
  meetingsWhereHost: Scalars['Int']['output'];
  messages: Scalars['Int']['output'];
  npsScores: Scalars['Int']['output'];
  readAccessUserHasGranted: Scalars['Int']['output'];
  teamsWhereTechnicalManager: Scalars['Int']['output'];
  userMeetingJoins: Scalars['Int']['output'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int']['output'];
  clientId: Scalars['Int']['output'];
  clientRole: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isGuest: Scalars['Int']['output'];
  isMocked: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  clientId?: Maybe<Scalars['String']['output']>;
  clientRole?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGuest?: Maybe<Scalars['Boolean']['output']>;
  isMocked?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserMeetingJoin = {
  __typename?: 'UserMeetingJoin';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type UserMeetingJoinConnection = {
  __typename?: 'UserMeetingJoinConnection';
  edges: Array<UserMeetingJoinEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserMeetingJoinCountAggregate = {
  __typename?: 'UserMeetingJoinCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meetingId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserMeetingJoinEdge = {
  __typename?: 'UserMeetingJoinEdge';
  cursor: Scalars['String']['output'];
  node: UserMeetingJoin;
};

export type UserMeetingJoinListRelationFilter = {
  every?: InputMaybe<UserMeetingJoinWhereInput>;
  none?: InputMaybe<UserMeetingJoinWhereInput>;
  some?: InputMaybe<UserMeetingJoinWhereInput>;
};

export type UserMeetingJoinMaxAggregate = {
  __typename?: 'UserMeetingJoinMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserMeetingJoinMinAggregate = {
  __typename?: 'UserMeetingJoinMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserMeetingJoinWhereInput = {
  AND?: InputMaybe<Array<UserMeetingJoinWhereInput>>;
  NOT?: InputMaybe<Array<UserMeetingJoinWhereInput>>;
  OR?: InputMaybe<Array<UserMeetingJoinWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  meeting?: InputMaybe<MeetingScalarRelationFilter>;
  meetingId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  clientId?: Maybe<Scalars['String']['output']>;
  clientRole?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGuest?: Maybe<Scalars['Boolean']['output']>;
  isMocked?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserNullableScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  assetViews?: InputMaybe<AssetViewListRelationFilter>;
  certificationProgress?: InputMaybe<CertificationProgressListRelationFilter>;
  client?: InputMaybe<ClientNullableScalarRelationFilter>;
  clientId?: InputMaybe<StringNullableFilter>;
  clientRole?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  explicitReadAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isGuest?: InputMaybe<BoolFilter>;
  isMocked?: InputMaybe<BoolFilter>;
  masterClassSessions?: InputMaybe<MasterClassUserSessionListRelationFilter>;
  masterclassLoginLogs?: InputMaybe<MasterclassLoginLogsListRelationFilter>;
  masterclassRatings?: InputMaybe<MasterclassRatingsListRelationFilter>;
  masterclassUserStatistics?: InputMaybe<MasterclassUserStatisticsListRelationFilter>;
  meetingsCreatedBy?: InputMaybe<MeetingListRelationFilter>;
  meetingsWhereHost?: InputMaybe<MeetingListRelationFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  npsScores?: InputMaybe<NpsScoreListRelationFilter>;
  readAccessUserHasGranted?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  team?: InputMaybe<TeamNullableScalarRelationFilter>;
  teamId?: InputMaybe<StringNullableFilter>;
  teamsWhereTechnicalManager?: InputMaybe<TeamListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userMeetingJoins?: InputMaybe<UserMeetingJoinListRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  assetViews?: InputMaybe<AssetViewListRelationFilter>;
  certificationProgress?: InputMaybe<CertificationProgressListRelationFilter>;
  client?: InputMaybe<ClientNullableScalarRelationFilter>;
  clientId?: InputMaybe<StringNullableFilter>;
  clientRole?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  explicitReadAccesses?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isGuest?: InputMaybe<BoolFilter>;
  isMocked?: InputMaybe<BoolFilter>;
  masterClassSessions?: InputMaybe<MasterClassUserSessionListRelationFilter>;
  masterclassLoginLogs?: InputMaybe<MasterclassLoginLogsListRelationFilter>;
  masterclassRatings?: InputMaybe<MasterclassRatingsListRelationFilter>;
  masterclassUserStatistics?: InputMaybe<MasterclassUserStatisticsListRelationFilter>;
  meetingsCreatedBy?: InputMaybe<MeetingListRelationFilter>;
  meetingsWhereHost?: InputMaybe<MeetingListRelationFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  npsScores?: InputMaybe<NpsScoreListRelationFilter>;
  readAccessUserHasGranted?: InputMaybe<ExplicitUserAccessListRelationFilter>;
  team?: InputMaybe<TeamNullableScalarRelationFilter>;
  teamId?: InputMaybe<StringNullableFilter>;
  teamsWhereTechnicalManager?: InputMaybe<TeamListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userMeetingJoins?: InputMaybe<UserMeetingJoinListRelationFilter>;
};

export type MeetingStatsViewContextQueryVariables = Exact<{
  where: MeetingWhereUniqueInput;
}>;


export type MeetingStatsViewContextQuery = { __typename?: 'Query', getMeeting?: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null, caseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } } | null };

export type CurrentMeetingDataContextProviderQueryQueryVariables = Exact<{
  where: MeetingWhereUniqueInput;
}>;


export type CurrentMeetingDataContextProviderQueryQuery = { __typename?: 'Query', getMeeting?: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null, caseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } } | null };

export type AdminCaseClusterListViewQueryVariables = Exact<{
  where?: InputMaybe<CaseClusterWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  meetingsPaginationArgs?: InputMaybe<PaginationArgs>;
  clientsPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type AdminCaseClusterListViewQuery = { __typename?: 'Query', listCaseClusters: { __typename?: 'CaseClusterConnection', totalCount: number, edges: Array<{ __typename?: 'CaseClusterEdge', cursor: string, node: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } }, clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> }, meetings: { __typename?: 'MeetingConnection', edges: Array<{ __typename?: 'MeetingEdge', node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type AdminCaseListViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  orderByArgs?: InputMaybe<OrderByArgs>;
  where?: InputMaybe<PatientCaseWhereInput>;
}>;


export type AdminCaseListViewQuery = { __typename?: 'Query', listPatientCases: { __typename?: 'PatientCaseConnection', totalCount: number, edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', stringifiedContent: string, id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, caseClusters: { __typename?: 'CaseClusterConnection', edges: Array<{ __typename?: 'CaseClusterEdge', node: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } }> }, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetClickupLiveEventTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClickupLiveEventTasksQuery = { __typename?: 'Query', getClickupLiveEventTasks: any };

export type AdminClientListViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  orderByArgs?: InputMaybe<OrderByArgs>;
  where?: InputMaybe<ClientWhereInput>;
}>;


export type AdminClientListViewQuery = { __typename?: 'Query', listClients: { __typename?: 'ClientConnection', totalCount: number, edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date, meetings: { __typename?: 'MeetingConnection', edges: Array<{ __typename?: 'MeetingEdge', node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AdminMasterClassListViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  orderByArgs?: InputMaybe<OrderByArgs>;
  where?: InputMaybe<MasterClassWhereInput>;
  clientsPaginationArgs?: InputMaybe<PaginationArgs>;
  patientCasesPaginationArgs?: InputMaybe<PaginationArgs>;
  accessLinksPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type AdminMasterClassListViewQuery = { __typename?: 'Query', listMasterClasses: { __typename?: 'MasterClassConnection', totalCount: number, edges: Array<{ __typename?: 'MasterClassEdge', node: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number }, accessLinks: { __typename?: 'AccessLinkConnection', edges: Array<{ __typename?: 'AccessLinkEdge', node: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } }> }, clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> }, patientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AdminMeetingListViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  orderByArgs?: InputMaybe<OrderByArgs>;
  where?: InputMaybe<MeetingWhereInput>;
  clientsPaginationArgs?: InputMaybe<PaginationArgs>;
  teamPaginationArgs?: InputMaybe<PaginationArgs>;
  userMeetingJoinsPaginationArgs?: InputMaybe<PaginationArgs>;
  accessLinkPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type AdminMeetingListViewQuery = { __typename?: 'Query', listMeetings: { __typename?: 'MeetingConnection', totalCount: number, edges: Array<{ __typename?: 'MeetingEdge', node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null, accessLinks: { __typename?: 'AccessLinkConnection', edges: Array<{ __typename?: 'AccessLinkEdge', node: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } }> }, host: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string }, caseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } }, clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> }, teams: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', node: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } }> }, userMeetingJoins: { __typename?: 'UserMeetingJoinConnection', edges: Array<{ __typename?: 'UserMeetingJoinEdge', node: { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string } }> }, hostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AdminUserListViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  orderByArgs?: InputMaybe<OrderByArgs>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type AdminUserListViewQuery = { __typename?: 'Query', listUsers: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null, team?: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type MeetingUserAccessListViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  where?: InputMaybe<UserWhereInput>;
}>;


export type MeetingUserAccessListViewQuery = { __typename?: 'Query', listUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }> } };

export type UserMeetingAccessViewQueryVariables = Exact<{
  where: UserWhereUniqueInput;
  meetingPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type UserMeetingAccessViewQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null, explicitReadAccesses: { __typename?: 'ExplicitUserAccessConnection', edges: Array<{ __typename?: 'ExplicitUserAccessEdge', node: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } }> }, meetings: { __typename?: 'MeetingConnection', edges: Array<{ __typename?: 'MeetingEdge', node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null, clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> } } }> } } | null };

export type DashboardViewQueryVariables = Exact<{
  paginationArgs: PaginationArgs;
  where?: InputMaybe<MeetingWhereInput>;
  clientsPaginationArgs?: InputMaybe<PaginationArgs>;
  masterClassPaginationArgs?: InputMaybe<PaginationArgs>;
  masterClassWhere?: InputMaybe<MasterClassWhereInput>;
  patientCasesPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type DashboardViewQuery = { __typename?: 'Query', listMeetings: { __typename?: 'MeetingConnection', edges: Array<{ __typename?: 'MeetingEdge', node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null, caseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } }, host: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string }, clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> }, stats?: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } | null, hostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } } }> }, listMasterClasses: { __typename?: 'MasterClassConnection', edges: Array<{ __typename?: 'MasterClassEdge', node: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number }, patientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }> } } }> } };

export type IsValidAccessLinkQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type IsValidAccessLinkQuery = { __typename?: 'Query', isValidAccessLink?: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } | null };

export type CreateAccessLinkMutationVariables = Exact<{
  data: CreateReadAccessLinkInputDto;
}>;


export type CreateAccessLinkMutation = { __typename?: 'Mutation', createAccessLink: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } };

export type BatchCreateAccessLinksMutationVariables = Exact<{
  data: BatchCreateAccessLinksInputDto;
}>;


export type BatchCreateAccessLinksMutation = { __typename?: 'Mutation', batchCreateAccessLinks: Array<{ __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null }> };

export type BatchUpdateAccessLinksMutationVariables = Exact<{
  data: BatchUpdateReadAccessLinksInputDto;
}>;


export type BatchUpdateAccessLinksMutation = { __typename?: 'Mutation', batchUpdateAccessLinks: Array<{ __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null }> };

export type ListAccessLinksQueryVariables = Exact<{
  where?: InputMaybe<AccessLinkWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListAccessLinksQuery = { __typename?: 'Query', listAccessLinks: { __typename?: 'AccessLinkConnection', totalCount: number, edges: Array<{ __typename?: 'AccessLinkEdge', cursor: string, node: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type RequestReadAccessMutationVariables = Exact<{
  data: RequestAccessInputDto;
}>;


export type RequestReadAccessMutation = { __typename?: 'Mutation', requestReadAccess: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } };

export type DeleteAccessLinkMutationVariables = Exact<{
  where: AccessLinkWhereUniqueInput;
}>;


export type DeleteAccessLinkMutation = { __typename?: 'Mutation', deleteAccessLink: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } };

export type OnCreateAccessLinkSubscriptionVariables = Exact<{
  where?: InputMaybe<AccessLinkWhereInput>;
}>;


export type OnCreateAccessLinkSubscription = { __typename?: 'Subscription', onCreateAccessLink: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } };

export type OnDeleteAccessLinkSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteAccessLinkSubscription = { __typename?: 'Subscription', onDeleteAccessLink: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } };

export type CreateRegistrationLinkMutationVariables = Exact<{
  data: CreateRegistrationLinkInputDto;
}>;


export type CreateRegistrationLinkMutation = { __typename?: 'Mutation', createRegistrationLink: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } };

export type CreateAnswerMutationVariables = Exact<{
  data: CreateAnswerInputDto;
}>;


export type CreateAnswerMutation = { __typename?: 'Mutation', createAnswer: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } };

export type ListAnswersQueryVariables = Exact<{
  where?: InputMaybe<AnswerWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListAnswersQuery = { __typename?: 'Query', listAnswers: { __typename?: 'AnswerConnection', edges: Array<{ __typename?: 'AnswerEdge', cursor: string, node: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListAnswersWithUsersQueryVariables = Exact<{
  where?: InputMaybe<AnswerWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListAnswersWithUsersQuery = { __typename?: 'Query', listAnswers: { __typename?: 'AnswerConnection', edges: Array<{ __typename?: 'AnswerEdge', cursor: string, node: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null, user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UpdateAnswerMutationVariables = Exact<{
  data: UpdateAnswerInputDto;
}>;


export type UpdateAnswerMutation = { __typename?: 'Mutation', updateAnswer: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } };

export type CreateOrUpdateAnswerMutationVariables = Exact<{
  data: CreateOrUpdateAnswerInputDto;
}>;


export type CreateOrUpdateAnswerMutation = { __typename?: 'Mutation', createOrUpdateAnswer: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } };

export type OnCreateAnswerSubscriptionVariables = Exact<{
  where?: InputMaybe<AnswerWhereInput>;
}>;


export type OnCreateAnswerSubscription = { __typename?: 'Subscription', onCreateAnswer: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } };

export type OnUpdateAnswerSubscriptionVariables = Exact<{
  where?: InputMaybe<AnswerWhereInput>;
}>;


export type OnUpdateAnswerSubscription = { __typename?: 'Subscription', onUpdateAnswer: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } };

export type OnDeleteAnswerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteAnswerSubscription = { __typename?: 'Subscription', onDeleteAnswer: { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null } };

export type CreateAssetViewMutationVariables = Exact<{
  data: CreateAssetViewInputDto;
}>;


export type CreateAssetViewMutation = { __typename?: 'Mutation', createAssetView: { __typename?: 'AssetView', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, timeWatched: number, userId: string, meetingId: string, assetId: string } };

export type ListAssetViewsQueryVariables = Exact<{
  where?: InputMaybe<AssetViewWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListAssetViewsQuery = { __typename?: 'Query', listAssetViews: { __typename?: 'AssetViewConnection', edges: Array<{ __typename?: 'AssetViewEdge', cursor: string, node: { __typename?: 'AssetView', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, timeWatched: number, userId: string, meetingId: string, assetId: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type OnCreateAssetViewSubscriptionVariables = Exact<{
  where?: InputMaybe<AssetViewWhereInput>;
}>;


export type OnCreateAssetViewSubscription = { __typename?: 'Subscription', onCreateAssetView: { __typename?: 'AssetView', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, timeWatched: number, userId: string, meetingId: string, assetId: string } };

export type OnUpdateAssetViewSubscriptionVariables = Exact<{
  where?: InputMaybe<AssetViewWhereInput>;
}>;


export type OnUpdateAssetViewSubscription = { __typename?: 'Subscription', onUpdateAssetView: { __typename?: 'AssetView', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, timeWatched: number, userId: string, meetingId: string, assetId: string } };

export type OnDeleteAssetViewSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteAssetViewSubscription = { __typename?: 'Subscription', onDeleteAssetView: { __typename?: 'AssetView', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, timeWatched: number, userId: string, meetingId: string, assetId: string } };

export type CreateCaseClusterMutationVariables = Exact<{
  data: CreateCaseClusterInputDto;
}>;


export type CreateCaseClusterMutation = { __typename?: 'Mutation', createCaseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type GetCaseClusterQueryVariables = Exact<{
  where: CaseClusterWhereUniqueInput;
}>;


export type GetCaseClusterQuery = { __typename?: 'Query', getCaseCluster?: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } | null };

export type ListCaseClustersQueryVariables = Exact<{
  where?: InputMaybe<CaseClusterWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListCaseClustersQuery = { __typename?: 'Query', listCaseClusters: { __typename?: 'CaseClusterConnection', edges: Array<{ __typename?: 'CaseClusterEdge', cursor: string, node: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UpdateCaseClusterMutationVariables = Exact<{
  data: UpdateCaseClusterInputDto;
}>;


export type UpdateCaseClusterMutation = { __typename?: 'Mutation', updateCaseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type DeleteCaseClusterMutationVariables = Exact<{
  where: CaseClusterWhereUniqueInput;
}>;


export type DeleteCaseClusterMutation = { __typename?: 'Mutation', deleteCaseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type OnCreateCaseClusterSubscriptionVariables = Exact<{
  where?: InputMaybe<CaseClusterWhereInput>;
}>;


export type OnCreateCaseClusterSubscription = { __typename?: 'Subscription', onCreateCaseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type OnUpdateCaseClusterSubscriptionVariables = Exact<{
  where?: InputMaybe<CaseClusterWhereInput>;
}>;


export type OnUpdateCaseClusterSubscription = { __typename?: 'Subscription', onUpdateCaseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type OnDeleteCaseClusterSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteCaseClusterSubscription = { __typename?: 'Subscription', onDeleteCaseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type GetCaseStatsAggregationQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  masterclassId: Scalars['String']['input'];
}>;


export type GetCaseStatsAggregationQuery = { __typename?: 'Query', getCaseStatsAggregation: { __typename?: 'CaseStatsAggregation', caseId: string, caseName?: string | null, summary: { __typename?: 'CaseStatsSummary', totalUsers: number, usersWhoAccessed: number, usersWhoCompleted: number, usersWhoPassed: number, averageRating?: number | null, completionRate?: number | null, passRate?: number | null }, userStats: Array<{ __typename?: 'CaseUserStats', userId: string, username: string, email?: string | null, caseSelectorVisits: number, caseClicks: number, completions: number, firstAccessDate?: Date | null, lastAccessDate?: Date | null, averageRating?: number | null, certificationStatus: CertificationStatus, certificationAttempts: number, bestCertificationScore?: number | null, hasAccessed: boolean, hasCompleted: boolean }> } };

export type GetCertificationQuestionsQueryVariables = Exact<{
  input: PatientCaseFilter;
}>;


export type GetCertificationQuestionsQuery = { __typename?: 'Query', getCertificationQuestions: { __typename?: 'CertificationData', case_id: string, case_key: string, passing_score?: number | null, certification_questions: Array<{ __typename?: 'CertificationQuestion', id: string, question_text: string, options: Array<string>, correct_answer: number, explanation?: string | null }> } };

export type GetCertificationProgressQueryVariables = Exact<{
  where: CertificationProgressWhereUniqueInput;
}>;


export type GetCertificationProgressQuery = { __typename?: 'Query', getCertificationProgress?: { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date } | null };

export type ListCertificationProgressQueryVariables = Exact<{
  where?: InputMaybe<CertificationProgressWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListCertificationProgressQuery = { __typename?: 'Query', listCertificationProgress: { __typename?: 'CertificationProgressConnection', edges: Array<{ __typename?: 'CertificationProgressEdge', cursor: string, node: { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UpsertCertificationProgressMutationVariables = Exact<{
  data: UpsertCertificationProgressInputDto;
}>;


export type UpsertCertificationProgressMutation = { __typename?: 'Mutation', upsertCertificationProgress: { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date } };

export type DeleteCertificationProgressMutationVariables = Exact<{
  where: CertificationProgressWhereUniqueInput;
}>;


export type DeleteCertificationProgressMutation = { __typename?: 'Mutation', deleteCertificationProgress: { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date } };

export type OnCreateCertificationProgressSubscriptionVariables = Exact<{
  where?: InputMaybe<CertificationProgressWhereInput>;
}>;


export type OnCreateCertificationProgressSubscription = { __typename?: 'Subscription', onCreateCertificationProgress: { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date } };

export type OnUpdateCertificationProgressSubscriptionVariables = Exact<{
  where?: InputMaybe<CertificationProgressWhereInput>;
}>;


export type OnUpdateCertificationProgressSubscription = { __typename?: 'Subscription', onUpdateCertificationProgress: { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date } };

export type CreateClientMutationVariables = Exact<{
  data: CreateClientInputDto;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, name: string, createdAt: Date } };

export type ListClientsQueryVariables = Exact<{
  where?: InputMaybe<ClientWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListClientsQuery = { __typename?: 'Query', listClients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListClientsWithMembersQueryVariables = Exact<{
  where?: InputMaybe<ClientWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  memberPagination?: InputMaybe<PaginationArgs>;
}>;


export type ListClientsWithMembersQuery = { __typename?: 'Query', listClients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'Client', id: string, name: string, createdAt: Date, members: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetClientQueryVariables = Exact<{
  where: ClientWhereUniqueInput;
}>;


export type GetClientQuery = { __typename?: 'Query', getClient?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null };

export type GetClientWithMembersQueryVariables = Exact<{
  where: ClientWhereUniqueInput;
  memberPagination?: InputMaybe<PaginationArgs>;
}>;


export type GetClientWithMembersQuery = { __typename?: 'Query', getClient?: { __typename?: 'Client', id: string, name: string, createdAt: Date, members: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type DeleteClientMutationVariables = Exact<{
  where: ClientWhereUniqueInput;
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: { __typename?: 'Client', id: string, name: string, createdAt: Date } };

export type AddUserToClientMutationVariables = Exact<{
  data: ChangeUserToClientInputDto;
  memberPagination?: InputMaybe<PaginationArgs>;
}>;


export type AddUserToClientMutation = { __typename?: 'Mutation', addUserToClient: { __typename?: 'Client', id: string, name: string, createdAt: Date, members: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type RemoveUserFromClientMutationVariables = Exact<{
  data: ChangeUserToClientInputDto;
  memberPagination?: InputMaybe<PaginationArgs>;
}>;


export type RemoveUserFromClientMutation = { __typename?: 'Mutation', removeUserFromClient: { __typename?: 'Client', id: string, name: string, createdAt: Date, members: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type SetClientRoleMutationVariables = Exact<{
  data: SetClientRoleInputDto;
}>;


export type SetClientRoleMutation = { __typename?: 'Mutation', setClientRole: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type OnCreateClientSubscriptionVariables = Exact<{
  where?: InputMaybe<ClientWhereInput>;
}>;


export type OnCreateClientSubscription = { __typename?: 'Subscription', onCreateClient: { __typename?: 'Client', id: string, name: string, createdAt: Date } };

export type OnUpdateClientSubscriptionVariables = Exact<{
  where?: InputMaybe<ClientWhereInput>;
}>;


export type OnUpdateClientSubscription = { __typename?: 'Subscription', onUpdateClient: { __typename?: 'Client', id: string, name: string, createdAt: Date } };

export type OnDeleteClientSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteClientSubscription = { __typename?: 'Subscription', onDeleteClient: { __typename?: 'Client', id: string, name: string, createdAt: Date } };

export type AccessLinkFieldsFragment = { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null };

export type AssetViewFieldsFragment = { __typename?: 'AssetView', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, timeWatched: number, userId: string, meetingId: string, assetId: string };

export type CaseClusterFieldsFragment = { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type CaseClusterRelationClientsFragment = { __typename?: 'CaseCluster', clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> } };

export type CaseClusterRelationMeetingsFragment = { __typename?: 'CaseCluster', meetings: { __typename?: 'MeetingConnection', edges: Array<{ __typename?: 'MeetingEdge', node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } }> } };

export type CertificationProgressFieldsFragment = { __typename?: 'CertificationProgress', id: string, userId: string, caseId: string, masterclassId: string, attemptNumber: number, currentQuestion?: number | null, answers?: any | null, score?: number | null, passed: boolean, startedAt?: Date | null, completedAt?: Date | null, updatedAt: Date };

export type ClientFieldsFragment = { __typename?: 'Client', id: string, name: string, createdAt: Date };

export type ExplicitUserAccessFieldsFragment = { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date };

export type HostFieldsFieldsFragment = { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string };

export type MasterclassLoginLogsFieldsFragment = { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date };

export type MasterclassRatingsFieldsFragment = { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date };

export type MasterClassUserSessionFieldsFragment = { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any };

export type MasterclassUserStatisticsFieldsFragment = { __typename?: 'MasterclassUserStatistics', id: string, userId: string, caseId: string, caseSelectorVisits: number, caseClicks: number, completions: number, createdAt: Date, updatedAt: Date };

export type MasterClassFieldsFragment = { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } };

export type MasterClassWithSessionFieldsFragment = { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number }, mySessions: { __typename?: 'MasterClassUserSessionConnection', totalCount: number, edges: Array<{ __typename?: 'MasterClassUserSessionEdge', node: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any, caseId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, mySessionStats: { __typename?: 'MySessionStats', completedCasesCount: number, startedCasesCount: number, totalCases: number, hasStartedAny: boolean, isFullyCompleted: boolean }, patientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string } }> } };

export type MasterClassRelationClientsFragment = { __typename?: 'MasterClass', clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> } };

export type MasterClassRelationPatientCasesFragment = { __typename?: 'MasterClass', patientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }> } };

export type MasterClassRelationAccessLinksFragment = { __typename?: 'MasterClass', accessLinks: { __typename?: 'AccessLinkConnection', edges: Array<{ __typename?: 'AccessLinkEdge', node: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } }> } };

export type MasterClassMyAccessFragment = { __typename?: 'MasterClass', hasReviewerAccess: boolean };

export type MeetingStatsFieldsFragment = { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string };

export type MeetingFieldsFragment = { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null };

export type MeetingRelationAccessLinkFragment = { __typename?: 'Meeting', accessLinks: { __typename?: 'AccessLinkConnection', edges: Array<{ __typename?: 'AccessLinkEdge', node: { __typename?: 'AccessLink', id: string, createdAt: Date, updatedAt: Date, purpose: string, accessCode: string, isEnabled: boolean, validUntil: Date, usageCountLeft: number, metadata: any, linkFirstAccount: boolean, objId: string, meetingId?: string | null, masterClassId?: string | null, patientCaseId?: string | null } }> } };

export type MeetingRelationHostFragment = { __typename?: 'Meeting', host: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type MeetingRelationCaseClusterFragment = { __typename?: 'Meeting', caseCluster: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type MeetingRelationClientsFragment = { __typename?: 'Meeting', clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node: { __typename?: 'Client', id: string, name: string, createdAt: Date } }> } };

export type MeetingRelationTeamsFragment = { __typename?: 'Meeting', teams: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', node: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } }> } };

export type MeetingRelationUserMeetingJoinsFragment = { __typename?: 'Meeting', userMeetingJoins: { __typename?: 'UserMeetingJoinConnection', edges: Array<{ __typename?: 'UserMeetingJoinEdge', node: { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string } }> } };

export type MeetingRelationMeetingStatsFragment = { __typename?: 'Meeting', stats?: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } | null };

export type MeetingRelationHostFieldsFragment = { __typename?: 'Meeting', hostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } };

export type UnloadedPatientCaseFieldsFragment = { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null };

export type PatientCaseFieldsFragment = { __typename?: 'PatientCase', stringifiedContent: string, id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null };

export type PatientCaseRelationCaseClusterFragment = { __typename?: 'PatientCase', caseClusters: { __typename?: 'CaseClusterConnection', edges: Array<{ __typename?: 'CaseClusterEdge', node: { __typename?: 'CaseCluster', id: string, name: string, createdAt: Date, updatedAt: Date, isMock: boolean, cases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } } }> } };

export type PatientCaseRelationClientFragment = { __typename?: 'PatientCase', client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null };

export type SlideStatsFieldsFragment = { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string };

export type TeamFieldsFragment = { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null };

export type UserMeetingJoinFieldsFragment = { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string };

export type LiveMeetingParticipantsFieldsFragment = { __typename?: 'LiveMeetingParticipants', meetingId: string, count: number, participants: Array<{ __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string }> };

export type MeetingParticipantsChangePacketFieldsFragment = { __typename?: 'MeetingParticipantsChangePacket', type: MeetingParticipantsChangeType, user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type UserMeetingJoinRelationUserFragment = { __typename?: 'UserMeetingJoin', user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type UserFieldsFragment = { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string };

export type UserRelationClientFragment = { __typename?: 'User', client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null };

export type AnswerFieldsFragment = { __typename?: 'Answer', id: string, createdAt: Date, updatedAt: Date, slideId: string, patientCaseId: string, userId: string, meetingId?: string | null, masterClassUserSessionId?: string | null, answerIndexes?: Array<string> | null, answerTexts?: Array<string> | null };

export type AnswerRelationUserFragment = { __typename?: 'Answer', user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type MessageFieldsFragment = { __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string };

export type NpsScoreFieldsFragment = { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string };

export type GetHostFieldsQueryVariables = Exact<{
  where: HostFieldsWhereUniqueInput;
}>;


export type GetHostFieldsQuery = { __typename?: 'Query', getHostFields?: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } | null };

export type UpdateHostFieldsMutationVariables = Exact<{
  data: UpdateHostFieldsInputDto;
}>;


export type UpdateHostFieldsMutation = { __typename?: 'Mutation', updateHostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } };

export type OnCreateHostFieldsSubscriptionVariables = Exact<{
  where?: InputMaybe<HostFieldsWhereInput>;
}>;


export type OnCreateHostFieldsSubscription = { __typename?: 'Subscription', onCreateHostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } };

export type OnUpdateHostFieldsSubscriptionVariables = Exact<{
  where?: InputMaybe<HostFieldsWhereInput>;
}>;


export type OnUpdateHostFieldsSubscription = { __typename?: 'Subscription', onUpdateHostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } };

export type OnDeleteHostFieldsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteHostFieldsSubscription = { __typename?: 'Subscription', onDeleteHostFields: { __typename?: 'HostFields', id: string, currentCase?: string | null, currentSlide: number, currentAssetID?: string | null, meetingId: string } };

export type GetMasterclassLoginLogsQueryVariables = Exact<{
  where: MasterclassLoginLogsWhereUniqueInput;
}>;


export type GetMasterclassLoginLogsQuery = { __typename?: 'Query', getMasterclassLoginLogs?: { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date } | null };

export type ListMasterclassLoginLogsQueryVariables = Exact<{
  where?: InputMaybe<MasterclassLoginLogsWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMasterclassLoginLogsQuery = { __typename?: 'Query', listMasterclassLoginLogs: { __typename?: 'MasterclassLoginLogsConnection', edges: Array<{ __typename?: 'MasterclassLoginLogsEdge', cursor: string, node: { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type CreateMasterclassLoginLogsMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMasterclassLoginLogsMutation = { __typename?: 'Mutation', createMasterclassLoginLogs: { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date } };

export type DeleteMasterclassLoginLogsMutationVariables = Exact<{
  where: MasterclassLoginLogsWhereUniqueInput;
}>;


export type DeleteMasterclassLoginLogsMutation = { __typename?: 'Mutation', deleteMasterclassLoginLogs: { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date } };

export type OnCreateMasterclassLoginLogsSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterclassLoginLogsWhereInput>;
}>;


export type OnCreateMasterclassLoginLogsSubscription = { __typename?: 'Subscription', onCreateMasterclassLoginLogs: { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date } };

export type OnUpdateMasterclassLoginLogsSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterclassLoginLogsWhereInput>;
}>;


export type OnUpdateMasterclassLoginLogsSubscription = { __typename?: 'Subscription', onUpdateMasterclassLoginLogs: { __typename?: 'MasterclassLoginLogs', id: string, userId: string, createdAt: Date, loggedInAt: Date } };

export type GetMasterclassRatingsQueryVariables = Exact<{
  where: MasterclassRatingsWhereUniqueInput;
}>;


export type GetMasterclassRatingsQuery = { __typename?: 'Query', getMasterclassRatings?: { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date } | null };

export type ListMasterclassRatingsQueryVariables = Exact<{
  where?: InputMaybe<MasterclassRatingsWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMasterclassRatingsQuery = { __typename?: 'Query', listMasterclassRatings: { __typename?: 'MasterclassRatingsConnection', edges: Array<{ __typename?: 'MasterclassRatingsEdge', cursor: string, node: { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type CreateMasterclassRatingsMutationVariables = Exact<{
  data: CreateMasterclassRatingsInputDto;
}>;


export type CreateMasterclassRatingsMutation = { __typename?: 'Mutation', createMasterclassRatings: { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date } };

export type DeleteMasterclassRatingsMutationVariables = Exact<{
  where: MasterclassRatingsWhereUniqueInput;
}>;


export type DeleteMasterclassRatingsMutation = { __typename?: 'Mutation', deleteMasterclassRatings: { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date } };

export type OnCreateMasterclassRatingsSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterclassRatingsWhereInput>;
}>;


export type OnCreateMasterclassRatingsSubscription = { __typename?: 'Subscription', onCreateMasterclassRatings: { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date } };

export type OnUpdateMasterclassRatingsSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterclassRatingsWhereInput>;
}>;


export type OnUpdateMasterclassRatingsSubscription = { __typename?: 'Subscription', onUpdateMasterclassRatings: { __typename?: 'MasterclassRatings', id: string, userId: string, caseId: string, masterclassId: string, certificationProgressId: string, applicationRating: number, masterclassRating: number, createdAt: Date } };

export type CreateMasterClassUserSessionMutationVariables = Exact<{
  data: CreateMasterClassUserSessionInputDto;
}>;


export type CreateMasterClassUserSessionMutation = { __typename?: 'Mutation', createMasterClassUserSession: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } };

export type GetMasterClassUserSessionQueryVariables = Exact<{
  where: MasterClassUserSessionWhereUniqueInput;
}>;


export type GetMasterClassUserSessionQuery = { __typename?: 'Query', getMasterClassUserSession?: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } | null };

export type UpdateMasterClassUserSessionMutationVariables = Exact<{
  data: UpdateMasterClassUserSessionInputDto;
}>;


export type UpdateMasterClassUserSessionMutation = { __typename?: 'Mutation', updateMasterClassUserSession: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } };

export type ResetCaseProgressMutationVariables = Exact<{
  data: ResetCaseProgressInputDto;
}>;


export type ResetCaseProgressMutation = { __typename?: 'Mutation', resetCaseProgress?: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } | null };

export type OnCreateMasterClassUserSessionSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterClassUserSessionWhereInput>;
}>;


export type OnCreateMasterClassUserSessionSubscription = { __typename?: 'Subscription', onCreateMasterClassUserSession: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } };

export type OnUpdateMasterClassUserSessionSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterClassUserSessionWhereInput>;
}>;


export type OnUpdateMasterClassUserSessionSubscription = { __typename?: 'Subscription', onUpdateMasterClassUserSession: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } };

export type OnDeleteMasterClassUserSessionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteMasterClassUserSessionSubscription = { __typename?: 'Subscription', onDeleteMasterClassUserSession: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, caseId?: string | null, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any } };

export type GetMasterclassUserStatisticsQueryVariables = Exact<{
  where: MasterclassUserStatisticsWhereUniqueInput;
}>;


export type GetMasterclassUserStatisticsQuery = { __typename?: 'Query', getMasterclassUserStatistics?: { __typename?: 'MasterclassUserStatistics', id: string, userId: string, caseId: string, caseSelectorVisits: number, caseClicks: number, completions: number, createdAt: Date, updatedAt: Date } | null };

export type ListMasterclassUserStatisticsQueryVariables = Exact<{
  where?: InputMaybe<MasterclassUserStatisticsWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMasterclassUserStatisticsQuery = { __typename?: 'Query', listMasterclassUserStatistics: { __typename?: 'MasterclassUserStatisticsConnection', edges: Array<{ __typename?: 'MasterclassUserStatisticsEdge', cursor: string, node: { __typename?: 'MasterclassUserStatistics', id: string, userId: string, caseId: string, caseSelectorVisits: number, caseClicks: number, completions: number, createdAt: Date, updatedAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UpdateMasterclassUserStatisticsMutationVariables = Exact<{
  data: UpdateMasterclassUserStatisticsInputDto;
}>;


export type UpdateMasterclassUserStatisticsMutation = { __typename?: 'Mutation', updateMasterclassUserStatistics: { __typename?: 'MasterclassUserStatistics', id: string, userId: string, caseId: string, caseSelectorVisits: number, caseClicks: number, completions: number, createdAt: Date, updatedAt: Date } };

export type OnCreateMasterclassUserStatisticsSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterclassUserStatisticsWhereInput>;
}>;


export type OnCreateMasterclassUserStatisticsSubscription = { __typename?: 'Subscription', onCreateMasterclassUserStatistics: { __typename?: 'MasterclassUserStatistics', id: string, userId: string, caseId: string, caseSelectorVisits: number, caseClicks: number, completions: number, createdAt: Date, updatedAt: Date } };

export type OnUpdateMasterclassUserStatisticsSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterclassUserStatisticsWhereInput>;
}>;


export type OnUpdateMasterclassUserStatisticsSubscription = { __typename?: 'Subscription', onUpdateMasterclassUserStatistics: { __typename?: 'MasterclassUserStatistics', id: string, userId: string, caseId: string, caseSelectorVisits: number, caseClicks: number, completions: number, createdAt: Date, updatedAt: Date } };

export type CreateMasterClassMutationVariables = Exact<{
  data: CreateMasterClassInputDto;
}>;


export type CreateMasterClassMutation = { __typename?: 'Mutation', createMasterClass: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } };

export type UpdateMasterClassMutationVariables = Exact<{
  data: UpdateMasterClassInputDto;
}>;


export type UpdateMasterClassMutation = { __typename?: 'Mutation', updateMasterClass: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } };

export type GetMasterClassQueryVariables = Exact<{
  where: MasterClassWhereUniqueInput;
}>;


export type GetMasterClassQuery = { __typename?: 'Query', getMasterClass?: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } | null };

export type GetMasterClassAccessQueryVariables = Exact<{
  where: MasterClassWhereUniqueInput;
}>;


export type GetMasterClassAccessQuery = { __typename?: 'Query', getMasterClass?: { __typename?: 'MasterClass', id: string, hasReviewerAccess: boolean } | null };

export type GetMasterClassWithPatientCasesQueryVariables = Exact<{
  where: MasterClassWhereUniqueInput;
  patientCasesPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type GetMasterClassWithPatientCasesQuery = { __typename?: 'Query', getMasterClass?: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number }, patientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }> } } | null };

export type ListMasterClassesQueryVariables = Exact<{
  where?: InputMaybe<MasterClassWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMasterClassesQuery = { __typename?: 'Query', listMasterClasses: { __typename?: 'MasterClassConnection', edges: Array<{ __typename?: 'MasterClassEdge', cursor: string, node: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListMasterClassesWithSessionsQueryVariables = Exact<{
  where?: InputMaybe<MasterClassWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMasterClassesWithSessionsQuery = { __typename?: 'Query', listMasterClasses: { __typename?: 'MasterClassConnection', edges: Array<{ __typename?: 'MasterClassEdge', cursor: string, node: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number }, mySessions: { __typename?: 'MasterClassUserSessionConnection', totalCount: number, edges: Array<{ __typename?: 'MasterClassUserSessionEdge', node: { __typename?: 'MasterClassUserSession', id: string, userId: string, masterClassId: string, currentSlideId?: string | null, currentCaseId?: string | null, celebrationShown: boolean, completed: boolean, scorePercentage: any, visitedSlideIds: any, caseId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, mySessionStats: { __typename?: 'MySessionStats', completedCasesCount: number, startedCasesCount: number, totalCases: number, hasStartedAny: boolean, isFullyCompleted: boolean }, patientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type DeleteMasterClassMutationVariables = Exact<{
  where: MasterClassWhereUniqueInput;
}>;


export type DeleteMasterClassMutation = { __typename?: 'Mutation', deleteMasterClass: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } };

export type OnCreateMasterClassSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterClassWhereInput>;
}>;


export type OnCreateMasterClassSubscription = { __typename?: 'Subscription', onCreateMasterClass: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } };

export type OnUpdateMasterClassSubscriptionVariables = Exact<{
  where?: InputMaybe<MasterClassWhereInput>;
}>;


export type OnUpdateMasterClassSubscription = { __typename?: 'Subscription', onUpdateMasterClass: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } };

export type OnDeleteMasterClassSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteMasterClassSubscription = { __typename?: 'Subscription', onDeleteMasterClass: { __typename?: 'MasterClass', id: string, title: string, _count: { __typename?: 'MasterClassCount', patientCases: number } } };

export type GetMeetingStatsQueryVariables = Exact<{
  where: MeetingStatsWhereUniqueInput;
}>;


export type GetMeetingStatsQuery = { __typename?: 'Query', getMeetingStats?: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } | null };

export type UpdateMeetingStatsMutationVariables = Exact<{
  data: UpdateMeetingStatsInputDto;
}>;


export type UpdateMeetingStatsMutation = { __typename?: 'Mutation', updateMeetingStats: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } };

export type OnCreateMeetingStatsSubscriptionVariables = Exact<{
  where?: InputMaybe<MeetingStatsWhereInput>;
}>;


export type OnCreateMeetingStatsSubscription = { __typename?: 'Subscription', onCreateMeetingStats: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } };

export type OnUpdateMeetingStatsSubscriptionVariables = Exact<{
  where?: InputMaybe<MeetingStatsWhereInput>;
}>;


export type OnUpdateMeetingStatsSubscription = { __typename?: 'Subscription', onUpdateMeetingStats: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } };

export type OnDeleteMeetingStatsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteMeetingStatsSubscription = { __typename?: 'Subscription', onDeleteMeetingStats: { __typename?: 'MeetingStats', id: string, createdAt: Date, updatedAt: Date, casePresentationHistory?: Array<string> | null, amountParticipants: number, meetingId: string } };

export type CreateMeetingMutationVariables = Exact<{
  data: CreateMeetingInputDto;
}>;


export type CreateMeetingMutation = { __typename?: 'Mutation', createMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type UpdateMeetingMutationVariables = Exact<{
  data: UpdateMeetingInputDto;
}>;


export type UpdateMeetingMutation = { __typename?: 'Mutation', updateMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type GetMeetingQueryVariables = Exact<{
  where: MeetingWhereUniqueInput;
}>;


export type GetMeetingQuery = { __typename?: 'Query', getMeeting?: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } | null };

export type ListMeetingsQueryVariables = Exact<{
  where?: InputMaybe<MeetingWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMeetingsQuery = { __typename?: 'Query', listMeetings: { __typename?: 'MeetingConnection', edges: Array<{ __typename?: 'MeetingEdge', cursor: string, node: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type DeleteMeetingMutationVariables = Exact<{
  where: MeetingWhereUniqueInput;
}>;


export type DeleteMeetingMutation = { __typename?: 'Mutation', deleteMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type ResetMeetingMutationVariables = Exact<{
  where: MeetingWhereUniqueInput;
  data: ResetMeetingInputDto;
}>;


export type ResetMeetingMutation = { __typename?: 'Mutation', resetMeeting: boolean };

export type CancelMeetingMutationVariables = Exact<{
  where: MeetingWhereUniqueInput;
}>;


export type CancelMeetingMutation = { __typename?: 'Mutation', cancelMeeting: boolean };

export type OnCreateMeetingSubscriptionVariables = Exact<{
  where?: InputMaybe<MeetingWhereInput>;
}>;


export type OnCreateMeetingSubscription = { __typename?: 'Subscription', onCreateMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type OnUpdateMeetingSubscriptionVariables = Exact<{
  where?: InputMaybe<MeetingWhereInput>;
}>;


export type OnUpdateMeetingSubscription = { __typename?: 'Subscription', onUpdateMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type OnDeleteMeetingSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteMeetingSubscription = { __typename?: 'Subscription', onDeleteMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type GetAvailableDatesQueryVariables = Exact<{
  data: GetAvailableDatesInputDto;
}>;


export type GetAvailableDatesQuery = { __typename?: 'Query', getAvailableDates: Array<{ __typename?: 'DateAvailability', date: Date, totalTeams: number, bookedTeams: number, availableTeams: number, isFullyBooked: boolean }> };

export type ApproveMeetingMutationVariables = Exact<{
  data: ApproveMeetingInputDto;
}>;


export type ApproveMeetingMutation = { __typename?: 'Mutation', approveMeeting: { __typename?: 'Meeting', id: string, name: string, createdAt: Date, updatedAt: Date, hostId: string, hostFullName: string, eventDate: Date, startDate?: Date | null, endDate?: Date | null, eventLocation: string, purchaseOrderNbr: string, meetingNotes: string, meetingType: string, streamUrl?: string | null, isMock: boolean, isInTesting: boolean, isArchived: boolean, isDemo: boolean, administrativeStatus: MeetingAdministrativeStatus, caseClusterId: string, createdById?: string | null } };

export type CreateMessageMutationVariables = Exact<{
  data: CreateMessageInputDto;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string } };

export type ListMessagesQueryVariables = Exact<{
  where?: InputMaybe<MessageWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListMessagesQuery = { __typename?: 'Query', listMessages: { __typename?: 'MessageConnection', edges: Array<{ __typename?: 'MessageEdge', cursor: string, node: { __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type DeleteMessagesMutationVariables = Exact<{
  where: MessageWhereInput;
}>;


export type DeleteMessagesMutation = { __typename?: 'Mutation', deleteMessages: Array<{ __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string }> };

export type OnCreateMessageSubscriptionVariables = Exact<{
  where?: InputMaybe<MessageWhereInput>;
}>;


export type OnCreateMessageSubscription = { __typename?: 'Subscription', onCreateMessage: { __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string } };

export type OnUpdateMessageSubscriptionVariables = Exact<{
  where?: InputMaybe<MessageWhereInput>;
}>;


export type OnUpdateMessageSubscription = { __typename?: 'Subscription', onUpdateMessage: { __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string } };

export type OnDeleteMessageSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteMessageSubscription = { __typename?: 'Subscription', onDeleteMessage: { __typename?: 'Message', id: string, createdAt: Date, updatedAt: Date, body: string, meetingId: string, userId: string } };

export type CreateNpsScoreMutationVariables = Exact<{
  data: CreateNpsScoreInputDto;
}>;


export type CreateNpsScoreMutation = { __typename?: 'Mutation', createNPSScore: { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string } };

export type GetNpsScoreQueryVariables = Exact<{
  where: NpsScoreWhereUniqueInput;
}>;


export type GetNpsScoreQuery = { __typename?: 'Query', getNPSScore?: { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string } | null };

export type ListNpsScoresQueryVariables = Exact<{
  where?: InputMaybe<NpsScoreWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListNpsScoresQuery = { __typename?: 'Query', listNPSScores: { __typename?: 'NPSScoreConnection', edges: Array<{ __typename?: 'NPSScoreEdge', cursor: string, node: { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type OnCreateNpsScoreSubscriptionVariables = Exact<{
  where?: InputMaybe<NpsScoreWhereInput>;
}>;


export type OnCreateNpsScoreSubscription = { __typename?: 'Subscription', onCreateNPSScore: { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string } };

export type OnUpdateNpsScoreSubscriptionVariables = Exact<{
  where?: InputMaybe<NpsScoreWhereInput>;
}>;


export type OnUpdateNpsScoreSubscription = { __typename?: 'Subscription', onUpdateNPSScore: { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string } };

export type OnDeleteNpsScoreSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteNpsScoreSubscription = { __typename?: 'Subscription', onDeleteNPSScore: { __typename?: 'NPSScore', id: string, createdAt: Date, updatedAt: Date, scores?: Array<number> | null, userId: string, meetingId: string } };

export type GetPatientCaseWithContentQueryVariables = Exact<{
  input: PatientCaseFilter;
}>;


export type GetPatientCaseWithContentQuery = { __typename?: 'Query', getPatientCase: { __typename?: 'PatientCase', stringifiedContent: string, id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } };

export type ListPatientCasesQueryVariables = Exact<{
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<PatientCaseWhereInput>;
}>;


export type ListPatientCasesQuery = { __typename?: 'Query', listPatientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', cursor: string, node: { __typename?: 'PatientCase', id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListPatientCasesWithContentQueryVariables = Exact<{
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<PatientCaseWhereInput>;
}>;


export type ListPatientCasesWithContentQuery = { __typename?: 'Query', listPatientCases: { __typename?: 'PatientCaseConnection', edges: Array<{ __typename?: 'PatientCaseEdge', cursor: string, node: { __typename?: 'PatientCase', stringifiedContent: string, id: string, legacyCaseId: string, name: string, purchaseOrderNbr?: string | null, creationDate: Date, clientName?: string | null, client?: { __typename?: 'Client', id: string, name: string, createdAt: Date } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type CreateOrUpdateSlideStatsMutationVariables = Exact<{
  data: CreateOrUpdateSlideStatsDto;
}>;


export type CreateOrUpdateSlideStatsMutation = { __typename?: 'Mutation', createOrUpdateSlideStats: { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string } };

export type GetSlideStatsQueryVariables = Exact<{
  where: SlideStatsWhereUniqueInput;
}>;


export type GetSlideStatsQuery = { __typename?: 'Query', getSlideStats?: { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string } | null };

export type ListSlideStatsQueryVariables = Exact<{
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  where?: InputMaybe<SlideStatsWhereInput>;
}>;


export type ListSlideStatsQuery = { __typename?: 'Query', listSlideStats: { __typename?: 'SlideStatsConnection', edges: Array<{ __typename?: 'SlideStatsEdge', node: { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type OnCreateSlideStatsSubscriptionVariables = Exact<{
  where?: InputMaybe<SlideStatsWhereInput>;
}>;


export type OnCreateSlideStatsSubscription = { __typename?: 'Subscription', onCreateSlideStats: { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string } };

export type OnUpdateSlideStatsSubscriptionVariables = Exact<{
  where?: InputMaybe<SlideStatsWhereInput>;
}>;


export type OnUpdateSlideStatsSubscription = { __typename?: 'Subscription', onUpdateSlideStats: { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string } };

export type OnDeleteSlideStatsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteSlideStatsSubscription = { __typename?: 'Subscription', onDeleteSlideStats: { __typename?: 'SlideStats', id: string, createdAt: Date, updatedAt: Date, patientCaseId: string, slideId: string, time: number, meetingId: string } };

export type CreateTeamMutationVariables = Exact<{
  data: CreateTeamInputDto;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type GetTeamQueryVariables = Exact<{
  where: TeamWhereUniqueInput;
}>;


export type GetTeamQuery = { __typename?: 'Query', getTeam?: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } | null };

export type ListTeamsQueryVariables = Exact<{
  where?: InputMaybe<TeamWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListTeamsQuery = { __typename?: 'Query', listTeams: { __typename?: 'TeamConnection', totalCount: number, edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListTeamswithMembersQueryVariables = Exact<{
  where?: InputMaybe<TeamWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
  memberPaginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListTeamswithMembersQuery = { __typename?: 'Query', listTeams: { __typename?: 'TeamConnection', totalCount: number, edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null, members: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UpdateTeamMutationVariables = Exact<{
  data: UpdateTeamInputDto;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type DeleteTeamMutationVariables = Exact<{
  where: TeamWhereUniqueInput;
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type AddUserToTeamMutationVariables = Exact<{
  data: ChangeUserToTeamInputDto;
}>;


export type AddUserToTeamMutation = { __typename?: 'Mutation', addUserToTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type RemoveUserFromTeamMutationVariables = Exact<{
  data: ChangeUserToTeamInputDto;
}>;


export type RemoveUserFromTeamMutation = { __typename?: 'Mutation', removeUserFromTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type SetTechnicalManagerMutationVariables = Exact<{
  data: SetTechnicalManagerInputDto;
}>;


export type SetTechnicalManagerMutation = { __typename?: 'Mutation', setTechnicalManager: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type OnCreateTeamSubscriptionVariables = Exact<{
  where?: InputMaybe<TeamWhereInput>;
}>;


export type OnCreateTeamSubscription = { __typename?: 'Subscription', onCreateTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type OnUpdateTeamSubscriptionVariables = Exact<{
  where?: InputMaybe<TeamWhereInput>;
}>;


export type OnUpdateTeamSubscription = { __typename?: 'Subscription', onUpdateTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type OnDeleteTeamSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteTeamSubscription = { __typename?: 'Subscription', onDeleteTeam: { __typename?: 'Team', id: string, name: string, createdAt: Date, updatedAt: Date, technicalManagerId?: string | null } };

export type CreateExplicitUserAccessMutationVariables = Exact<{
  data: CreateExplicitUserAccessInputDto;
}>;


export type CreateExplicitUserAccessMutation = { __typename?: 'Mutation', createExplicitUserAccess: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } };

export type ListExplicitUserAccessesQueryVariables = Exact<{
  where?: InputMaybe<ExplicitUserAccessWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListExplicitUserAccessesQuery = { __typename?: 'Query', listExplicitUserAccesses: { __typename?: 'ExplicitUserAccessConnection', edges: Array<{ __typename?: 'ExplicitUserAccessEdge', cursor: string, node: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type DeleteExplicitUserAccessMutationVariables = Exact<{
  where: ExplicitUserAccessWhereUniqueInput;
}>;


export type DeleteExplicitUserAccessMutation = { __typename?: 'Mutation', deleteExplicitUserAccess: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } };

export type OnCreateExplicitUserAccessSubscriptionVariables = Exact<{
  where?: InputMaybe<ExplicitUserAccessWhereInput>;
}>;


export type OnCreateExplicitUserAccessSubscription = { __typename?: 'Subscription', onCreateExplicitUserAccess: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } };

export type OnUpdateExplicitUserAccessSubscriptionVariables = Exact<{
  where?: InputMaybe<ExplicitUserAccessWhereInput>;
}>;


export type OnUpdateExplicitUserAccessSubscription = { __typename?: 'Subscription', onUpdateExplicitUserAccess: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } };

export type OnDeleteExplicitUserAccessSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteExplicitUserAccessSubscription = { __typename?: 'Subscription', onDeleteExplicitUserAccess: { __typename?: 'ExplicitUserAccess', id: string, createdAt: Date, updatedAt: Date, type: string, userId: string, meetingId?: string | null, masterClassId?: string | null, accessGranterId?: string | null, validUntil: Date } };

export type ListUserMeetingJoinsQueryVariables = Exact<{
  where?: InputMaybe<UserMeetingJoinWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListUserMeetingJoinsQuery = { __typename?: 'Query', listUserMeetingJoins: { __typename?: 'UserMeetingJoinConnection', edges: Array<{ __typename?: 'UserMeetingJoinEdge', cursor: string, node: { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListUserMeetingJoinsWithUsersQueryVariables = Exact<{
  where?: InputMaybe<UserMeetingJoinWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListUserMeetingJoinsWithUsersQuery = { __typename?: 'Query', listUserMeetingJoins: { __typename?: 'UserMeetingJoinConnection', edges: Array<{ __typename?: 'UserMeetingJoinEdge', cursor: string, node: { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string, user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListMeetingLiveParticipantsQueryVariables = Exact<{
  meetingId: Scalars['String']['input'];
}>;


export type ListMeetingLiveParticipantsQuery = { __typename?: 'Query', listMeetingLiveParticipants: { __typename?: 'LiveMeetingParticipants', meetingId: string, count: number, participants: Array<{ __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string }> } };

export type JoinMeetingParticipantsMutationVariables = Exact<{
  meetingId: Scalars['String']['input'];
}>;


export type JoinMeetingParticipantsMutation = { __typename?: 'Mutation', joinMeetingParticipants: { __typename?: 'LiveMeetingParticipants', meetingId: string, count: number, participants: Array<{ __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string }> } };

export type LeaveMeetingParticipantsMutationVariables = Exact<{
  meetingId: Scalars['String']['input'];
}>;


export type LeaveMeetingParticipantsMutation = { __typename?: 'Mutation', leaveMeetingParticipants?: { __typename?: 'LiveMeetingParticipants', meetingId: string, count: number, participants: Array<{ __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string }> } | null };

export type MeetingParticipantsHeartbeatMutationVariables = Exact<{
  meetingId: Scalars['String']['input'];
}>;


export type MeetingParticipantsHeartbeatMutation = { __typename?: 'Mutation', meetingParticipantsHeartbeat: boolean };

export type OnCreateUserMeetingJoinSubscriptionVariables = Exact<{
  where?: InputMaybe<UserMeetingJoinWhereInput>;
}>;


export type OnCreateUserMeetingJoinSubscription = { __typename?: 'Subscription', onCreateUserMeetingJoin: { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string } };

export type OnDeleteUserMeetingJoinSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteUserMeetingJoinSubscription = { __typename?: 'Subscription', onDeleteUserMeetingJoin: { __typename?: 'UserMeetingJoin', id: string, createdAt: Date, updatedAt: Date, userId: string, meetingId: string } };

export type OnMeetingLiveParticipantsChangeSubscriptionVariables = Exact<{
  meetingId: Scalars['String']['input'];
}>;


export type OnMeetingLiveParticipantsChangeSubscription = { __typename?: 'Subscription', onMeetingLiveParticipantsChange: { __typename?: 'MeetingParticipantsChangePacket', type: MeetingParticipantsChangeType, user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } } };

export type GetUserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } | null };

export type ListUsersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  orderByArgs?: InputMaybe<OrderByArgs>;
  paginationArgs?: InputMaybe<PaginationArgs>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInputDto;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserResult', temporaryPassword: string, user: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } } };

export type OnCreateUserSubscriptionVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
}>;


export type OnCreateUserSubscription = { __typename?: 'Subscription', onCreateUser: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type OnUpdateUserSubscriptionVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
}>;


export type OnUpdateUserSubscription = { __typename?: 'Subscription', onUpdateUser: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export type OnDeleteUserSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteUserSubscription = { __typename?: 'Subscription', onDeleteUser: { __typename?: 'User', id: string, email: string, createdAt: Date, isGuest: boolean, clientId?: string | null, teamId?: string | null, clientRole: string } };

export const AssetViewFieldsFragmentDoc = gql`
    fragment AssetViewFields on AssetView {
  id
  createdAt
  updatedAt
  patientCaseId
  timeWatched
  userId
  meetingId
  assetId
}
    `;
export const ClientFieldsFragmentDoc = gql`
    fragment ClientFields on Client {
  id
  name
  createdAt
}
    `;
export const CaseClusterRelationClientsFragmentDoc = gql`
    fragment CaseClusterRelationClients on CaseCluster {
  clients(paginationArgs: $clientsPaginationArgs) {
    edges {
      node {
        ...ClientFields
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}`;
export const MeetingFieldsFragmentDoc = gql`
    fragment MeetingFields on Meeting {
  id
  name
  createdAt
  updatedAt
  hostId
  hostFullName
  eventDate
  startDate
  endDate
  eventLocation
  purchaseOrderNbr
  meetingNotes
  meetingType
  streamUrl
  isMock
  isInTesting
  isArchived
  isDemo
  administrativeStatus
  caseClusterId
  createdById
}
    `;
export const CaseClusterRelationMeetingsFragmentDoc = gql`
    fragment CaseClusterRelationMeetings on CaseCluster {
  meetings(paginationArgs: $meetingsPaginationArgs) {
    edges {
      node {
        ...MeetingFields
      }
    }
  }
}
    ${MeetingFieldsFragmentDoc}`;
export const CertificationProgressFieldsFragmentDoc = gql`
    fragment CertificationProgressFields on CertificationProgress {
  id
  userId
  caseId
  masterclassId
  attemptNumber
  currentQuestion
  answers
  score
  passed
  startedAt
  completedAt
  updatedAt
}
    `;
export const ExplicitUserAccessFieldsFragmentDoc = gql`
    fragment ExplicitUserAccessFields on ExplicitUserAccess {
  id
  createdAt
  updatedAt
  type
  userId
  meetingId
  masterClassId
  accessGranterId
  validUntil
}
    `;
export const MasterclassLoginLogsFieldsFragmentDoc = gql`
    fragment MasterclassLoginLogsFields on MasterclassLoginLogs {
  id
  userId
  createdAt
  loggedInAt
}
    `;
export const MasterclassRatingsFieldsFragmentDoc = gql`
    fragment MasterclassRatingsFields on MasterclassRatings {
  id
  userId
  caseId
  masterclassId
  certificationProgressId
  applicationRating
  masterclassRating
  createdAt
}
    `;
export const MasterClassUserSessionFieldsFragmentDoc = gql`
    fragment MasterClassUserSessionFields on MasterClassUserSession {
  id
  userId
  masterClassId
  caseId
  currentSlideId
  currentCaseId
  celebrationShown
  completed
  scorePercentage
  visitedSlideIds
}
    `;
export const MasterclassUserStatisticsFieldsFragmentDoc = gql`
    fragment MasterclassUserStatisticsFields on MasterclassUserStatistics {
  id
  userId
  caseId
  caseSelectorVisits
  caseClicks
  completions
  createdAt
  updatedAt
}
    `;
export const MasterClassFieldsFragmentDoc = gql`
    fragment MasterClassFields on MasterClass {
  id
  title
  _count {
    patientCases
  }
}
    `;
export const MasterClassWithSessionFieldsFragmentDoc = gql`
    fragment MasterClassWithSessionFields on MasterClass {
  id
  title
  _count {
    patientCases
  }
  mySessions(paginationArgs: {first: 100}) {
    edges {
      node {
        id
        userId
        masterClassId
        currentSlideId
        currentCaseId
        celebrationShown
        completed
        scorePercentage
        visitedSlideIds
        caseId
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
  mySessionStats {
    completedCasesCount
    startedCasesCount
    totalCases
    hasStartedAny
    isFullyCompleted
  }
  patientCases {
    edges {
      node {
        id
        legacyCaseId
        name
      }
    }
  }
}
    `;
export const MasterClassRelationClientsFragmentDoc = gql`
    fragment MasterClassRelationClients on MasterClass {
  clients(paginationArgs: $clientsPaginationArgs) {
    edges {
      node {
        ...ClientFields
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}`;
export const UnloadedPatientCaseFieldsFragmentDoc = gql`
    fragment UnloadedPatientCaseFields on PatientCase {
  id
  legacyCaseId
  name
  purchaseOrderNbr
  creationDate
  clientName
  client {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export const MasterClassRelationPatientCasesFragmentDoc = gql`
    fragment MasterClassRelationPatientCases on MasterClass {
  patientCases(paginationArgs: $patientCasesPaginationArgs) {
    edges {
      node {
        ...UnloadedPatientCaseFields
      }
    }
  }
}
    ${UnloadedPatientCaseFieldsFragmentDoc}`;
export const AccessLinkFieldsFragmentDoc = gql`
    fragment AccessLinkFields on AccessLink {
  id
  createdAt
  updatedAt
  purpose
  accessCode
  isEnabled
  validUntil
  usageCountLeft
  metadata
  linkFirstAccount
  objId
  meetingId
  masterClassId
  patientCaseId
}
    `;
export const MasterClassRelationAccessLinksFragmentDoc = gql`
    fragment MasterClassRelationAccessLinks on MasterClass {
  accessLinks(paginationArgs: $accessLinksPaginationArgs) {
    edges {
      node {
        ...AccessLinkFields
      }
    }
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export const MasterClassMyAccessFragmentDoc = gql`
    fragment MasterClassMyAccess on MasterClass {
  hasReviewerAccess
}
    `;
export const MeetingRelationAccessLinkFragmentDoc = gql`
    fragment MeetingRelationAccessLink on Meeting {
  accessLinks(paginationArgs: $accessLinkPaginationArgs) {
    edges {
      node {
        ...AccessLinkFields
      }
    }
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  email
  createdAt
  isGuest
  clientId
  teamId
  clientRole
}
    `;
export const MeetingRelationHostFragmentDoc = gql`
    fragment MeetingRelationHost on Meeting {
  host {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const CaseClusterFieldsFragmentDoc = gql`
    fragment CaseClusterFields on CaseCluster {
  id
  name
  createdAt
  updatedAt
  isMock
  cases {
    edges {
      node {
        ...UnloadedPatientCaseFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${UnloadedPatientCaseFieldsFragmentDoc}`;
export const MeetingRelationCaseClusterFragmentDoc = gql`
    fragment MeetingRelationCaseCluster on Meeting {
  caseCluster {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;
export const MeetingRelationClientsFragmentDoc = gql`
    fragment MeetingRelationClients on Meeting {
  clients(paginationArgs: $clientsPaginationArgs) {
    edges {
      node {
        ...ClientFields
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}`;
export const TeamFieldsFragmentDoc = gql`
    fragment TeamFields on Team {
  id
  name
  createdAt
  updatedAt
  technicalManagerId
}
    `;
export const MeetingRelationTeamsFragmentDoc = gql`
    fragment MeetingRelationTeams on Meeting {
  teams(paginationArgs: $teamPaginationArgs) {
    edges {
      node {
        ...TeamFields
      }
    }
  }
}
    ${TeamFieldsFragmentDoc}`;
export const UserMeetingJoinFieldsFragmentDoc = gql`
    fragment UserMeetingJoinFields on UserMeetingJoin {
  id
  createdAt
  updatedAt
  userId
  meetingId
}
    `;
export const MeetingRelationUserMeetingJoinsFragmentDoc = gql`
    fragment MeetingRelationUserMeetingJoins on Meeting {
  userMeetingJoins(paginationArgs: $userMeetingJoinsPaginationArgs) {
    edges {
      node {
        ...UserMeetingJoinFields
      }
    }
  }
}
    ${UserMeetingJoinFieldsFragmentDoc}`;
export const MeetingStatsFieldsFragmentDoc = gql`
    fragment MeetingStatsFields on MeetingStats {
  id
  createdAt
  updatedAt
  casePresentationHistory
  amountParticipants
  meetingId
}
    `;
export const MeetingRelationMeetingStatsFragmentDoc = gql`
    fragment MeetingRelationMeetingStats on Meeting {
  stats {
    ...MeetingStatsFields
  }
}
    ${MeetingStatsFieldsFragmentDoc}`;
export const HostFieldsFieldsFragmentDoc = gql`
    fragment HostFieldsFields on HostFields {
  id
  currentCase
  currentSlide
  currentAssetID
  meetingId
}
    `;
export const MeetingRelationHostFieldsFragmentDoc = gql`
    fragment MeetingRelationHostFields on Meeting {
  hostFields {
    ...HostFieldsFields
  }
}
    ${HostFieldsFieldsFragmentDoc}`;
export const PatientCaseFieldsFragmentDoc = gql`
    fragment PatientCaseFields on PatientCase {
  ...UnloadedPatientCaseFields
  stringifiedContent
}
    ${UnloadedPatientCaseFieldsFragmentDoc}`;
export const PatientCaseRelationCaseClusterFragmentDoc = gql`
    fragment PatientCaseRelationCaseCluster on PatientCase {
  caseClusters {
    edges {
      node {
        ...CaseClusterFields
      }
    }
  }
}
    ${CaseClusterFieldsFragmentDoc}`;
export const PatientCaseRelationClientFragmentDoc = gql`
    fragment PatientCaseRelationClient on PatientCase {
  client {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export const SlideStatsFieldsFragmentDoc = gql`
    fragment SlideStatsFields on SlideStats {
  id
  createdAt
  updatedAt
  patientCaseId
  slideId
  time
  meetingId
}
    `;
export const LiveMeetingParticipantsFieldsFragmentDoc = gql`
    fragment LiveMeetingParticipantsFields on LiveMeetingParticipants {
  meetingId
  count
  participants {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const MeetingParticipantsChangePacketFieldsFragmentDoc = gql`
    fragment MeetingParticipantsChangePacketFields on MeetingParticipantsChangePacket {
  type
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UserMeetingJoinRelationUserFragmentDoc = gql`
    fragment UserMeetingJoinRelationUser on UserMeetingJoin {
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UserRelationClientFragmentDoc = gql`
    fragment UserRelationClient on User {
  client {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export const AnswerFieldsFragmentDoc = gql`
    fragment AnswerFields on Answer {
  id
  createdAt
  updatedAt
  slideId
  patientCaseId
  userId
  meetingId
  masterClassUserSessionId
  answerIndexes
  answerTexts
}
    `;
export const AnswerRelationUserFragmentDoc = gql`
    fragment AnswerRelationUser on Answer {
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  createdAt
  updatedAt
  body
  meetingId
  userId
}
    `;
export const NpsScoreFieldsFragmentDoc = gql`
    fragment NPSScoreFields on NPSScore {
  id
  createdAt
  updatedAt
  scores
  userId
  meetingId
}
    `;
export const MeetingStatsViewContextDocument = gql`
    query MeetingStatsViewContext($where: MeetingWhereUniqueInput!) {
  getMeeting(where: $where) {
    ...MeetingFields
    ...MeetingRelationCaseCluster
  }
}
    ${MeetingFieldsFragmentDoc}
${MeetingRelationCaseClusterFragmentDoc}`;

/**
 * __useMeetingStatsViewContextQuery__
 *
 * To run a query within a React component, call `useMeetingStatsViewContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingStatsViewContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingStatsViewContextQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMeetingStatsViewContextQuery(baseOptions: Apollo.QueryHookOptions<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables> & ({ variables: MeetingStatsViewContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables>(MeetingStatsViewContextDocument, options);
      }
export function useMeetingStatsViewContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables>(MeetingStatsViewContextDocument, options);
        }
export function useMeetingStatsViewContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables>(MeetingStatsViewContextDocument, options);
        }
export type MeetingStatsViewContextQueryHookResult = ReturnType<typeof useMeetingStatsViewContextQuery>;
export type MeetingStatsViewContextLazyQueryHookResult = ReturnType<typeof useMeetingStatsViewContextLazyQuery>;
export type MeetingStatsViewContextSuspenseQueryHookResult = ReturnType<typeof useMeetingStatsViewContextSuspenseQuery>;
export type MeetingStatsViewContextQueryResult = Apollo.QueryResult<MeetingStatsViewContextQuery, MeetingStatsViewContextQueryVariables>;
export const CurrentMeetingDataContextProviderQueryDocument = gql`
    query CurrentMeetingDataContextProviderQuery($where: MeetingWhereUniqueInput!) {
  getMeeting(where: $where) {
    ...MeetingFields
    ...MeetingRelationCaseCluster
  }
}
    ${MeetingFieldsFragmentDoc}
${MeetingRelationCaseClusterFragmentDoc}`;

/**
 * __useCurrentMeetingDataContextProviderQueryQuery__
 *
 * To run a query within a React component, call `useCurrentMeetingDataContextProviderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMeetingDataContextProviderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMeetingDataContextProviderQueryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCurrentMeetingDataContextProviderQueryQuery(baseOptions: Apollo.QueryHookOptions<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables> & ({ variables: CurrentMeetingDataContextProviderQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables>(CurrentMeetingDataContextProviderQueryDocument, options);
      }
export function useCurrentMeetingDataContextProviderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables>(CurrentMeetingDataContextProviderQueryDocument, options);
        }
export function useCurrentMeetingDataContextProviderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables>(CurrentMeetingDataContextProviderQueryDocument, options);
        }
export type CurrentMeetingDataContextProviderQueryQueryHookResult = ReturnType<typeof useCurrentMeetingDataContextProviderQueryQuery>;
export type CurrentMeetingDataContextProviderQueryLazyQueryHookResult = ReturnType<typeof useCurrentMeetingDataContextProviderQueryLazyQuery>;
export type CurrentMeetingDataContextProviderQuerySuspenseQueryHookResult = ReturnType<typeof useCurrentMeetingDataContextProviderQuerySuspenseQuery>;
export type CurrentMeetingDataContextProviderQueryQueryResult = Apollo.QueryResult<CurrentMeetingDataContextProviderQueryQuery, CurrentMeetingDataContextProviderQueryQueryVariables>;
export const AdminCaseClusterListViewDocument = gql`
    query AdminCaseClusterListView($where: CaseClusterWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs, $meetingsPaginationArgs: PaginationArgs, $clientsPaginationArgs: PaginationArgs) {
  listCaseClusters(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...CaseClusterFields
        ...CaseClusterRelationClients
        ...CaseClusterRelationMeetings
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${CaseClusterFieldsFragmentDoc}
${CaseClusterRelationClientsFragmentDoc}
${CaseClusterRelationMeetingsFragmentDoc}`;

/**
 * __useAdminCaseClusterListViewQuery__
 *
 * To run a query within a React component, call `useAdminCaseClusterListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCaseClusterListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCaseClusterListViewQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *      meetingsPaginationArgs: // value for 'meetingsPaginationArgs'
 *      clientsPaginationArgs: // value for 'clientsPaginationArgs'
 *   },
 * });
 */
export function useAdminCaseClusterListViewQuery(baseOptions?: Apollo.QueryHookOptions<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>(AdminCaseClusterListViewDocument, options);
      }
export function useAdminCaseClusterListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>(AdminCaseClusterListViewDocument, options);
        }
export function useAdminCaseClusterListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>(AdminCaseClusterListViewDocument, options);
        }
export type AdminCaseClusterListViewQueryHookResult = ReturnType<typeof useAdminCaseClusterListViewQuery>;
export type AdminCaseClusterListViewLazyQueryHookResult = ReturnType<typeof useAdminCaseClusterListViewLazyQuery>;
export type AdminCaseClusterListViewSuspenseQueryHookResult = ReturnType<typeof useAdminCaseClusterListViewSuspenseQuery>;
export type AdminCaseClusterListViewQueryResult = Apollo.QueryResult<AdminCaseClusterListViewQuery, AdminCaseClusterListViewQueryVariables>;
export const AdminCaseListViewDocument = gql`
    query AdminCaseListView($paginationArgs: PaginationArgs!, $orderByArgs: OrderByArgs, $where: PatientCaseWhereInput) {
  listPatientCases(
    paginationArgs: $paginationArgs
    orderByArgs: $orderByArgs
    where: $where
  ) {
    edges {
      node {
        ...PatientCaseFields
        ...PatientCaseRelationCaseCluster
        ...PatientCaseRelationClient
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${PatientCaseFieldsFragmentDoc}
${PatientCaseRelationCaseClusterFragmentDoc}
${PatientCaseRelationClientFragmentDoc}`;

/**
 * __useAdminCaseListViewQuery__
 *
 * To run a query within a React component, call `useAdminCaseListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCaseListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCaseListViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      orderByArgs: // value for 'orderByArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminCaseListViewQuery(baseOptions: Apollo.QueryHookOptions<AdminCaseListViewQuery, AdminCaseListViewQueryVariables> & ({ variables: AdminCaseListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCaseListViewQuery, AdminCaseListViewQueryVariables>(AdminCaseListViewDocument, options);
      }
export function useAdminCaseListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCaseListViewQuery, AdminCaseListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCaseListViewQuery, AdminCaseListViewQueryVariables>(AdminCaseListViewDocument, options);
        }
export function useAdminCaseListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCaseListViewQuery, AdminCaseListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCaseListViewQuery, AdminCaseListViewQueryVariables>(AdminCaseListViewDocument, options);
        }
export type AdminCaseListViewQueryHookResult = ReturnType<typeof useAdminCaseListViewQuery>;
export type AdminCaseListViewLazyQueryHookResult = ReturnType<typeof useAdminCaseListViewLazyQuery>;
export type AdminCaseListViewSuspenseQueryHookResult = ReturnType<typeof useAdminCaseListViewSuspenseQuery>;
export type AdminCaseListViewQueryResult = Apollo.QueryResult<AdminCaseListViewQuery, AdminCaseListViewQueryVariables>;
export const GetClickupLiveEventTasksDocument = gql`
    query GetClickupLiveEventTasks {
  getClickupLiveEventTasks
}
    `;

/**
 * __useGetClickupLiveEventTasksQuery__
 *
 * To run a query within a React component, call `useGetClickupLiveEventTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClickupLiveEventTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClickupLiveEventTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClickupLiveEventTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>(GetClickupLiveEventTasksDocument, options);
      }
export function useGetClickupLiveEventTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>(GetClickupLiveEventTasksDocument, options);
        }
export function useGetClickupLiveEventTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>(GetClickupLiveEventTasksDocument, options);
        }
export type GetClickupLiveEventTasksQueryHookResult = ReturnType<typeof useGetClickupLiveEventTasksQuery>;
export type GetClickupLiveEventTasksLazyQueryHookResult = ReturnType<typeof useGetClickupLiveEventTasksLazyQuery>;
export type GetClickupLiveEventTasksSuspenseQueryHookResult = ReturnType<typeof useGetClickupLiveEventTasksSuspenseQuery>;
export type GetClickupLiveEventTasksQueryResult = Apollo.QueryResult<GetClickupLiveEventTasksQuery, GetClickupLiveEventTasksQueryVariables>;
export const AdminClientListViewDocument = gql`
    query AdminClientListView($paginationArgs: PaginationArgs!, $orderByArgs: OrderByArgs, $where: ClientWhereInput) {
  listClients(
    paginationArgs: $paginationArgs
    orderByArgs: $orderByArgs
    where: $where
  ) {
    edges {
      node {
        ...ClientFields
        meetings {
          edges {
            node {
              ...MeetingFields
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${ClientFieldsFragmentDoc}
${MeetingFieldsFragmentDoc}`;

/**
 * __useAdminClientListViewQuery__
 *
 * To run a query within a React component, call `useAdminClientListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClientListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClientListViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      orderByArgs: // value for 'orderByArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminClientListViewQuery(baseOptions: Apollo.QueryHookOptions<AdminClientListViewQuery, AdminClientListViewQueryVariables> & ({ variables: AdminClientListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClientListViewQuery, AdminClientListViewQueryVariables>(AdminClientListViewDocument, options);
      }
export function useAdminClientListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClientListViewQuery, AdminClientListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClientListViewQuery, AdminClientListViewQueryVariables>(AdminClientListViewDocument, options);
        }
export function useAdminClientListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminClientListViewQuery, AdminClientListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminClientListViewQuery, AdminClientListViewQueryVariables>(AdminClientListViewDocument, options);
        }
export type AdminClientListViewQueryHookResult = ReturnType<typeof useAdminClientListViewQuery>;
export type AdminClientListViewLazyQueryHookResult = ReturnType<typeof useAdminClientListViewLazyQuery>;
export type AdminClientListViewSuspenseQueryHookResult = ReturnType<typeof useAdminClientListViewSuspenseQuery>;
export type AdminClientListViewQueryResult = Apollo.QueryResult<AdminClientListViewQuery, AdminClientListViewQueryVariables>;
export const AdminMasterClassListViewDocument = gql`
    query AdminMasterClassListView($paginationArgs: PaginationArgs!, $orderByArgs: OrderByArgs, $where: MasterClassWhereInput, $clientsPaginationArgs: PaginationArgs, $patientCasesPaginationArgs: PaginationArgs, $accessLinksPaginationArgs: PaginationArgs) {
  listMasterClasses(
    paginationArgs: $paginationArgs
    orderByArgs: $orderByArgs
    where: $where
  ) {
    edges {
      node {
        ...MasterClassFields
        ...MasterClassRelationAccessLinks
        ...MasterClassRelationClients
        ...MasterClassRelationPatientCases
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${MasterClassFieldsFragmentDoc}
${MasterClassRelationAccessLinksFragmentDoc}
${MasterClassRelationClientsFragmentDoc}
${MasterClassRelationPatientCasesFragmentDoc}`;

/**
 * __useAdminMasterClassListViewQuery__
 *
 * To run a query within a React component, call `useAdminMasterClassListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMasterClassListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMasterClassListViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      orderByArgs: // value for 'orderByArgs'
 *      where: // value for 'where'
 *      clientsPaginationArgs: // value for 'clientsPaginationArgs'
 *      patientCasesPaginationArgs: // value for 'patientCasesPaginationArgs'
 *      accessLinksPaginationArgs: // value for 'accessLinksPaginationArgs'
 *   },
 * });
 */
export function useAdminMasterClassListViewQuery(baseOptions: Apollo.QueryHookOptions<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables> & ({ variables: AdminMasterClassListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables>(AdminMasterClassListViewDocument, options);
      }
export function useAdminMasterClassListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables>(AdminMasterClassListViewDocument, options);
        }
export function useAdminMasterClassListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables>(AdminMasterClassListViewDocument, options);
        }
export type AdminMasterClassListViewQueryHookResult = ReturnType<typeof useAdminMasterClassListViewQuery>;
export type AdminMasterClassListViewLazyQueryHookResult = ReturnType<typeof useAdminMasterClassListViewLazyQuery>;
export type AdminMasterClassListViewSuspenseQueryHookResult = ReturnType<typeof useAdminMasterClassListViewSuspenseQuery>;
export type AdminMasterClassListViewQueryResult = Apollo.QueryResult<AdminMasterClassListViewQuery, AdminMasterClassListViewQueryVariables>;
export const AdminMeetingListViewDocument = gql`
    query AdminMeetingListView($paginationArgs: PaginationArgs!, $orderByArgs: OrderByArgs, $where: MeetingWhereInput, $clientsPaginationArgs: PaginationArgs, $teamPaginationArgs: PaginationArgs, $userMeetingJoinsPaginationArgs: PaginationArgs, $accessLinkPaginationArgs: PaginationArgs) {
  listMeetings(
    paginationArgs: $paginationArgs
    orderByArgs: $orderByArgs
    where: $where
  ) {
    edges {
      node {
        ...MeetingFields
        ...MeetingRelationAccessLink
        ...MeetingRelationHost
        ...MeetingRelationCaseCluster
        ...MeetingRelationClients
        ...MeetingRelationTeams
        ...MeetingRelationUserMeetingJoins
        ...MeetingRelationHostFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${MeetingFieldsFragmentDoc}
${MeetingRelationAccessLinkFragmentDoc}
${MeetingRelationHostFragmentDoc}
${MeetingRelationCaseClusterFragmentDoc}
${MeetingRelationClientsFragmentDoc}
${MeetingRelationTeamsFragmentDoc}
${MeetingRelationUserMeetingJoinsFragmentDoc}
${MeetingRelationHostFieldsFragmentDoc}`;

/**
 * __useAdminMeetingListViewQuery__
 *
 * To run a query within a React component, call `useAdminMeetingListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMeetingListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMeetingListViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      orderByArgs: // value for 'orderByArgs'
 *      where: // value for 'where'
 *      clientsPaginationArgs: // value for 'clientsPaginationArgs'
 *      teamPaginationArgs: // value for 'teamPaginationArgs'
 *      userMeetingJoinsPaginationArgs: // value for 'userMeetingJoinsPaginationArgs'
 *      accessLinkPaginationArgs: // value for 'accessLinkPaginationArgs'
 *   },
 * });
 */
export function useAdminMeetingListViewQuery(baseOptions: Apollo.QueryHookOptions<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables> & ({ variables: AdminMeetingListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables>(AdminMeetingListViewDocument, options);
      }
export function useAdminMeetingListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables>(AdminMeetingListViewDocument, options);
        }
export function useAdminMeetingListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables>(AdminMeetingListViewDocument, options);
        }
export type AdminMeetingListViewQueryHookResult = ReturnType<typeof useAdminMeetingListViewQuery>;
export type AdminMeetingListViewLazyQueryHookResult = ReturnType<typeof useAdminMeetingListViewLazyQuery>;
export type AdminMeetingListViewSuspenseQueryHookResult = ReturnType<typeof useAdminMeetingListViewSuspenseQuery>;
export type AdminMeetingListViewQueryResult = Apollo.QueryResult<AdminMeetingListViewQuery, AdminMeetingListViewQueryVariables>;
export const AdminUserListViewDocument = gql`
    query AdminUserListView($paginationArgs: PaginationArgs!, $orderByArgs: OrderByArgs, $where: UserWhereInput) {
  listUsers(
    paginationArgs: $paginationArgs
    orderByArgs: $orderByArgs
    where: $where
  ) {
    edges {
      node {
        ...UserFields
        client {
          ...ClientFields
        }
        team {
          ...TeamFields
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${UserFieldsFragmentDoc}
${ClientFieldsFragmentDoc}
${TeamFieldsFragmentDoc}`;

/**
 * __useAdminUserListViewQuery__
 *
 * To run a query within a React component, call `useAdminUserListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserListViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      orderByArgs: // value for 'orderByArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminUserListViewQuery(baseOptions: Apollo.QueryHookOptions<AdminUserListViewQuery, AdminUserListViewQueryVariables> & ({ variables: AdminUserListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserListViewQuery, AdminUserListViewQueryVariables>(AdminUserListViewDocument, options);
      }
export function useAdminUserListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserListViewQuery, AdminUserListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserListViewQuery, AdminUserListViewQueryVariables>(AdminUserListViewDocument, options);
        }
export function useAdminUserListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUserListViewQuery, AdminUserListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUserListViewQuery, AdminUserListViewQueryVariables>(AdminUserListViewDocument, options);
        }
export type AdminUserListViewQueryHookResult = ReturnType<typeof useAdminUserListViewQuery>;
export type AdminUserListViewLazyQueryHookResult = ReturnType<typeof useAdminUserListViewLazyQuery>;
export type AdminUserListViewSuspenseQueryHookResult = ReturnType<typeof useAdminUserListViewSuspenseQuery>;
export type AdminUserListViewQueryResult = Apollo.QueryResult<AdminUserListViewQuery, AdminUserListViewQueryVariables>;
export const MeetingUserAccessListViewDocument = gql`
    query MeetingUserAccessListView($paginationArgs: PaginationArgs!, $where: UserWhereInput) {
  listUsers(paginationArgs: $paginationArgs, where: $where) {
    edges {
      node {
        ...UserFields
        ...UserRelationClient
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserRelationClientFragmentDoc}`;

/**
 * __useMeetingUserAccessListViewQuery__
 *
 * To run a query within a React component, call `useMeetingUserAccessListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingUserAccessListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingUserAccessListViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMeetingUserAccessListViewQuery(baseOptions: Apollo.QueryHookOptions<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables> & ({ variables: MeetingUserAccessListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables>(MeetingUserAccessListViewDocument, options);
      }
export function useMeetingUserAccessListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables>(MeetingUserAccessListViewDocument, options);
        }
export function useMeetingUserAccessListViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables>(MeetingUserAccessListViewDocument, options);
        }
export type MeetingUserAccessListViewQueryHookResult = ReturnType<typeof useMeetingUserAccessListViewQuery>;
export type MeetingUserAccessListViewLazyQueryHookResult = ReturnType<typeof useMeetingUserAccessListViewLazyQuery>;
export type MeetingUserAccessListViewSuspenseQueryHookResult = ReturnType<typeof useMeetingUserAccessListViewSuspenseQuery>;
export type MeetingUserAccessListViewQueryResult = Apollo.QueryResult<MeetingUserAccessListViewQuery, MeetingUserAccessListViewQueryVariables>;
export const UserMeetingAccessViewDocument = gql`
    query UserMeetingAccessView($where: UserWhereUniqueInput!, $meetingPaginationArgs: PaginationArgs) {
  getUser(where: $where) {
    ...UserFields
    client {
      ...ClientFields
    }
    explicitReadAccesses {
      edges {
        node {
          ...ExplicitUserAccessFields
        }
      }
    }
    meetings(paginationArgs: $meetingPaginationArgs) {
      edges {
        node {
          ...MeetingFields
          clients {
            edges {
              node {
                ...ClientFields
              }
            }
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${ClientFieldsFragmentDoc}
${ExplicitUserAccessFieldsFragmentDoc}
${MeetingFieldsFragmentDoc}`;

/**
 * __useUserMeetingAccessViewQuery__
 *
 * To run a query within a React component, call `useUserMeetingAccessViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMeetingAccessViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMeetingAccessViewQuery({
 *   variables: {
 *      where: // value for 'where'
 *      meetingPaginationArgs: // value for 'meetingPaginationArgs'
 *   },
 * });
 */
export function useUserMeetingAccessViewQuery(baseOptions: Apollo.QueryHookOptions<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables> & ({ variables: UserMeetingAccessViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables>(UserMeetingAccessViewDocument, options);
      }
export function useUserMeetingAccessViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables>(UserMeetingAccessViewDocument, options);
        }
export function useUserMeetingAccessViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables>(UserMeetingAccessViewDocument, options);
        }
export type UserMeetingAccessViewQueryHookResult = ReturnType<typeof useUserMeetingAccessViewQuery>;
export type UserMeetingAccessViewLazyQueryHookResult = ReturnType<typeof useUserMeetingAccessViewLazyQuery>;
export type UserMeetingAccessViewSuspenseQueryHookResult = ReturnType<typeof useUserMeetingAccessViewSuspenseQuery>;
export type UserMeetingAccessViewQueryResult = Apollo.QueryResult<UserMeetingAccessViewQuery, UserMeetingAccessViewQueryVariables>;
export const DashboardViewDocument = gql`
    query DashboardView($paginationArgs: PaginationArgs!, $where: MeetingWhereInput, $clientsPaginationArgs: PaginationArgs, $masterClassPaginationArgs: PaginationArgs, $masterClassWhere: MasterClassWhereInput, $patientCasesPaginationArgs: PaginationArgs) {
  listMeetings(paginationArgs: $paginationArgs, where: $where) {
    edges {
      node {
        ...MeetingFields
        ...MeetingRelationCaseCluster
        ...MeetingRelationHost
        ...MeetingRelationClients
        ...MeetingRelationMeetingStats
        ...MeetingRelationHostFields
      }
    }
  }
  listMasterClasses(
    paginationArgs: $masterClassPaginationArgs
    where: $masterClassWhere
  ) {
    edges {
      node {
        ...MasterClassFields
        ...MasterClassRelationPatientCases
      }
    }
  }
}
    ${MeetingFieldsFragmentDoc}
${MeetingRelationCaseClusterFragmentDoc}
${MeetingRelationHostFragmentDoc}
${MeetingRelationClientsFragmentDoc}
${MeetingRelationMeetingStatsFragmentDoc}
${MeetingRelationHostFieldsFragmentDoc}
${MasterClassFieldsFragmentDoc}
${MasterClassRelationPatientCasesFragmentDoc}`;

/**
 * __useDashboardViewQuery__
 *
 * To run a query within a React component, call `useDashboardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardViewQuery({
 *   variables: {
 *      paginationArgs: // value for 'paginationArgs'
 *      where: // value for 'where'
 *      clientsPaginationArgs: // value for 'clientsPaginationArgs'
 *      masterClassPaginationArgs: // value for 'masterClassPaginationArgs'
 *      masterClassWhere: // value for 'masterClassWhere'
 *      patientCasesPaginationArgs: // value for 'patientCasesPaginationArgs'
 *   },
 * });
 */
export function useDashboardViewQuery(baseOptions: Apollo.QueryHookOptions<DashboardViewQuery, DashboardViewQueryVariables> & ({ variables: DashboardViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardViewQuery, DashboardViewQueryVariables>(DashboardViewDocument, options);
      }
export function useDashboardViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardViewQuery, DashboardViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardViewQuery, DashboardViewQueryVariables>(DashboardViewDocument, options);
        }
export function useDashboardViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardViewQuery, DashboardViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardViewQuery, DashboardViewQueryVariables>(DashboardViewDocument, options);
        }
export type DashboardViewQueryHookResult = ReturnType<typeof useDashboardViewQuery>;
export type DashboardViewLazyQueryHookResult = ReturnType<typeof useDashboardViewLazyQuery>;
export type DashboardViewSuspenseQueryHookResult = ReturnType<typeof useDashboardViewSuspenseQuery>;
export type DashboardViewQueryResult = Apollo.QueryResult<DashboardViewQuery, DashboardViewQueryVariables>;
export const IsValidAccessLinkDocument = gql`
    query isValidAccessLink($code: String!) {
  isValidAccessLink(code: $code) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;

/**
 * __useIsValidAccessLinkQuery__
 *
 * To run a query within a React component, call `useIsValidAccessLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsValidAccessLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsValidAccessLinkQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useIsValidAccessLinkQuery(baseOptions: Apollo.QueryHookOptions<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables> & ({ variables: IsValidAccessLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables>(IsValidAccessLinkDocument, options);
      }
export function useIsValidAccessLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables>(IsValidAccessLinkDocument, options);
        }
export function useIsValidAccessLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables>(IsValidAccessLinkDocument, options);
        }
export type IsValidAccessLinkQueryHookResult = ReturnType<typeof useIsValidAccessLinkQuery>;
export type IsValidAccessLinkLazyQueryHookResult = ReturnType<typeof useIsValidAccessLinkLazyQuery>;
export type IsValidAccessLinkSuspenseQueryHookResult = ReturnType<typeof useIsValidAccessLinkSuspenseQuery>;
export type IsValidAccessLinkQueryResult = Apollo.QueryResult<IsValidAccessLinkQuery, IsValidAccessLinkQueryVariables>;
export const CreateAccessLinkDocument = gql`
    mutation createAccessLink($data: CreateReadAccessLinkInputDTO!) {
  createAccessLink(data: $data) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export type CreateAccessLinkMutationFn = Apollo.MutationFunction<CreateAccessLinkMutation, CreateAccessLinkMutationVariables>;

/**
 * __useCreateAccessLinkMutation__
 *
 * To run a mutation, you first call `useCreateAccessLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessLinkMutation, { data, loading, error }] = useCreateAccessLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccessLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccessLinkMutation, CreateAccessLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccessLinkMutation, CreateAccessLinkMutationVariables>(CreateAccessLinkDocument, options);
      }
export type CreateAccessLinkMutationHookResult = ReturnType<typeof useCreateAccessLinkMutation>;
export type CreateAccessLinkMutationResult = Apollo.MutationResult<CreateAccessLinkMutation>;
export type CreateAccessLinkMutationOptions = Apollo.BaseMutationOptions<CreateAccessLinkMutation, CreateAccessLinkMutationVariables>;
export const BatchCreateAccessLinksDocument = gql`
    mutation batchCreateAccessLinks($data: BatchCreateAccessLinksInputDTO!) {
  batchCreateAccessLinks(data: $data) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export type BatchCreateAccessLinksMutationFn = Apollo.MutationFunction<BatchCreateAccessLinksMutation, BatchCreateAccessLinksMutationVariables>;

/**
 * __useBatchCreateAccessLinksMutation__
 *
 * To run a mutation, you first call `useBatchCreateAccessLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateAccessLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateAccessLinksMutation, { data, loading, error }] = useBatchCreateAccessLinksMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBatchCreateAccessLinksMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateAccessLinksMutation, BatchCreateAccessLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateAccessLinksMutation, BatchCreateAccessLinksMutationVariables>(BatchCreateAccessLinksDocument, options);
      }
export type BatchCreateAccessLinksMutationHookResult = ReturnType<typeof useBatchCreateAccessLinksMutation>;
export type BatchCreateAccessLinksMutationResult = Apollo.MutationResult<BatchCreateAccessLinksMutation>;
export type BatchCreateAccessLinksMutationOptions = Apollo.BaseMutationOptions<BatchCreateAccessLinksMutation, BatchCreateAccessLinksMutationVariables>;
export const BatchUpdateAccessLinksDocument = gql`
    mutation batchUpdateAccessLinks($data: BatchUpdateReadAccessLinksInputDTO!) {
  batchUpdateAccessLinks(data: $data) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export type BatchUpdateAccessLinksMutationFn = Apollo.MutationFunction<BatchUpdateAccessLinksMutation, BatchUpdateAccessLinksMutationVariables>;

/**
 * __useBatchUpdateAccessLinksMutation__
 *
 * To run a mutation, you first call `useBatchUpdateAccessLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateAccessLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateAccessLinksMutation, { data, loading, error }] = useBatchUpdateAccessLinksMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBatchUpdateAccessLinksMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateAccessLinksMutation, BatchUpdateAccessLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateAccessLinksMutation, BatchUpdateAccessLinksMutationVariables>(BatchUpdateAccessLinksDocument, options);
      }
export type BatchUpdateAccessLinksMutationHookResult = ReturnType<typeof useBatchUpdateAccessLinksMutation>;
export type BatchUpdateAccessLinksMutationResult = Apollo.MutationResult<BatchUpdateAccessLinksMutation>;
export type BatchUpdateAccessLinksMutationOptions = Apollo.BaseMutationOptions<BatchUpdateAccessLinksMutation, BatchUpdateAccessLinksMutationVariables>;
export const ListAccessLinksDocument = gql`
    query listAccessLinks($where: AccessLinkWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listAccessLinks(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...AccessLinkFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${AccessLinkFieldsFragmentDoc}`;

/**
 * __useListAccessLinksQuery__
 *
 * To run a query within a React component, call `useListAccessLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccessLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccessLinksQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListAccessLinksQuery(baseOptions?: Apollo.QueryHookOptions<ListAccessLinksQuery, ListAccessLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccessLinksQuery, ListAccessLinksQueryVariables>(ListAccessLinksDocument, options);
      }
export function useListAccessLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccessLinksQuery, ListAccessLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccessLinksQuery, ListAccessLinksQueryVariables>(ListAccessLinksDocument, options);
        }
export function useListAccessLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccessLinksQuery, ListAccessLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccessLinksQuery, ListAccessLinksQueryVariables>(ListAccessLinksDocument, options);
        }
export type ListAccessLinksQueryHookResult = ReturnType<typeof useListAccessLinksQuery>;
export type ListAccessLinksLazyQueryHookResult = ReturnType<typeof useListAccessLinksLazyQuery>;
export type ListAccessLinksSuspenseQueryHookResult = ReturnType<typeof useListAccessLinksSuspenseQuery>;
export type ListAccessLinksQueryResult = Apollo.QueryResult<ListAccessLinksQuery, ListAccessLinksQueryVariables>;
export const RequestReadAccessDocument = gql`
    mutation requestReadAccess($data: RequestAccessInputDTO!) {
  requestReadAccess(data: $data) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export type RequestReadAccessMutationFn = Apollo.MutationFunction<RequestReadAccessMutation, RequestReadAccessMutationVariables>;

/**
 * __useRequestReadAccessMutation__
 *
 * To run a mutation, you first call `useRequestReadAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReadAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReadAccessMutation, { data, loading, error }] = useRequestReadAccessMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestReadAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestReadAccessMutation, RequestReadAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestReadAccessMutation, RequestReadAccessMutationVariables>(RequestReadAccessDocument, options);
      }
export type RequestReadAccessMutationHookResult = ReturnType<typeof useRequestReadAccessMutation>;
export type RequestReadAccessMutationResult = Apollo.MutationResult<RequestReadAccessMutation>;
export type RequestReadAccessMutationOptions = Apollo.BaseMutationOptions<RequestReadAccessMutation, RequestReadAccessMutationVariables>;
export const DeleteAccessLinkDocument = gql`
    mutation deleteAccessLink($where: AccessLinkWhereUniqueInput!) {
  deleteAccessLink(where: $where) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export type DeleteAccessLinkMutationFn = Apollo.MutationFunction<DeleteAccessLinkMutation, DeleteAccessLinkMutationVariables>;

/**
 * __useDeleteAccessLinkMutation__
 *
 * To run a mutation, you first call `useDeleteAccessLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessLinkMutation, { data, loading, error }] = useDeleteAccessLinkMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteAccessLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccessLinkMutation, DeleteAccessLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccessLinkMutation, DeleteAccessLinkMutationVariables>(DeleteAccessLinkDocument, options);
      }
export type DeleteAccessLinkMutationHookResult = ReturnType<typeof useDeleteAccessLinkMutation>;
export type DeleteAccessLinkMutationResult = Apollo.MutationResult<DeleteAccessLinkMutation>;
export type DeleteAccessLinkMutationOptions = Apollo.BaseMutationOptions<DeleteAccessLinkMutation, DeleteAccessLinkMutationVariables>;
export const OnCreateAccessLinkDocument = gql`
    subscription onCreateAccessLink($where: AccessLinkWhereInput) {
  onCreateAccessLink(where: $where) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;

/**
 * __useOnCreateAccessLinkSubscription__
 *
 * To run a query within a React component, call `useOnCreateAccessLinkSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateAccessLinkSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateAccessLinkSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateAccessLinkSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateAccessLinkSubscription, OnCreateAccessLinkSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateAccessLinkSubscription, OnCreateAccessLinkSubscriptionVariables>(OnCreateAccessLinkDocument, options);
      }
export type OnCreateAccessLinkSubscriptionHookResult = ReturnType<typeof useOnCreateAccessLinkSubscription>;
export type OnCreateAccessLinkSubscriptionResult = Apollo.SubscriptionResult<OnCreateAccessLinkSubscription>;
export const OnDeleteAccessLinkDocument = gql`
    subscription onDeleteAccessLink {
  onDeleteAccessLink {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;

/**
 * __useOnDeleteAccessLinkSubscription__
 *
 * To run a query within a React component, call `useOnDeleteAccessLinkSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteAccessLinkSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteAccessLinkSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteAccessLinkSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteAccessLinkSubscription, OnDeleteAccessLinkSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteAccessLinkSubscription, OnDeleteAccessLinkSubscriptionVariables>(OnDeleteAccessLinkDocument, options);
      }
export type OnDeleteAccessLinkSubscriptionHookResult = ReturnType<typeof useOnDeleteAccessLinkSubscription>;
export type OnDeleteAccessLinkSubscriptionResult = Apollo.SubscriptionResult<OnDeleteAccessLinkSubscription>;
export const CreateRegistrationLinkDocument = gql`
    mutation createRegistrationLink($data: CreateRegistrationLinkInputDTO!) {
  createRegistrationLink(data: $data) {
    ...AccessLinkFields
  }
}
    ${AccessLinkFieldsFragmentDoc}`;
export type CreateRegistrationLinkMutationFn = Apollo.MutationFunction<CreateRegistrationLinkMutation, CreateRegistrationLinkMutationVariables>;

/**
 * __useCreateRegistrationLinkMutation__
 *
 * To run a mutation, you first call `useCreateRegistrationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistrationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistrationLinkMutation, { data, loading, error }] = useCreateRegistrationLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRegistrationLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegistrationLinkMutation, CreateRegistrationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegistrationLinkMutation, CreateRegistrationLinkMutationVariables>(CreateRegistrationLinkDocument, options);
      }
export type CreateRegistrationLinkMutationHookResult = ReturnType<typeof useCreateRegistrationLinkMutation>;
export type CreateRegistrationLinkMutationResult = Apollo.MutationResult<CreateRegistrationLinkMutation>;
export type CreateRegistrationLinkMutationOptions = Apollo.BaseMutationOptions<CreateRegistrationLinkMutation, CreateRegistrationLinkMutationVariables>;
export const CreateAnswerDocument = gql`
    mutation createAnswer($data: CreateAnswerInputDTO!) {
  createAnswer(data: $data) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc}`;
export type CreateAnswerMutationFn = Apollo.MutationFunction<CreateAnswerMutation, CreateAnswerMutationVariables>;

/**
 * __useCreateAnswerMutation__
 *
 * To run a mutation, you first call `useCreateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerMutation, { data, loading, error }] = useCreateAnswerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnswerMutation, CreateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnswerMutation, CreateAnswerMutationVariables>(CreateAnswerDocument, options);
      }
export type CreateAnswerMutationHookResult = ReturnType<typeof useCreateAnswerMutation>;
export type CreateAnswerMutationResult = Apollo.MutationResult<CreateAnswerMutation>;
export type CreateAnswerMutationOptions = Apollo.BaseMutationOptions<CreateAnswerMutation, CreateAnswerMutationVariables>;
export const ListAnswersDocument = gql`
    query listAnswers($where: AnswerWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listAnswers(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...AnswerFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${AnswerFieldsFragmentDoc}`;

/**
 * __useListAnswersQuery__
 *
 * To run a query within a React component, call `useListAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAnswersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListAnswersQuery(baseOptions?: Apollo.QueryHookOptions<ListAnswersQuery, ListAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAnswersQuery, ListAnswersQueryVariables>(ListAnswersDocument, options);
      }
export function useListAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAnswersQuery, ListAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAnswersQuery, ListAnswersQueryVariables>(ListAnswersDocument, options);
        }
export function useListAnswersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAnswersQuery, ListAnswersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAnswersQuery, ListAnswersQueryVariables>(ListAnswersDocument, options);
        }
export type ListAnswersQueryHookResult = ReturnType<typeof useListAnswersQuery>;
export type ListAnswersLazyQueryHookResult = ReturnType<typeof useListAnswersLazyQuery>;
export type ListAnswersSuspenseQueryHookResult = ReturnType<typeof useListAnswersSuspenseQuery>;
export type ListAnswersQueryResult = Apollo.QueryResult<ListAnswersQuery, ListAnswersQueryVariables>;
export const ListAnswersWithUsersDocument = gql`
    query listAnswersWithUsers($where: AnswerWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listAnswers(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...AnswerFields
        ...AnswerRelationUser
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${AnswerFieldsFragmentDoc}
${AnswerRelationUserFragmentDoc}`;

/**
 * __useListAnswersWithUsersQuery__
 *
 * To run a query within a React component, call `useListAnswersWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAnswersWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAnswersWithUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListAnswersWithUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>(ListAnswersWithUsersDocument, options);
      }
export function useListAnswersWithUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>(ListAnswersWithUsersDocument, options);
        }
export function useListAnswersWithUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>(ListAnswersWithUsersDocument, options);
        }
export type ListAnswersWithUsersQueryHookResult = ReturnType<typeof useListAnswersWithUsersQuery>;
export type ListAnswersWithUsersLazyQueryHookResult = ReturnType<typeof useListAnswersWithUsersLazyQuery>;
export type ListAnswersWithUsersSuspenseQueryHookResult = ReturnType<typeof useListAnswersWithUsersSuspenseQuery>;
export type ListAnswersWithUsersQueryResult = Apollo.QueryResult<ListAnswersWithUsersQuery, ListAnswersWithUsersQueryVariables>;
export const UpdateAnswerDocument = gql`
    mutation updateAnswer($data: UpdateAnswerInputDTO!) {
  updateAnswer(data: $data) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc}`;
export type UpdateAnswerMutationFn = Apollo.MutationFunction<UpdateAnswerMutation, UpdateAnswerMutationVariables>;

/**
 * __useUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerMutation, { data, loading, error }] = useUpdateAnswerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnswerMutation, UpdateAnswerMutationVariables>(UpdateAnswerDocument, options);
      }
export type UpdateAnswerMutationHookResult = ReturnType<typeof useUpdateAnswerMutation>;
export type UpdateAnswerMutationResult = Apollo.MutationResult<UpdateAnswerMutation>;
export type UpdateAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>;
export const CreateOrUpdateAnswerDocument = gql`
    mutation createOrUpdateAnswer($data: CreateOrUpdateAnswerInputDto!) {
  createOrUpdateAnswer(data: $data) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc}`;
export type CreateOrUpdateAnswerMutationFn = Apollo.MutationFunction<CreateOrUpdateAnswerMutation, CreateOrUpdateAnswerMutationVariables>;

/**
 * __useCreateOrUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAnswerMutation, { data, loading, error }] = useCreateOrUpdateAnswerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrUpdateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAnswerMutation, CreateOrUpdateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAnswerMutation, CreateOrUpdateAnswerMutationVariables>(CreateOrUpdateAnswerDocument, options);
      }
export type CreateOrUpdateAnswerMutationHookResult = ReturnType<typeof useCreateOrUpdateAnswerMutation>;
export type CreateOrUpdateAnswerMutationResult = Apollo.MutationResult<CreateOrUpdateAnswerMutation>;
export type CreateOrUpdateAnswerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAnswerMutation, CreateOrUpdateAnswerMutationVariables>;
export const OnCreateAnswerDocument = gql`
    subscription onCreateAnswer($where: AnswerWhereInput) {
  onCreateAnswer(where: $where) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc}`;

/**
 * __useOnCreateAnswerSubscription__
 *
 * To run a query within a React component, call `useOnCreateAnswerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateAnswerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateAnswerSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateAnswerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateAnswerSubscription, OnCreateAnswerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateAnswerSubscription, OnCreateAnswerSubscriptionVariables>(OnCreateAnswerDocument, options);
      }
export type OnCreateAnswerSubscriptionHookResult = ReturnType<typeof useOnCreateAnswerSubscription>;
export type OnCreateAnswerSubscriptionResult = Apollo.SubscriptionResult<OnCreateAnswerSubscription>;
export const OnUpdateAnswerDocument = gql`
    subscription onUpdateAnswer($where: AnswerWhereInput) {
  onUpdateAnswer(where: $where) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc}`;

/**
 * __useOnUpdateAnswerSubscription__
 *
 * To run a query within a React component, call `useOnUpdateAnswerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateAnswerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateAnswerSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateAnswerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateAnswerSubscription, OnUpdateAnswerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateAnswerSubscription, OnUpdateAnswerSubscriptionVariables>(OnUpdateAnswerDocument, options);
      }
export type OnUpdateAnswerSubscriptionHookResult = ReturnType<typeof useOnUpdateAnswerSubscription>;
export type OnUpdateAnswerSubscriptionResult = Apollo.SubscriptionResult<OnUpdateAnswerSubscription>;
export const OnDeleteAnswerDocument = gql`
    subscription onDeleteAnswer {
  onDeleteAnswer {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc}`;

/**
 * __useOnDeleteAnswerSubscription__
 *
 * To run a query within a React component, call `useOnDeleteAnswerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteAnswerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteAnswerSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteAnswerSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteAnswerSubscription, OnDeleteAnswerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteAnswerSubscription, OnDeleteAnswerSubscriptionVariables>(OnDeleteAnswerDocument, options);
      }
export type OnDeleteAnswerSubscriptionHookResult = ReturnType<typeof useOnDeleteAnswerSubscription>;
export type OnDeleteAnswerSubscriptionResult = Apollo.SubscriptionResult<OnDeleteAnswerSubscription>;
export const CreateAssetViewDocument = gql`
    mutation createAssetView($data: CreateAssetViewInputDTO!) {
  createAssetView(data: $data) {
    ...AssetViewFields
  }
}
    ${AssetViewFieldsFragmentDoc}`;
export type CreateAssetViewMutationFn = Apollo.MutationFunction<CreateAssetViewMutation, CreateAssetViewMutationVariables>;

/**
 * __useCreateAssetViewMutation__
 *
 * To run a mutation, you first call `useCreateAssetViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetViewMutation, { data, loading, error }] = useCreateAssetViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAssetViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetViewMutation, CreateAssetViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetViewMutation, CreateAssetViewMutationVariables>(CreateAssetViewDocument, options);
      }
export type CreateAssetViewMutationHookResult = ReturnType<typeof useCreateAssetViewMutation>;
export type CreateAssetViewMutationResult = Apollo.MutationResult<CreateAssetViewMutation>;
export type CreateAssetViewMutationOptions = Apollo.BaseMutationOptions<CreateAssetViewMutation, CreateAssetViewMutationVariables>;
export const ListAssetViewsDocument = gql`
    query listAssetViews($where: AssetViewWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listAssetViews(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...AssetViewFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${AssetViewFieldsFragmentDoc}`;

/**
 * __useListAssetViewsQuery__
 *
 * To run a query within a React component, call `useListAssetViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssetViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssetViewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListAssetViewsQuery(baseOptions?: Apollo.QueryHookOptions<ListAssetViewsQuery, ListAssetViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAssetViewsQuery, ListAssetViewsQueryVariables>(ListAssetViewsDocument, options);
      }
export function useListAssetViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAssetViewsQuery, ListAssetViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAssetViewsQuery, ListAssetViewsQueryVariables>(ListAssetViewsDocument, options);
        }
export function useListAssetViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAssetViewsQuery, ListAssetViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAssetViewsQuery, ListAssetViewsQueryVariables>(ListAssetViewsDocument, options);
        }
export type ListAssetViewsQueryHookResult = ReturnType<typeof useListAssetViewsQuery>;
export type ListAssetViewsLazyQueryHookResult = ReturnType<typeof useListAssetViewsLazyQuery>;
export type ListAssetViewsSuspenseQueryHookResult = ReturnType<typeof useListAssetViewsSuspenseQuery>;
export type ListAssetViewsQueryResult = Apollo.QueryResult<ListAssetViewsQuery, ListAssetViewsQueryVariables>;
export const OnCreateAssetViewDocument = gql`
    subscription onCreateAssetView($where: AssetViewWhereInput) {
  onCreateAssetView(where: $where) {
    ...AssetViewFields
  }
}
    ${AssetViewFieldsFragmentDoc}`;

/**
 * __useOnCreateAssetViewSubscription__
 *
 * To run a query within a React component, call `useOnCreateAssetViewSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateAssetViewSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateAssetViewSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateAssetViewSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateAssetViewSubscription, OnCreateAssetViewSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateAssetViewSubscription, OnCreateAssetViewSubscriptionVariables>(OnCreateAssetViewDocument, options);
      }
export type OnCreateAssetViewSubscriptionHookResult = ReturnType<typeof useOnCreateAssetViewSubscription>;
export type OnCreateAssetViewSubscriptionResult = Apollo.SubscriptionResult<OnCreateAssetViewSubscription>;
export const OnUpdateAssetViewDocument = gql`
    subscription onUpdateAssetView($where: AssetViewWhereInput) {
  onUpdateAssetView(where: $where) {
    ...AssetViewFields
  }
}
    ${AssetViewFieldsFragmentDoc}`;

/**
 * __useOnUpdateAssetViewSubscription__
 *
 * To run a query within a React component, call `useOnUpdateAssetViewSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateAssetViewSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateAssetViewSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateAssetViewSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateAssetViewSubscription, OnUpdateAssetViewSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateAssetViewSubscription, OnUpdateAssetViewSubscriptionVariables>(OnUpdateAssetViewDocument, options);
      }
export type OnUpdateAssetViewSubscriptionHookResult = ReturnType<typeof useOnUpdateAssetViewSubscription>;
export type OnUpdateAssetViewSubscriptionResult = Apollo.SubscriptionResult<OnUpdateAssetViewSubscription>;
export const OnDeleteAssetViewDocument = gql`
    subscription onDeleteAssetView {
  onDeleteAssetView {
    ...AssetViewFields
  }
}
    ${AssetViewFieldsFragmentDoc}`;

/**
 * __useOnDeleteAssetViewSubscription__
 *
 * To run a query within a React component, call `useOnDeleteAssetViewSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteAssetViewSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteAssetViewSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteAssetViewSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteAssetViewSubscription, OnDeleteAssetViewSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteAssetViewSubscription, OnDeleteAssetViewSubscriptionVariables>(OnDeleteAssetViewDocument, options);
      }
export type OnDeleteAssetViewSubscriptionHookResult = ReturnType<typeof useOnDeleteAssetViewSubscription>;
export type OnDeleteAssetViewSubscriptionResult = Apollo.SubscriptionResult<OnDeleteAssetViewSubscription>;
export const CreateCaseClusterDocument = gql`
    mutation createCaseCluster($data: CreateCaseClusterInputDTO!) {
  createCaseCluster(data: $data) {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;
export type CreateCaseClusterMutationFn = Apollo.MutationFunction<CreateCaseClusterMutation, CreateCaseClusterMutationVariables>;

/**
 * __useCreateCaseClusterMutation__
 *
 * To run a mutation, you first call `useCreateCaseClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseClusterMutation, { data, loading, error }] = useCreateCaseClusterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaseClusterMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseClusterMutation, CreateCaseClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseClusterMutation, CreateCaseClusterMutationVariables>(CreateCaseClusterDocument, options);
      }
export type CreateCaseClusterMutationHookResult = ReturnType<typeof useCreateCaseClusterMutation>;
export type CreateCaseClusterMutationResult = Apollo.MutationResult<CreateCaseClusterMutation>;
export type CreateCaseClusterMutationOptions = Apollo.BaseMutationOptions<CreateCaseClusterMutation, CreateCaseClusterMutationVariables>;
export const GetCaseClusterDocument = gql`
    query getCaseCluster($where: CaseClusterWhereUniqueInput!) {
  getCaseCluster(where: $where) {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;

/**
 * __useGetCaseClusterQuery__
 *
 * To run a query within a React component, call `useGetCaseClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseClusterQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCaseClusterQuery(baseOptions: Apollo.QueryHookOptions<GetCaseClusterQuery, GetCaseClusterQueryVariables> & ({ variables: GetCaseClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseClusterQuery, GetCaseClusterQueryVariables>(GetCaseClusterDocument, options);
      }
export function useGetCaseClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseClusterQuery, GetCaseClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseClusterQuery, GetCaseClusterQueryVariables>(GetCaseClusterDocument, options);
        }
export function useGetCaseClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClusterQuery, GetCaseClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseClusterQuery, GetCaseClusterQueryVariables>(GetCaseClusterDocument, options);
        }
export type GetCaseClusterQueryHookResult = ReturnType<typeof useGetCaseClusterQuery>;
export type GetCaseClusterLazyQueryHookResult = ReturnType<typeof useGetCaseClusterLazyQuery>;
export type GetCaseClusterSuspenseQueryHookResult = ReturnType<typeof useGetCaseClusterSuspenseQuery>;
export type GetCaseClusterQueryResult = Apollo.QueryResult<GetCaseClusterQuery, GetCaseClusterQueryVariables>;
export const ListCaseClustersDocument = gql`
    query listCaseClusters($where: CaseClusterWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listCaseClusters(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...CaseClusterFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${CaseClusterFieldsFragmentDoc}`;

/**
 * __useListCaseClustersQuery__
 *
 * To run a query within a React component, call `useListCaseClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCaseClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCaseClustersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListCaseClustersQuery(baseOptions?: Apollo.QueryHookOptions<ListCaseClustersQuery, ListCaseClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCaseClustersQuery, ListCaseClustersQueryVariables>(ListCaseClustersDocument, options);
      }
export function useListCaseClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCaseClustersQuery, ListCaseClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCaseClustersQuery, ListCaseClustersQueryVariables>(ListCaseClustersDocument, options);
        }
export function useListCaseClustersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCaseClustersQuery, ListCaseClustersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCaseClustersQuery, ListCaseClustersQueryVariables>(ListCaseClustersDocument, options);
        }
export type ListCaseClustersQueryHookResult = ReturnType<typeof useListCaseClustersQuery>;
export type ListCaseClustersLazyQueryHookResult = ReturnType<typeof useListCaseClustersLazyQuery>;
export type ListCaseClustersSuspenseQueryHookResult = ReturnType<typeof useListCaseClustersSuspenseQuery>;
export type ListCaseClustersQueryResult = Apollo.QueryResult<ListCaseClustersQuery, ListCaseClustersQueryVariables>;
export const UpdateCaseClusterDocument = gql`
    mutation updateCaseCluster($data: UpdateCaseClusterInputDTO!) {
  updateCaseCluster(data: $data) {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;
export type UpdateCaseClusterMutationFn = Apollo.MutationFunction<UpdateCaseClusterMutation, UpdateCaseClusterMutationVariables>;

/**
 * __useUpdateCaseClusterMutation__
 *
 * To run a mutation, you first call `useUpdateCaseClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseClusterMutation, { data, loading, error }] = useUpdateCaseClusterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCaseClusterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseClusterMutation, UpdateCaseClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseClusterMutation, UpdateCaseClusterMutationVariables>(UpdateCaseClusterDocument, options);
      }
export type UpdateCaseClusterMutationHookResult = ReturnType<typeof useUpdateCaseClusterMutation>;
export type UpdateCaseClusterMutationResult = Apollo.MutationResult<UpdateCaseClusterMutation>;
export type UpdateCaseClusterMutationOptions = Apollo.BaseMutationOptions<UpdateCaseClusterMutation, UpdateCaseClusterMutationVariables>;
export const DeleteCaseClusterDocument = gql`
    mutation deleteCaseCluster($where: CaseClusterWhereUniqueInput!) {
  deleteCaseCluster(where: $where) {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;
export type DeleteCaseClusterMutationFn = Apollo.MutationFunction<DeleteCaseClusterMutation, DeleteCaseClusterMutationVariables>;

/**
 * __useDeleteCaseClusterMutation__
 *
 * To run a mutation, you first call `useDeleteCaseClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseClusterMutation, { data, loading, error }] = useDeleteCaseClusterMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCaseClusterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseClusterMutation, DeleteCaseClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseClusterMutation, DeleteCaseClusterMutationVariables>(DeleteCaseClusterDocument, options);
      }
export type DeleteCaseClusterMutationHookResult = ReturnType<typeof useDeleteCaseClusterMutation>;
export type DeleteCaseClusterMutationResult = Apollo.MutationResult<DeleteCaseClusterMutation>;
export type DeleteCaseClusterMutationOptions = Apollo.BaseMutationOptions<DeleteCaseClusterMutation, DeleteCaseClusterMutationVariables>;
export const OnCreateCaseClusterDocument = gql`
    subscription onCreateCaseCluster($where: CaseClusterWhereInput) {
  onCreateCaseCluster(where: $where) {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;

/**
 * __useOnCreateCaseClusterSubscription__
 *
 * To run a query within a React component, call `useOnCreateCaseClusterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateCaseClusterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateCaseClusterSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateCaseClusterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateCaseClusterSubscription, OnCreateCaseClusterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateCaseClusterSubscription, OnCreateCaseClusterSubscriptionVariables>(OnCreateCaseClusterDocument, options);
      }
export type OnCreateCaseClusterSubscriptionHookResult = ReturnType<typeof useOnCreateCaseClusterSubscription>;
export type OnCreateCaseClusterSubscriptionResult = Apollo.SubscriptionResult<OnCreateCaseClusterSubscription>;
export const OnUpdateCaseClusterDocument = gql`
    subscription onUpdateCaseCluster($where: CaseClusterWhereInput) {
  onUpdateCaseCluster(where: $where) {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;

/**
 * __useOnUpdateCaseClusterSubscription__
 *
 * To run a query within a React component, call `useOnUpdateCaseClusterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateCaseClusterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateCaseClusterSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateCaseClusterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateCaseClusterSubscription, OnUpdateCaseClusterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateCaseClusterSubscription, OnUpdateCaseClusterSubscriptionVariables>(OnUpdateCaseClusterDocument, options);
      }
export type OnUpdateCaseClusterSubscriptionHookResult = ReturnType<typeof useOnUpdateCaseClusterSubscription>;
export type OnUpdateCaseClusterSubscriptionResult = Apollo.SubscriptionResult<OnUpdateCaseClusterSubscription>;
export const OnDeleteCaseClusterDocument = gql`
    subscription onDeleteCaseCluster {
  onDeleteCaseCluster {
    ...CaseClusterFields
  }
}
    ${CaseClusterFieldsFragmentDoc}`;

/**
 * __useOnDeleteCaseClusterSubscription__
 *
 * To run a query within a React component, call `useOnDeleteCaseClusterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteCaseClusterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteCaseClusterSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteCaseClusterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteCaseClusterSubscription, OnDeleteCaseClusterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteCaseClusterSubscription, OnDeleteCaseClusterSubscriptionVariables>(OnDeleteCaseClusterDocument, options);
      }
export type OnDeleteCaseClusterSubscriptionHookResult = ReturnType<typeof useOnDeleteCaseClusterSubscription>;
export type OnDeleteCaseClusterSubscriptionResult = Apollo.SubscriptionResult<OnDeleteCaseClusterSubscription>;
export const GetCaseStatsAggregationDocument = gql`
    query getCaseStatsAggregation($caseId: String!, $masterclassId: String!) {
  getCaseStatsAggregation(caseId: $caseId, masterclassId: $masterclassId) {
    caseId
    caseName
    summary {
      totalUsers
      usersWhoAccessed
      usersWhoCompleted
      usersWhoPassed
      averageRating
      completionRate
      passRate
    }
    userStats {
      userId
      username
      email
      caseSelectorVisits
      caseClicks
      completions
      firstAccessDate
      lastAccessDate
      averageRating
      certificationStatus
      certificationAttempts
      bestCertificationScore
      hasAccessed
      hasCompleted
    }
  }
}
    `;

/**
 * __useGetCaseStatsAggregationQuery__
 *
 * To run a query within a React component, call `useGetCaseStatsAggregationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseStatsAggregationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseStatsAggregationQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      masterclassId: // value for 'masterclassId'
 *   },
 * });
 */
export function useGetCaseStatsAggregationQuery(baseOptions: Apollo.QueryHookOptions<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables> & ({ variables: GetCaseStatsAggregationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables>(GetCaseStatsAggregationDocument, options);
      }
export function useGetCaseStatsAggregationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables>(GetCaseStatsAggregationDocument, options);
        }
export function useGetCaseStatsAggregationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables>(GetCaseStatsAggregationDocument, options);
        }
export type GetCaseStatsAggregationQueryHookResult = ReturnType<typeof useGetCaseStatsAggregationQuery>;
export type GetCaseStatsAggregationLazyQueryHookResult = ReturnType<typeof useGetCaseStatsAggregationLazyQuery>;
export type GetCaseStatsAggregationSuspenseQueryHookResult = ReturnType<typeof useGetCaseStatsAggregationSuspenseQuery>;
export type GetCaseStatsAggregationQueryResult = Apollo.QueryResult<GetCaseStatsAggregationQuery, GetCaseStatsAggregationQueryVariables>;
export const GetCertificationQuestionsDocument = gql`
    query getCertificationQuestions($input: PatientCaseFilter!) {
  getCertificationQuestions(input: $input) {
    case_id
    case_key
    passing_score
    certification_questions {
      id
      question_text
      options
      correct_answer
      explanation
    }
  }
}
    `;

/**
 * __useGetCertificationQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCertificationQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCertificationQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables> & ({ variables: GetCertificationQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables>(GetCertificationQuestionsDocument, options);
      }
export function useGetCertificationQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables>(GetCertificationQuestionsDocument, options);
        }
export function useGetCertificationQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables>(GetCertificationQuestionsDocument, options);
        }
export type GetCertificationQuestionsQueryHookResult = ReturnType<typeof useGetCertificationQuestionsQuery>;
export type GetCertificationQuestionsLazyQueryHookResult = ReturnType<typeof useGetCertificationQuestionsLazyQuery>;
export type GetCertificationQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetCertificationQuestionsSuspenseQuery>;
export type GetCertificationQuestionsQueryResult = Apollo.QueryResult<GetCertificationQuestionsQuery, GetCertificationQuestionsQueryVariables>;
export const GetCertificationProgressDocument = gql`
    query getCertificationProgress($where: CertificationProgressWhereUniqueInput!) {
  getCertificationProgress(where: $where) {
    ...CertificationProgressFields
  }
}
    ${CertificationProgressFieldsFragmentDoc}`;

/**
 * __useGetCertificationProgressQuery__
 *
 * To run a query within a React component, call `useGetCertificationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationProgressQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCertificationProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCertificationProgressQuery, GetCertificationProgressQueryVariables> & ({ variables: GetCertificationProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificationProgressQuery, GetCertificationProgressQueryVariables>(GetCertificationProgressDocument, options);
      }
export function useGetCertificationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificationProgressQuery, GetCertificationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificationProgressQuery, GetCertificationProgressQueryVariables>(GetCertificationProgressDocument, options);
        }
export function useGetCertificationProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificationProgressQuery, GetCertificationProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCertificationProgressQuery, GetCertificationProgressQueryVariables>(GetCertificationProgressDocument, options);
        }
export type GetCertificationProgressQueryHookResult = ReturnType<typeof useGetCertificationProgressQuery>;
export type GetCertificationProgressLazyQueryHookResult = ReturnType<typeof useGetCertificationProgressLazyQuery>;
export type GetCertificationProgressSuspenseQueryHookResult = ReturnType<typeof useGetCertificationProgressSuspenseQuery>;
export type GetCertificationProgressQueryResult = Apollo.QueryResult<GetCertificationProgressQuery, GetCertificationProgressQueryVariables>;
export const ListCertificationProgressDocument = gql`
    query listCertificationProgress($where: CertificationProgressWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listCertificationProgress(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...CertificationProgressFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${CertificationProgressFieldsFragmentDoc}`;

/**
 * __useListCertificationProgressQuery__
 *
 * To run a query within a React component, call `useListCertificationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCertificationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCertificationProgressQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListCertificationProgressQuery(baseOptions?: Apollo.QueryHookOptions<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>(ListCertificationProgressDocument, options);
      }
export function useListCertificationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>(ListCertificationProgressDocument, options);
        }
export function useListCertificationProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>(ListCertificationProgressDocument, options);
        }
export type ListCertificationProgressQueryHookResult = ReturnType<typeof useListCertificationProgressQuery>;
export type ListCertificationProgressLazyQueryHookResult = ReturnType<typeof useListCertificationProgressLazyQuery>;
export type ListCertificationProgressSuspenseQueryHookResult = ReturnType<typeof useListCertificationProgressSuspenseQuery>;
export type ListCertificationProgressQueryResult = Apollo.QueryResult<ListCertificationProgressQuery, ListCertificationProgressQueryVariables>;
export const UpsertCertificationProgressDocument = gql`
    mutation upsertCertificationProgress($data: UpsertCertificationProgressInputDTO!) {
  upsertCertificationProgress(data: $data) {
    ...CertificationProgressFields
  }
}
    ${CertificationProgressFieldsFragmentDoc}`;
export type UpsertCertificationProgressMutationFn = Apollo.MutationFunction<UpsertCertificationProgressMutation, UpsertCertificationProgressMutationVariables>;

/**
 * __useUpsertCertificationProgressMutation__
 *
 * To run a mutation, you first call `useUpsertCertificationProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCertificationProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCertificationProgressMutation, { data, loading, error }] = useUpsertCertificationProgressMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertCertificationProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCertificationProgressMutation, UpsertCertificationProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCertificationProgressMutation, UpsertCertificationProgressMutationVariables>(UpsertCertificationProgressDocument, options);
      }
export type UpsertCertificationProgressMutationHookResult = ReturnType<typeof useUpsertCertificationProgressMutation>;
export type UpsertCertificationProgressMutationResult = Apollo.MutationResult<UpsertCertificationProgressMutation>;
export type UpsertCertificationProgressMutationOptions = Apollo.BaseMutationOptions<UpsertCertificationProgressMutation, UpsertCertificationProgressMutationVariables>;
export const DeleteCertificationProgressDocument = gql`
    mutation deleteCertificationProgress($where: CertificationProgressWhereUniqueInput!) {
  deleteCertificationProgress(where: $where) {
    ...CertificationProgressFields
  }
}
    ${CertificationProgressFieldsFragmentDoc}`;
export type DeleteCertificationProgressMutationFn = Apollo.MutationFunction<DeleteCertificationProgressMutation, DeleteCertificationProgressMutationVariables>;

/**
 * __useDeleteCertificationProgressMutation__
 *
 * To run a mutation, you first call `useDeleteCertificationProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificationProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificationProgressMutation, { data, loading, error }] = useDeleteCertificationProgressMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCertificationProgressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCertificationProgressMutation, DeleteCertificationProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCertificationProgressMutation, DeleteCertificationProgressMutationVariables>(DeleteCertificationProgressDocument, options);
      }
export type DeleteCertificationProgressMutationHookResult = ReturnType<typeof useDeleteCertificationProgressMutation>;
export type DeleteCertificationProgressMutationResult = Apollo.MutationResult<DeleteCertificationProgressMutation>;
export type DeleteCertificationProgressMutationOptions = Apollo.BaseMutationOptions<DeleteCertificationProgressMutation, DeleteCertificationProgressMutationVariables>;
export const OnCreateCertificationProgressDocument = gql`
    subscription onCreateCertificationProgress($where: CertificationProgressWhereInput) {
  onCreateCertificationProgress(where: $where) {
    ...CertificationProgressFields
  }
}
    ${CertificationProgressFieldsFragmentDoc}`;

/**
 * __useOnCreateCertificationProgressSubscription__
 *
 * To run a query within a React component, call `useOnCreateCertificationProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateCertificationProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateCertificationProgressSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateCertificationProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateCertificationProgressSubscription, OnCreateCertificationProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateCertificationProgressSubscription, OnCreateCertificationProgressSubscriptionVariables>(OnCreateCertificationProgressDocument, options);
      }
export type OnCreateCertificationProgressSubscriptionHookResult = ReturnType<typeof useOnCreateCertificationProgressSubscription>;
export type OnCreateCertificationProgressSubscriptionResult = Apollo.SubscriptionResult<OnCreateCertificationProgressSubscription>;
export const OnUpdateCertificationProgressDocument = gql`
    subscription onUpdateCertificationProgress($where: CertificationProgressWhereInput) {
  onUpdateCertificationProgress(where: $where) {
    ...CertificationProgressFields
  }
}
    ${CertificationProgressFieldsFragmentDoc}`;

/**
 * __useOnUpdateCertificationProgressSubscription__
 *
 * To run a query within a React component, call `useOnUpdateCertificationProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateCertificationProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateCertificationProgressSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateCertificationProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateCertificationProgressSubscription, OnUpdateCertificationProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateCertificationProgressSubscription, OnUpdateCertificationProgressSubscriptionVariables>(OnUpdateCertificationProgressDocument, options);
      }
export type OnUpdateCertificationProgressSubscriptionHookResult = ReturnType<typeof useOnUpdateCertificationProgressSubscription>;
export type OnUpdateCertificationProgressSubscriptionResult = Apollo.SubscriptionResult<OnUpdateCertificationProgressSubscription>;
export const CreateClientDocument = gql`
    mutation createClient($data: CreateClientInputDTO!) {
  createClient(data: $data) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const ListClientsDocument = gql`
    query listClients($where: ClientWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listClients(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...ClientFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useListClientsQuery__
 *
 * To run a query within a React component, call `useListClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListClientsQuery(baseOptions?: Apollo.QueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, options);
      }
export function useListClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, options);
        }
export function useListClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, options);
        }
export type ListClientsQueryHookResult = ReturnType<typeof useListClientsQuery>;
export type ListClientsLazyQueryHookResult = ReturnType<typeof useListClientsLazyQuery>;
export type ListClientsSuspenseQueryHookResult = ReturnType<typeof useListClientsSuspenseQuery>;
export type ListClientsQueryResult = Apollo.QueryResult<ListClientsQuery, ListClientsQueryVariables>;
export const ListClientsWithMembersDocument = gql`
    query listClientsWithMembers($where: ClientWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs, $memberPagination: PaginationArgs) {
  listClients(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...ClientFields
        members(paginationArgs: $memberPagination) {
          edges {
            node {
              ...UserFields
            }
            cursor
          }
          pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
          }
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${ClientFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useListClientsWithMembersQuery__
 *
 * To run a query within a React component, call `useListClientsWithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientsWithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientsWithMembersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *      memberPagination: // value for 'memberPagination'
 *   },
 * });
 */
export function useListClientsWithMembersQuery(baseOptions?: Apollo.QueryHookOptions<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>(ListClientsWithMembersDocument, options);
      }
export function useListClientsWithMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>(ListClientsWithMembersDocument, options);
        }
export function useListClientsWithMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>(ListClientsWithMembersDocument, options);
        }
export type ListClientsWithMembersQueryHookResult = ReturnType<typeof useListClientsWithMembersQuery>;
export type ListClientsWithMembersLazyQueryHookResult = ReturnType<typeof useListClientsWithMembersLazyQuery>;
export type ListClientsWithMembersSuspenseQueryHookResult = ReturnType<typeof useListClientsWithMembersSuspenseQuery>;
export type ListClientsWithMembersQueryResult = Apollo.QueryResult<ListClientsWithMembersQuery, ListClientsWithMembersQueryVariables>;
export const GetClientDocument = gql`
    query getClient($where: ClientWhereUniqueInput!) {
  getClient(where: $where) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientWithMembersDocument = gql`
    query getClientWithMembers($where: ClientWhereUniqueInput!, $memberPagination: PaginationArgs) {
  getClient(where: $where) {
    ...ClientFields
    members(paginationArgs: $memberPagination) {
      edges {
        node {
          ...UserFields
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useGetClientWithMembersQuery__
 *
 * To run a query within a React component, call `useGetClientWithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientWithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientWithMembersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      memberPagination: // value for 'memberPagination'
 *   },
 * });
 */
export function useGetClientWithMembersQuery(baseOptions: Apollo.QueryHookOptions<GetClientWithMembersQuery, GetClientWithMembersQueryVariables> & ({ variables: GetClientWithMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientWithMembersQuery, GetClientWithMembersQueryVariables>(GetClientWithMembersDocument, options);
      }
export function useGetClientWithMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientWithMembersQuery, GetClientWithMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientWithMembersQuery, GetClientWithMembersQueryVariables>(GetClientWithMembersDocument, options);
        }
export function useGetClientWithMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientWithMembersQuery, GetClientWithMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientWithMembersQuery, GetClientWithMembersQueryVariables>(GetClientWithMembersDocument, options);
        }
export type GetClientWithMembersQueryHookResult = ReturnType<typeof useGetClientWithMembersQuery>;
export type GetClientWithMembersLazyQueryHookResult = ReturnType<typeof useGetClientWithMembersLazyQuery>;
export type GetClientWithMembersSuspenseQueryHookResult = ReturnType<typeof useGetClientWithMembersSuspenseQuery>;
export type GetClientWithMembersQueryResult = Apollo.QueryResult<GetClientWithMembersQuery, GetClientWithMembersQueryVariables>;
export const DeleteClientDocument = gql`
    mutation deleteClient($where: ClientWhereUniqueInput!) {
  deleteClient(where: $where) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const AddUserToClientDocument = gql`
    mutation addUserToClient($data: ChangeUserToClientInputDTO!, $memberPagination: PaginationArgs) {
  addUserToClient(data: $data) {
    ...ClientFields
    members(paginationArgs: $memberPagination) {
      edges {
        node {
          ...UserFields
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export type AddUserToClientMutationFn = Apollo.MutationFunction<AddUserToClientMutation, AddUserToClientMutationVariables>;

/**
 * __useAddUserToClientMutation__
 *
 * To run a mutation, you first call `useAddUserToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToClientMutation, { data, loading, error }] = useAddUserToClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *      memberPagination: // value for 'memberPagination'
 *   },
 * });
 */
export function useAddUserToClientMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToClientMutation, AddUserToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToClientMutation, AddUserToClientMutationVariables>(AddUserToClientDocument, options);
      }
export type AddUserToClientMutationHookResult = ReturnType<typeof useAddUserToClientMutation>;
export type AddUserToClientMutationResult = Apollo.MutationResult<AddUserToClientMutation>;
export type AddUserToClientMutationOptions = Apollo.BaseMutationOptions<AddUserToClientMutation, AddUserToClientMutationVariables>;
export const RemoveUserFromClientDocument = gql`
    mutation removeUserFromClient($data: ChangeUserToClientInputDTO!, $memberPagination: PaginationArgs) {
  removeUserFromClient(data: $data) {
    ...ClientFields
    members(paginationArgs: $memberPagination) {
      edges {
        node {
          ...UserFields
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export type RemoveUserFromClientMutationFn = Apollo.MutationFunction<RemoveUserFromClientMutation, RemoveUserFromClientMutationVariables>;

/**
 * __useRemoveUserFromClientMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromClientMutation, { data, loading, error }] = useRemoveUserFromClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *      memberPagination: // value for 'memberPagination'
 *   },
 * });
 */
export function useRemoveUserFromClientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromClientMutation, RemoveUserFromClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromClientMutation, RemoveUserFromClientMutationVariables>(RemoveUserFromClientDocument, options);
      }
export type RemoveUserFromClientMutationHookResult = ReturnType<typeof useRemoveUserFromClientMutation>;
export type RemoveUserFromClientMutationResult = Apollo.MutationResult<RemoveUserFromClientMutation>;
export type RemoveUserFromClientMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromClientMutation, RemoveUserFromClientMutationVariables>;
export const SetClientRoleDocument = gql`
    mutation setClientRole($data: SetClientRoleInputDTO!) {
  setClientRole(data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type SetClientRoleMutationFn = Apollo.MutationFunction<SetClientRoleMutation, SetClientRoleMutationVariables>;

/**
 * __useSetClientRoleMutation__
 *
 * To run a mutation, you first call `useSetClientRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClientRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClientRoleMutation, { data, loading, error }] = useSetClientRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetClientRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetClientRoleMutation, SetClientRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClientRoleMutation, SetClientRoleMutationVariables>(SetClientRoleDocument, options);
      }
export type SetClientRoleMutationHookResult = ReturnType<typeof useSetClientRoleMutation>;
export type SetClientRoleMutationResult = Apollo.MutationResult<SetClientRoleMutation>;
export type SetClientRoleMutationOptions = Apollo.BaseMutationOptions<SetClientRoleMutation, SetClientRoleMutationVariables>;
export const OnCreateClientDocument = gql`
    subscription onCreateClient($where: ClientWhereInput) {
  onCreateClient(where: $where) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useOnCreateClientSubscription__
 *
 * To run a query within a React component, call `useOnCreateClientSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateClientSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateClientSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateClientSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateClientSubscription, OnCreateClientSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateClientSubscription, OnCreateClientSubscriptionVariables>(OnCreateClientDocument, options);
      }
export type OnCreateClientSubscriptionHookResult = ReturnType<typeof useOnCreateClientSubscription>;
export type OnCreateClientSubscriptionResult = Apollo.SubscriptionResult<OnCreateClientSubscription>;
export const OnUpdateClientDocument = gql`
    subscription onUpdateClient($where: ClientWhereInput) {
  onUpdateClient(where: $where) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useOnUpdateClientSubscription__
 *
 * To run a query within a React component, call `useOnUpdateClientSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateClientSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateClientSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateClientSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateClientSubscription, OnUpdateClientSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateClientSubscription, OnUpdateClientSubscriptionVariables>(OnUpdateClientDocument, options);
      }
export type OnUpdateClientSubscriptionHookResult = ReturnType<typeof useOnUpdateClientSubscription>;
export type OnUpdateClientSubscriptionResult = Apollo.SubscriptionResult<OnUpdateClientSubscription>;
export const OnDeleteClientDocument = gql`
    subscription onDeleteClient {
  onDeleteClient {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useOnDeleteClientSubscription__
 *
 * To run a query within a React component, call `useOnDeleteClientSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteClientSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteClientSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteClientSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteClientSubscription, OnDeleteClientSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteClientSubscription, OnDeleteClientSubscriptionVariables>(OnDeleteClientDocument, options);
      }
export type OnDeleteClientSubscriptionHookResult = ReturnType<typeof useOnDeleteClientSubscription>;
export type OnDeleteClientSubscriptionResult = Apollo.SubscriptionResult<OnDeleteClientSubscription>;
export const GetHostFieldsDocument = gql`
    query getHostFields($where: HostFieldsWhereUniqueInput!) {
  getHostFields(where: $where) {
    ...HostFieldsFields
  }
}
    ${HostFieldsFieldsFragmentDoc}`;

/**
 * __useGetHostFieldsQuery__
 *
 * To run a query within a React component, call `useGetHostFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostFieldsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetHostFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetHostFieldsQuery, GetHostFieldsQueryVariables> & ({ variables: GetHostFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostFieldsQuery, GetHostFieldsQueryVariables>(GetHostFieldsDocument, options);
      }
export function useGetHostFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostFieldsQuery, GetHostFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostFieldsQuery, GetHostFieldsQueryVariables>(GetHostFieldsDocument, options);
        }
export function useGetHostFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHostFieldsQuery, GetHostFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHostFieldsQuery, GetHostFieldsQueryVariables>(GetHostFieldsDocument, options);
        }
export type GetHostFieldsQueryHookResult = ReturnType<typeof useGetHostFieldsQuery>;
export type GetHostFieldsLazyQueryHookResult = ReturnType<typeof useGetHostFieldsLazyQuery>;
export type GetHostFieldsSuspenseQueryHookResult = ReturnType<typeof useGetHostFieldsSuspenseQuery>;
export type GetHostFieldsQueryResult = Apollo.QueryResult<GetHostFieldsQuery, GetHostFieldsQueryVariables>;
export const UpdateHostFieldsDocument = gql`
    mutation updateHostFields($data: UpdateHostFieldsInputDTO!) {
  updateHostFields(data: $data) {
    ...HostFieldsFields
  }
}
    ${HostFieldsFieldsFragmentDoc}`;
export type UpdateHostFieldsMutationFn = Apollo.MutationFunction<UpdateHostFieldsMutation, UpdateHostFieldsMutationVariables>;

/**
 * __useUpdateHostFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateHostFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHostFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHostFieldsMutation, { data, loading, error }] = useUpdateHostFieldsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateHostFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHostFieldsMutation, UpdateHostFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHostFieldsMutation, UpdateHostFieldsMutationVariables>(UpdateHostFieldsDocument, options);
      }
export type UpdateHostFieldsMutationHookResult = ReturnType<typeof useUpdateHostFieldsMutation>;
export type UpdateHostFieldsMutationResult = Apollo.MutationResult<UpdateHostFieldsMutation>;
export type UpdateHostFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateHostFieldsMutation, UpdateHostFieldsMutationVariables>;
export const OnCreateHostFieldsDocument = gql`
    subscription onCreateHostFields($where: HostFieldsWhereInput) {
  onCreateHostFields(where: $where) {
    ...HostFieldsFields
  }
}
    ${HostFieldsFieldsFragmentDoc}`;

/**
 * __useOnCreateHostFieldsSubscription__
 *
 * To run a query within a React component, call `useOnCreateHostFieldsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateHostFieldsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateHostFieldsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateHostFieldsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateHostFieldsSubscription, OnCreateHostFieldsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateHostFieldsSubscription, OnCreateHostFieldsSubscriptionVariables>(OnCreateHostFieldsDocument, options);
      }
export type OnCreateHostFieldsSubscriptionHookResult = ReturnType<typeof useOnCreateHostFieldsSubscription>;
export type OnCreateHostFieldsSubscriptionResult = Apollo.SubscriptionResult<OnCreateHostFieldsSubscription>;
export const OnUpdateHostFieldsDocument = gql`
    subscription onUpdateHostFields($where: HostFieldsWhereInput) {
  onUpdateHostFields(where: $where) {
    ...HostFieldsFields
  }
}
    ${HostFieldsFieldsFragmentDoc}`;

/**
 * __useOnUpdateHostFieldsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateHostFieldsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateHostFieldsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateHostFieldsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateHostFieldsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateHostFieldsSubscription, OnUpdateHostFieldsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateHostFieldsSubscription, OnUpdateHostFieldsSubscriptionVariables>(OnUpdateHostFieldsDocument, options);
      }
export type OnUpdateHostFieldsSubscriptionHookResult = ReturnType<typeof useOnUpdateHostFieldsSubscription>;
export type OnUpdateHostFieldsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateHostFieldsSubscription>;
export const OnDeleteHostFieldsDocument = gql`
    subscription onDeleteHostFields {
  onDeleteHostFields {
    ...HostFieldsFields
  }
}
    ${HostFieldsFieldsFragmentDoc}`;

/**
 * __useOnDeleteHostFieldsSubscription__
 *
 * To run a query within a React component, call `useOnDeleteHostFieldsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteHostFieldsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteHostFieldsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteHostFieldsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteHostFieldsSubscription, OnDeleteHostFieldsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteHostFieldsSubscription, OnDeleteHostFieldsSubscriptionVariables>(OnDeleteHostFieldsDocument, options);
      }
export type OnDeleteHostFieldsSubscriptionHookResult = ReturnType<typeof useOnDeleteHostFieldsSubscription>;
export type OnDeleteHostFieldsSubscriptionResult = Apollo.SubscriptionResult<OnDeleteHostFieldsSubscription>;
export const GetMasterclassLoginLogsDocument = gql`
    query getMasterclassLoginLogs($where: MasterclassLoginLogsWhereUniqueInput!) {
  getMasterclassLoginLogs(where: $where) {
    ...MasterclassLoginLogsFields
  }
}
    ${MasterclassLoginLogsFieldsFragmentDoc}`;

/**
 * __useGetMasterclassLoginLogsQuery__
 *
 * To run a query within a React component, call `useGetMasterclassLoginLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterclassLoginLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterclassLoginLogsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterclassLoginLogsQuery(baseOptions: Apollo.QueryHookOptions<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables> & ({ variables: GetMasterclassLoginLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables>(GetMasterclassLoginLogsDocument, options);
      }
export function useGetMasterclassLoginLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables>(GetMasterclassLoginLogsDocument, options);
        }
export function useGetMasterclassLoginLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables>(GetMasterclassLoginLogsDocument, options);
        }
export type GetMasterclassLoginLogsQueryHookResult = ReturnType<typeof useGetMasterclassLoginLogsQuery>;
export type GetMasterclassLoginLogsLazyQueryHookResult = ReturnType<typeof useGetMasterclassLoginLogsLazyQuery>;
export type GetMasterclassLoginLogsSuspenseQueryHookResult = ReturnType<typeof useGetMasterclassLoginLogsSuspenseQuery>;
export type GetMasterclassLoginLogsQueryResult = Apollo.QueryResult<GetMasterclassLoginLogsQuery, GetMasterclassLoginLogsQueryVariables>;
export const ListMasterclassLoginLogsDocument = gql`
    query listMasterclassLoginLogs($where: MasterclassLoginLogsWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMasterclassLoginLogs(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MasterclassLoginLogsFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MasterclassLoginLogsFieldsFragmentDoc}`;

/**
 * __useListMasterclassLoginLogsQuery__
 *
 * To run a query within a React component, call `useListMasterclassLoginLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMasterclassLoginLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMasterclassLoginLogsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMasterclassLoginLogsQuery(baseOptions?: Apollo.QueryHookOptions<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>(ListMasterclassLoginLogsDocument, options);
      }
export function useListMasterclassLoginLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>(ListMasterclassLoginLogsDocument, options);
        }
export function useListMasterclassLoginLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>(ListMasterclassLoginLogsDocument, options);
        }
export type ListMasterclassLoginLogsQueryHookResult = ReturnType<typeof useListMasterclassLoginLogsQuery>;
export type ListMasterclassLoginLogsLazyQueryHookResult = ReturnType<typeof useListMasterclassLoginLogsLazyQuery>;
export type ListMasterclassLoginLogsSuspenseQueryHookResult = ReturnType<typeof useListMasterclassLoginLogsSuspenseQuery>;
export type ListMasterclassLoginLogsQueryResult = Apollo.QueryResult<ListMasterclassLoginLogsQuery, ListMasterclassLoginLogsQueryVariables>;
export const CreateMasterclassLoginLogsDocument = gql`
    mutation createMasterclassLoginLogs {
  createMasterclassLoginLogs {
    ...MasterclassLoginLogsFields
  }
}
    ${MasterclassLoginLogsFieldsFragmentDoc}`;
export type CreateMasterclassLoginLogsMutationFn = Apollo.MutationFunction<CreateMasterclassLoginLogsMutation, CreateMasterclassLoginLogsMutationVariables>;

/**
 * __useCreateMasterclassLoginLogsMutation__
 *
 * To run a mutation, you first call `useCreateMasterclassLoginLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterclassLoginLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterclassLoginLogsMutation, { data, loading, error }] = useCreateMasterclassLoginLogsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateMasterclassLoginLogsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterclassLoginLogsMutation, CreateMasterclassLoginLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterclassLoginLogsMutation, CreateMasterclassLoginLogsMutationVariables>(CreateMasterclassLoginLogsDocument, options);
      }
export type CreateMasterclassLoginLogsMutationHookResult = ReturnType<typeof useCreateMasterclassLoginLogsMutation>;
export type CreateMasterclassLoginLogsMutationResult = Apollo.MutationResult<CreateMasterclassLoginLogsMutation>;
export type CreateMasterclassLoginLogsMutationOptions = Apollo.BaseMutationOptions<CreateMasterclassLoginLogsMutation, CreateMasterclassLoginLogsMutationVariables>;
export const DeleteMasterclassLoginLogsDocument = gql`
    mutation deleteMasterclassLoginLogs($where: MasterclassLoginLogsWhereUniqueInput!) {
  deleteMasterclassLoginLogs(where: $where) {
    ...MasterclassLoginLogsFields
  }
}
    ${MasterclassLoginLogsFieldsFragmentDoc}`;
export type DeleteMasterclassLoginLogsMutationFn = Apollo.MutationFunction<DeleteMasterclassLoginLogsMutation, DeleteMasterclassLoginLogsMutationVariables>;

/**
 * __useDeleteMasterclassLoginLogsMutation__
 *
 * To run a mutation, you first call `useDeleteMasterclassLoginLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterclassLoginLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterclassLoginLogsMutation, { data, loading, error }] = useDeleteMasterclassLoginLogsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMasterclassLoginLogsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMasterclassLoginLogsMutation, DeleteMasterclassLoginLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMasterclassLoginLogsMutation, DeleteMasterclassLoginLogsMutationVariables>(DeleteMasterclassLoginLogsDocument, options);
      }
export type DeleteMasterclassLoginLogsMutationHookResult = ReturnType<typeof useDeleteMasterclassLoginLogsMutation>;
export type DeleteMasterclassLoginLogsMutationResult = Apollo.MutationResult<DeleteMasterclassLoginLogsMutation>;
export type DeleteMasterclassLoginLogsMutationOptions = Apollo.BaseMutationOptions<DeleteMasterclassLoginLogsMutation, DeleteMasterclassLoginLogsMutationVariables>;
export const OnCreateMasterclassLoginLogsDocument = gql`
    subscription onCreateMasterclassLoginLogs($where: MasterclassLoginLogsWhereInput) {
  onCreateMasterclassLoginLogs(where: $where) {
    ...MasterclassLoginLogsFields
  }
}
    ${MasterclassLoginLogsFieldsFragmentDoc}`;

/**
 * __useOnCreateMasterclassLoginLogsSubscription__
 *
 * To run a query within a React component, call `useOnCreateMasterclassLoginLogsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMasterclassLoginLogsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMasterclassLoginLogsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMasterclassLoginLogsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMasterclassLoginLogsSubscription, OnCreateMasterclassLoginLogsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMasterclassLoginLogsSubscription, OnCreateMasterclassLoginLogsSubscriptionVariables>(OnCreateMasterclassLoginLogsDocument, options);
      }
export type OnCreateMasterclassLoginLogsSubscriptionHookResult = ReturnType<typeof useOnCreateMasterclassLoginLogsSubscription>;
export type OnCreateMasterclassLoginLogsSubscriptionResult = Apollo.SubscriptionResult<OnCreateMasterclassLoginLogsSubscription>;
export const OnUpdateMasterclassLoginLogsDocument = gql`
    subscription onUpdateMasterclassLoginLogs($where: MasterclassLoginLogsWhereInput) {
  onUpdateMasterclassLoginLogs(where: $where) {
    ...MasterclassLoginLogsFields
  }
}
    ${MasterclassLoginLogsFieldsFragmentDoc}`;

/**
 * __useOnUpdateMasterclassLoginLogsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMasterclassLoginLogsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMasterclassLoginLogsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMasterclassLoginLogsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMasterclassLoginLogsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMasterclassLoginLogsSubscription, OnUpdateMasterclassLoginLogsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMasterclassLoginLogsSubscription, OnUpdateMasterclassLoginLogsSubscriptionVariables>(OnUpdateMasterclassLoginLogsDocument, options);
      }
export type OnUpdateMasterclassLoginLogsSubscriptionHookResult = ReturnType<typeof useOnUpdateMasterclassLoginLogsSubscription>;
export type OnUpdateMasterclassLoginLogsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMasterclassLoginLogsSubscription>;
export const GetMasterclassRatingsDocument = gql`
    query getMasterclassRatings($where: MasterclassRatingsWhereUniqueInput!) {
  getMasterclassRatings(where: $where) {
    ...MasterclassRatingsFields
  }
}
    ${MasterclassRatingsFieldsFragmentDoc}`;

/**
 * __useGetMasterclassRatingsQuery__
 *
 * To run a query within a React component, call `useGetMasterclassRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterclassRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterclassRatingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterclassRatingsQuery(baseOptions: Apollo.QueryHookOptions<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables> & ({ variables: GetMasterclassRatingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables>(GetMasterclassRatingsDocument, options);
      }
export function useGetMasterclassRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables>(GetMasterclassRatingsDocument, options);
        }
export function useGetMasterclassRatingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables>(GetMasterclassRatingsDocument, options);
        }
export type GetMasterclassRatingsQueryHookResult = ReturnType<typeof useGetMasterclassRatingsQuery>;
export type GetMasterclassRatingsLazyQueryHookResult = ReturnType<typeof useGetMasterclassRatingsLazyQuery>;
export type GetMasterclassRatingsSuspenseQueryHookResult = ReturnType<typeof useGetMasterclassRatingsSuspenseQuery>;
export type GetMasterclassRatingsQueryResult = Apollo.QueryResult<GetMasterclassRatingsQuery, GetMasterclassRatingsQueryVariables>;
export const ListMasterclassRatingsDocument = gql`
    query listMasterclassRatings($where: MasterclassRatingsWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMasterclassRatings(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MasterclassRatingsFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MasterclassRatingsFieldsFragmentDoc}`;

/**
 * __useListMasterclassRatingsQuery__
 *
 * To run a query within a React component, call `useListMasterclassRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMasterclassRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMasterclassRatingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMasterclassRatingsQuery(baseOptions?: Apollo.QueryHookOptions<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>(ListMasterclassRatingsDocument, options);
      }
export function useListMasterclassRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>(ListMasterclassRatingsDocument, options);
        }
export function useListMasterclassRatingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>(ListMasterclassRatingsDocument, options);
        }
export type ListMasterclassRatingsQueryHookResult = ReturnType<typeof useListMasterclassRatingsQuery>;
export type ListMasterclassRatingsLazyQueryHookResult = ReturnType<typeof useListMasterclassRatingsLazyQuery>;
export type ListMasterclassRatingsSuspenseQueryHookResult = ReturnType<typeof useListMasterclassRatingsSuspenseQuery>;
export type ListMasterclassRatingsQueryResult = Apollo.QueryResult<ListMasterclassRatingsQuery, ListMasterclassRatingsQueryVariables>;
export const CreateMasterclassRatingsDocument = gql`
    mutation createMasterclassRatings($data: CreateMasterclassRatingsInputDTO!) {
  createMasterclassRatings(data: $data) {
    ...MasterclassRatingsFields
  }
}
    ${MasterclassRatingsFieldsFragmentDoc}`;
export type CreateMasterclassRatingsMutationFn = Apollo.MutationFunction<CreateMasterclassRatingsMutation, CreateMasterclassRatingsMutationVariables>;

/**
 * __useCreateMasterclassRatingsMutation__
 *
 * To run a mutation, you first call `useCreateMasterclassRatingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterclassRatingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterclassRatingsMutation, { data, loading, error }] = useCreateMasterclassRatingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMasterclassRatingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterclassRatingsMutation, CreateMasterclassRatingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterclassRatingsMutation, CreateMasterclassRatingsMutationVariables>(CreateMasterclassRatingsDocument, options);
      }
export type CreateMasterclassRatingsMutationHookResult = ReturnType<typeof useCreateMasterclassRatingsMutation>;
export type CreateMasterclassRatingsMutationResult = Apollo.MutationResult<CreateMasterclassRatingsMutation>;
export type CreateMasterclassRatingsMutationOptions = Apollo.BaseMutationOptions<CreateMasterclassRatingsMutation, CreateMasterclassRatingsMutationVariables>;
export const DeleteMasterclassRatingsDocument = gql`
    mutation deleteMasterclassRatings($where: MasterclassRatingsWhereUniqueInput!) {
  deleteMasterclassRatings(where: $where) {
    ...MasterclassRatingsFields
  }
}
    ${MasterclassRatingsFieldsFragmentDoc}`;
export type DeleteMasterclassRatingsMutationFn = Apollo.MutationFunction<DeleteMasterclassRatingsMutation, DeleteMasterclassRatingsMutationVariables>;

/**
 * __useDeleteMasterclassRatingsMutation__
 *
 * To run a mutation, you first call `useDeleteMasterclassRatingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterclassRatingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterclassRatingsMutation, { data, loading, error }] = useDeleteMasterclassRatingsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMasterclassRatingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMasterclassRatingsMutation, DeleteMasterclassRatingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMasterclassRatingsMutation, DeleteMasterclassRatingsMutationVariables>(DeleteMasterclassRatingsDocument, options);
      }
export type DeleteMasterclassRatingsMutationHookResult = ReturnType<typeof useDeleteMasterclassRatingsMutation>;
export type DeleteMasterclassRatingsMutationResult = Apollo.MutationResult<DeleteMasterclassRatingsMutation>;
export type DeleteMasterclassRatingsMutationOptions = Apollo.BaseMutationOptions<DeleteMasterclassRatingsMutation, DeleteMasterclassRatingsMutationVariables>;
export const OnCreateMasterclassRatingsDocument = gql`
    subscription onCreateMasterclassRatings($where: MasterclassRatingsWhereInput) {
  onCreateMasterclassRatings(where: $where) {
    ...MasterclassRatingsFields
  }
}
    ${MasterclassRatingsFieldsFragmentDoc}`;

/**
 * __useOnCreateMasterclassRatingsSubscription__
 *
 * To run a query within a React component, call `useOnCreateMasterclassRatingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMasterclassRatingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMasterclassRatingsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMasterclassRatingsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMasterclassRatingsSubscription, OnCreateMasterclassRatingsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMasterclassRatingsSubscription, OnCreateMasterclassRatingsSubscriptionVariables>(OnCreateMasterclassRatingsDocument, options);
      }
export type OnCreateMasterclassRatingsSubscriptionHookResult = ReturnType<typeof useOnCreateMasterclassRatingsSubscription>;
export type OnCreateMasterclassRatingsSubscriptionResult = Apollo.SubscriptionResult<OnCreateMasterclassRatingsSubscription>;
export const OnUpdateMasterclassRatingsDocument = gql`
    subscription onUpdateMasterclassRatings($where: MasterclassRatingsWhereInput) {
  onUpdateMasterclassRatings(where: $where) {
    ...MasterclassRatingsFields
  }
}
    ${MasterclassRatingsFieldsFragmentDoc}`;

/**
 * __useOnUpdateMasterclassRatingsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMasterclassRatingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMasterclassRatingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMasterclassRatingsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMasterclassRatingsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMasterclassRatingsSubscription, OnUpdateMasterclassRatingsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMasterclassRatingsSubscription, OnUpdateMasterclassRatingsSubscriptionVariables>(OnUpdateMasterclassRatingsDocument, options);
      }
export type OnUpdateMasterclassRatingsSubscriptionHookResult = ReturnType<typeof useOnUpdateMasterclassRatingsSubscription>;
export type OnUpdateMasterclassRatingsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMasterclassRatingsSubscription>;
export const CreateMasterClassUserSessionDocument = gql`
    mutation createMasterClassUserSession($data: CreateMasterClassUserSessionInputDTO!) {
  createMasterClassUserSession(data: $data) {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;
export type CreateMasterClassUserSessionMutationFn = Apollo.MutationFunction<CreateMasterClassUserSessionMutation, CreateMasterClassUserSessionMutationVariables>;

/**
 * __useCreateMasterClassUserSessionMutation__
 *
 * To run a mutation, you first call `useCreateMasterClassUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterClassUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterClassUserSessionMutation, { data, loading, error }] = useCreateMasterClassUserSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMasterClassUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterClassUserSessionMutation, CreateMasterClassUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterClassUserSessionMutation, CreateMasterClassUserSessionMutationVariables>(CreateMasterClassUserSessionDocument, options);
      }
export type CreateMasterClassUserSessionMutationHookResult = ReturnType<typeof useCreateMasterClassUserSessionMutation>;
export type CreateMasterClassUserSessionMutationResult = Apollo.MutationResult<CreateMasterClassUserSessionMutation>;
export type CreateMasterClassUserSessionMutationOptions = Apollo.BaseMutationOptions<CreateMasterClassUserSessionMutation, CreateMasterClassUserSessionMutationVariables>;
export const GetMasterClassUserSessionDocument = gql`
    query getMasterClassUserSession($where: MasterClassUserSessionWhereUniqueInput!) {
  getMasterClassUserSession(where: $where) {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;

/**
 * __useGetMasterClassUserSessionQuery__
 *
 * To run a query within a React component, call `useGetMasterClassUserSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterClassUserSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterClassUserSessionQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterClassUserSessionQuery(baseOptions: Apollo.QueryHookOptions<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables> & ({ variables: GetMasterClassUserSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables>(GetMasterClassUserSessionDocument, options);
      }
export function useGetMasterClassUserSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables>(GetMasterClassUserSessionDocument, options);
        }
export function useGetMasterClassUserSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables>(GetMasterClassUserSessionDocument, options);
        }
export type GetMasterClassUserSessionQueryHookResult = ReturnType<typeof useGetMasterClassUserSessionQuery>;
export type GetMasterClassUserSessionLazyQueryHookResult = ReturnType<typeof useGetMasterClassUserSessionLazyQuery>;
export type GetMasterClassUserSessionSuspenseQueryHookResult = ReturnType<typeof useGetMasterClassUserSessionSuspenseQuery>;
export type GetMasterClassUserSessionQueryResult = Apollo.QueryResult<GetMasterClassUserSessionQuery, GetMasterClassUserSessionQueryVariables>;
export const UpdateMasterClassUserSessionDocument = gql`
    mutation updateMasterClassUserSession($data: UpdateMasterClassUserSessionInputDTO!) {
  updateMasterClassUserSession(data: $data) {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;
export type UpdateMasterClassUserSessionMutationFn = Apollo.MutationFunction<UpdateMasterClassUserSessionMutation, UpdateMasterClassUserSessionMutationVariables>;

/**
 * __useUpdateMasterClassUserSessionMutation__
 *
 * To run a mutation, you first call `useUpdateMasterClassUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterClassUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterClassUserSessionMutation, { data, loading, error }] = useUpdateMasterClassUserSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMasterClassUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterClassUserSessionMutation, UpdateMasterClassUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterClassUserSessionMutation, UpdateMasterClassUserSessionMutationVariables>(UpdateMasterClassUserSessionDocument, options);
      }
export type UpdateMasterClassUserSessionMutationHookResult = ReturnType<typeof useUpdateMasterClassUserSessionMutation>;
export type UpdateMasterClassUserSessionMutationResult = Apollo.MutationResult<UpdateMasterClassUserSessionMutation>;
export type UpdateMasterClassUserSessionMutationOptions = Apollo.BaseMutationOptions<UpdateMasterClassUserSessionMutation, UpdateMasterClassUserSessionMutationVariables>;
export const ResetCaseProgressDocument = gql`
    mutation resetCaseProgress($data: ResetCaseProgressInputDTO!) {
  resetCaseProgress(data: $data) {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;
export type ResetCaseProgressMutationFn = Apollo.MutationFunction<ResetCaseProgressMutation, ResetCaseProgressMutationVariables>;

/**
 * __useResetCaseProgressMutation__
 *
 * To run a mutation, you first call `useResetCaseProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCaseProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCaseProgressMutation, { data, loading, error }] = useResetCaseProgressMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResetCaseProgressMutation(baseOptions?: Apollo.MutationHookOptions<ResetCaseProgressMutation, ResetCaseProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCaseProgressMutation, ResetCaseProgressMutationVariables>(ResetCaseProgressDocument, options);
      }
export type ResetCaseProgressMutationHookResult = ReturnType<typeof useResetCaseProgressMutation>;
export type ResetCaseProgressMutationResult = Apollo.MutationResult<ResetCaseProgressMutation>;
export type ResetCaseProgressMutationOptions = Apollo.BaseMutationOptions<ResetCaseProgressMutation, ResetCaseProgressMutationVariables>;
export const OnCreateMasterClassUserSessionDocument = gql`
    subscription onCreateMasterClassUserSession($where: MasterClassUserSessionWhereInput) {
  onCreateMasterClassUserSession(where: $where) {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;

/**
 * __useOnCreateMasterClassUserSessionSubscription__
 *
 * To run a query within a React component, call `useOnCreateMasterClassUserSessionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMasterClassUserSessionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMasterClassUserSessionSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMasterClassUserSessionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMasterClassUserSessionSubscription, OnCreateMasterClassUserSessionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMasterClassUserSessionSubscription, OnCreateMasterClassUserSessionSubscriptionVariables>(OnCreateMasterClassUserSessionDocument, options);
      }
export type OnCreateMasterClassUserSessionSubscriptionHookResult = ReturnType<typeof useOnCreateMasterClassUserSessionSubscription>;
export type OnCreateMasterClassUserSessionSubscriptionResult = Apollo.SubscriptionResult<OnCreateMasterClassUserSessionSubscription>;
export const OnUpdateMasterClassUserSessionDocument = gql`
    subscription onUpdateMasterClassUserSession($where: MasterClassUserSessionWhereInput) {
  onUpdateMasterClassUserSession(where: $where) {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;

/**
 * __useOnUpdateMasterClassUserSessionSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMasterClassUserSessionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMasterClassUserSessionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMasterClassUserSessionSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMasterClassUserSessionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMasterClassUserSessionSubscription, OnUpdateMasterClassUserSessionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMasterClassUserSessionSubscription, OnUpdateMasterClassUserSessionSubscriptionVariables>(OnUpdateMasterClassUserSessionDocument, options);
      }
export type OnUpdateMasterClassUserSessionSubscriptionHookResult = ReturnType<typeof useOnUpdateMasterClassUserSessionSubscription>;
export type OnUpdateMasterClassUserSessionSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMasterClassUserSessionSubscription>;
export const OnDeleteMasterClassUserSessionDocument = gql`
    subscription onDeleteMasterClassUserSession {
  onDeleteMasterClassUserSession {
    ...MasterClassUserSessionFields
  }
}
    ${MasterClassUserSessionFieldsFragmentDoc}`;

/**
 * __useOnDeleteMasterClassUserSessionSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMasterClassUserSessionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMasterClassUserSessionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMasterClassUserSessionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteMasterClassUserSessionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteMasterClassUserSessionSubscription, OnDeleteMasterClassUserSessionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMasterClassUserSessionSubscription, OnDeleteMasterClassUserSessionSubscriptionVariables>(OnDeleteMasterClassUserSessionDocument, options);
      }
export type OnDeleteMasterClassUserSessionSubscriptionHookResult = ReturnType<typeof useOnDeleteMasterClassUserSessionSubscription>;
export type OnDeleteMasterClassUserSessionSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMasterClassUserSessionSubscription>;
export const GetMasterclassUserStatisticsDocument = gql`
    query getMasterclassUserStatistics($where: MasterclassUserStatisticsWhereUniqueInput!) {
  getMasterclassUserStatistics(where: $where) {
    ...MasterclassUserStatisticsFields
  }
}
    ${MasterclassUserStatisticsFieldsFragmentDoc}`;

/**
 * __useGetMasterclassUserStatisticsQuery__
 *
 * To run a query within a React component, call `useGetMasterclassUserStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterclassUserStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterclassUserStatisticsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterclassUserStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables> & ({ variables: GetMasterclassUserStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables>(GetMasterclassUserStatisticsDocument, options);
      }
export function useGetMasterclassUserStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables>(GetMasterclassUserStatisticsDocument, options);
        }
export function useGetMasterclassUserStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables>(GetMasterclassUserStatisticsDocument, options);
        }
export type GetMasterclassUserStatisticsQueryHookResult = ReturnType<typeof useGetMasterclassUserStatisticsQuery>;
export type GetMasterclassUserStatisticsLazyQueryHookResult = ReturnType<typeof useGetMasterclassUserStatisticsLazyQuery>;
export type GetMasterclassUserStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetMasterclassUserStatisticsSuspenseQuery>;
export type GetMasterclassUserStatisticsQueryResult = Apollo.QueryResult<GetMasterclassUserStatisticsQuery, GetMasterclassUserStatisticsQueryVariables>;
export const ListMasterclassUserStatisticsDocument = gql`
    query listMasterclassUserStatistics($where: MasterclassUserStatisticsWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMasterclassUserStatistics(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MasterclassUserStatisticsFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MasterclassUserStatisticsFieldsFragmentDoc}`;

/**
 * __useListMasterclassUserStatisticsQuery__
 *
 * To run a query within a React component, call `useListMasterclassUserStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMasterclassUserStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMasterclassUserStatisticsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMasterclassUserStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>(ListMasterclassUserStatisticsDocument, options);
      }
export function useListMasterclassUserStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>(ListMasterclassUserStatisticsDocument, options);
        }
export function useListMasterclassUserStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>(ListMasterclassUserStatisticsDocument, options);
        }
export type ListMasterclassUserStatisticsQueryHookResult = ReturnType<typeof useListMasterclassUserStatisticsQuery>;
export type ListMasterclassUserStatisticsLazyQueryHookResult = ReturnType<typeof useListMasterclassUserStatisticsLazyQuery>;
export type ListMasterclassUserStatisticsSuspenseQueryHookResult = ReturnType<typeof useListMasterclassUserStatisticsSuspenseQuery>;
export type ListMasterclassUserStatisticsQueryResult = Apollo.QueryResult<ListMasterclassUserStatisticsQuery, ListMasterclassUserStatisticsQueryVariables>;
export const UpdateMasterclassUserStatisticsDocument = gql`
    mutation updateMasterclassUserStatistics($data: UpdateMasterclassUserStatisticsInputDTO!) {
  updateMasterclassUserStatistics(data: $data) {
    ...MasterclassUserStatisticsFields
  }
}
    ${MasterclassUserStatisticsFieldsFragmentDoc}`;
export type UpdateMasterclassUserStatisticsMutationFn = Apollo.MutationFunction<UpdateMasterclassUserStatisticsMutation, UpdateMasterclassUserStatisticsMutationVariables>;

/**
 * __useUpdateMasterclassUserStatisticsMutation__
 *
 * To run a mutation, you first call `useUpdateMasterclassUserStatisticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterclassUserStatisticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterclassUserStatisticsMutation, { data, loading, error }] = useUpdateMasterclassUserStatisticsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMasterclassUserStatisticsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterclassUserStatisticsMutation, UpdateMasterclassUserStatisticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterclassUserStatisticsMutation, UpdateMasterclassUserStatisticsMutationVariables>(UpdateMasterclassUserStatisticsDocument, options);
      }
export type UpdateMasterclassUserStatisticsMutationHookResult = ReturnType<typeof useUpdateMasterclassUserStatisticsMutation>;
export type UpdateMasterclassUserStatisticsMutationResult = Apollo.MutationResult<UpdateMasterclassUserStatisticsMutation>;
export type UpdateMasterclassUserStatisticsMutationOptions = Apollo.BaseMutationOptions<UpdateMasterclassUserStatisticsMutation, UpdateMasterclassUserStatisticsMutationVariables>;
export const OnCreateMasterclassUserStatisticsDocument = gql`
    subscription onCreateMasterclassUserStatistics($where: MasterclassUserStatisticsWhereInput) {
  onCreateMasterclassUserStatistics(where: $where) {
    ...MasterclassUserStatisticsFields
  }
}
    ${MasterclassUserStatisticsFieldsFragmentDoc}`;

/**
 * __useOnCreateMasterclassUserStatisticsSubscription__
 *
 * To run a query within a React component, call `useOnCreateMasterclassUserStatisticsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMasterclassUserStatisticsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMasterclassUserStatisticsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMasterclassUserStatisticsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMasterclassUserStatisticsSubscription, OnCreateMasterclassUserStatisticsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMasterclassUserStatisticsSubscription, OnCreateMasterclassUserStatisticsSubscriptionVariables>(OnCreateMasterclassUserStatisticsDocument, options);
      }
export type OnCreateMasterclassUserStatisticsSubscriptionHookResult = ReturnType<typeof useOnCreateMasterclassUserStatisticsSubscription>;
export type OnCreateMasterclassUserStatisticsSubscriptionResult = Apollo.SubscriptionResult<OnCreateMasterclassUserStatisticsSubscription>;
export const OnUpdateMasterclassUserStatisticsDocument = gql`
    subscription onUpdateMasterclassUserStatistics($where: MasterclassUserStatisticsWhereInput) {
  onUpdateMasterclassUserStatistics(where: $where) {
    ...MasterclassUserStatisticsFields
  }
}
    ${MasterclassUserStatisticsFieldsFragmentDoc}`;

/**
 * __useOnUpdateMasterclassUserStatisticsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMasterclassUserStatisticsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMasterclassUserStatisticsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMasterclassUserStatisticsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMasterclassUserStatisticsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMasterclassUserStatisticsSubscription, OnUpdateMasterclassUserStatisticsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMasterclassUserStatisticsSubscription, OnUpdateMasterclassUserStatisticsSubscriptionVariables>(OnUpdateMasterclassUserStatisticsDocument, options);
      }
export type OnUpdateMasterclassUserStatisticsSubscriptionHookResult = ReturnType<typeof useOnUpdateMasterclassUserStatisticsSubscription>;
export type OnUpdateMasterclassUserStatisticsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMasterclassUserStatisticsSubscription>;
export const CreateMasterClassDocument = gql`
    mutation createMasterClass($data: CreateMasterClassInputDTO!) {
  createMasterClass(data: $data) {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;
export type CreateMasterClassMutationFn = Apollo.MutationFunction<CreateMasterClassMutation, CreateMasterClassMutationVariables>;

/**
 * __useCreateMasterClassMutation__
 *
 * To run a mutation, you first call `useCreateMasterClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterClassMutation, { data, loading, error }] = useCreateMasterClassMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMasterClassMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterClassMutation, CreateMasterClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterClassMutation, CreateMasterClassMutationVariables>(CreateMasterClassDocument, options);
      }
export type CreateMasterClassMutationHookResult = ReturnType<typeof useCreateMasterClassMutation>;
export type CreateMasterClassMutationResult = Apollo.MutationResult<CreateMasterClassMutation>;
export type CreateMasterClassMutationOptions = Apollo.BaseMutationOptions<CreateMasterClassMutation, CreateMasterClassMutationVariables>;
export const UpdateMasterClassDocument = gql`
    mutation updateMasterClass($data: UpdateMasterClassInputDTO!) {
  updateMasterClass(data: $data) {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;
export type UpdateMasterClassMutationFn = Apollo.MutationFunction<UpdateMasterClassMutation, UpdateMasterClassMutationVariables>;

/**
 * __useUpdateMasterClassMutation__
 *
 * To run a mutation, you first call `useUpdateMasterClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterClassMutation, { data, loading, error }] = useUpdateMasterClassMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMasterClassMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterClassMutation, UpdateMasterClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterClassMutation, UpdateMasterClassMutationVariables>(UpdateMasterClassDocument, options);
      }
export type UpdateMasterClassMutationHookResult = ReturnType<typeof useUpdateMasterClassMutation>;
export type UpdateMasterClassMutationResult = Apollo.MutationResult<UpdateMasterClassMutation>;
export type UpdateMasterClassMutationOptions = Apollo.BaseMutationOptions<UpdateMasterClassMutation, UpdateMasterClassMutationVariables>;
export const GetMasterClassDocument = gql`
    query getMasterClass($where: MasterClassWhereUniqueInput!) {
  getMasterClass(where: $where) {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;

/**
 * __useGetMasterClassQuery__
 *
 * To run a query within a React component, call `useGetMasterClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterClassQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterClassQuery(baseOptions: Apollo.QueryHookOptions<GetMasterClassQuery, GetMasterClassQueryVariables> & ({ variables: GetMasterClassQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterClassQuery, GetMasterClassQueryVariables>(GetMasterClassDocument, options);
      }
export function useGetMasterClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterClassQuery, GetMasterClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterClassQuery, GetMasterClassQueryVariables>(GetMasterClassDocument, options);
        }
export function useGetMasterClassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterClassQuery, GetMasterClassQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterClassQuery, GetMasterClassQueryVariables>(GetMasterClassDocument, options);
        }
export type GetMasterClassQueryHookResult = ReturnType<typeof useGetMasterClassQuery>;
export type GetMasterClassLazyQueryHookResult = ReturnType<typeof useGetMasterClassLazyQuery>;
export type GetMasterClassSuspenseQueryHookResult = ReturnType<typeof useGetMasterClassSuspenseQuery>;
export type GetMasterClassQueryResult = Apollo.QueryResult<GetMasterClassQuery, GetMasterClassQueryVariables>;
export const GetMasterClassAccessDocument = gql`
    query getMasterClassAccess($where: MasterClassWhereUniqueInput!) {
  getMasterClass(where: $where) {
    id
    ...MasterClassMyAccess
  }
}
    ${MasterClassMyAccessFragmentDoc}`;

/**
 * __useGetMasterClassAccessQuery__
 *
 * To run a query within a React component, call `useGetMasterClassAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterClassAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterClassAccessQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterClassAccessQuery(baseOptions: Apollo.QueryHookOptions<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables> & ({ variables: GetMasterClassAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables>(GetMasterClassAccessDocument, options);
      }
export function useGetMasterClassAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables>(GetMasterClassAccessDocument, options);
        }
export function useGetMasterClassAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables>(GetMasterClassAccessDocument, options);
        }
export type GetMasterClassAccessQueryHookResult = ReturnType<typeof useGetMasterClassAccessQuery>;
export type GetMasterClassAccessLazyQueryHookResult = ReturnType<typeof useGetMasterClassAccessLazyQuery>;
export type GetMasterClassAccessSuspenseQueryHookResult = ReturnType<typeof useGetMasterClassAccessSuspenseQuery>;
export type GetMasterClassAccessQueryResult = Apollo.QueryResult<GetMasterClassAccessQuery, GetMasterClassAccessQueryVariables>;
export const GetMasterClassWithPatientCasesDocument = gql`
    query getMasterClassWithPatientCases($where: MasterClassWhereUniqueInput!, $patientCasesPaginationArgs: PaginationArgs) {
  getMasterClass(where: $where) {
    ...MasterClassFields
    ...MasterClassRelationPatientCases
  }
}
    ${MasterClassFieldsFragmentDoc}
${MasterClassRelationPatientCasesFragmentDoc}`;

/**
 * __useGetMasterClassWithPatientCasesQuery__
 *
 * To run a query within a React component, call `useGetMasterClassWithPatientCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterClassWithPatientCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterClassWithPatientCasesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      patientCasesPaginationArgs: // value for 'patientCasesPaginationArgs'
 *   },
 * });
 */
export function useGetMasterClassWithPatientCasesQuery(baseOptions: Apollo.QueryHookOptions<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables> & ({ variables: GetMasterClassWithPatientCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables>(GetMasterClassWithPatientCasesDocument, options);
      }
export function useGetMasterClassWithPatientCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables>(GetMasterClassWithPatientCasesDocument, options);
        }
export function useGetMasterClassWithPatientCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables>(GetMasterClassWithPatientCasesDocument, options);
        }
export type GetMasterClassWithPatientCasesQueryHookResult = ReturnType<typeof useGetMasterClassWithPatientCasesQuery>;
export type GetMasterClassWithPatientCasesLazyQueryHookResult = ReturnType<typeof useGetMasterClassWithPatientCasesLazyQuery>;
export type GetMasterClassWithPatientCasesSuspenseQueryHookResult = ReturnType<typeof useGetMasterClassWithPatientCasesSuspenseQuery>;
export type GetMasterClassWithPatientCasesQueryResult = Apollo.QueryResult<GetMasterClassWithPatientCasesQuery, GetMasterClassWithPatientCasesQueryVariables>;
export const ListMasterClassesDocument = gql`
    query listMasterClasses($where: MasterClassWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMasterClasses(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MasterClassFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MasterClassFieldsFragmentDoc}`;

/**
 * __useListMasterClassesQuery__
 *
 * To run a query within a React component, call `useListMasterClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMasterClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMasterClassesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMasterClassesQuery(baseOptions?: Apollo.QueryHookOptions<ListMasterClassesQuery, ListMasterClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMasterClassesQuery, ListMasterClassesQueryVariables>(ListMasterClassesDocument, options);
      }
export function useListMasterClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMasterClassesQuery, ListMasterClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMasterClassesQuery, ListMasterClassesQueryVariables>(ListMasterClassesDocument, options);
        }
export function useListMasterClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMasterClassesQuery, ListMasterClassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMasterClassesQuery, ListMasterClassesQueryVariables>(ListMasterClassesDocument, options);
        }
export type ListMasterClassesQueryHookResult = ReturnType<typeof useListMasterClassesQuery>;
export type ListMasterClassesLazyQueryHookResult = ReturnType<typeof useListMasterClassesLazyQuery>;
export type ListMasterClassesSuspenseQueryHookResult = ReturnType<typeof useListMasterClassesSuspenseQuery>;
export type ListMasterClassesQueryResult = Apollo.QueryResult<ListMasterClassesQuery, ListMasterClassesQueryVariables>;
export const ListMasterClassesWithSessionsDocument = gql`
    query listMasterClassesWithSessions($where: MasterClassWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMasterClasses(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MasterClassWithSessionFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MasterClassWithSessionFieldsFragmentDoc}`;

/**
 * __useListMasterClassesWithSessionsQuery__
 *
 * To run a query within a React component, call `useListMasterClassesWithSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMasterClassesWithSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMasterClassesWithSessionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMasterClassesWithSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>(ListMasterClassesWithSessionsDocument, options);
      }
export function useListMasterClassesWithSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>(ListMasterClassesWithSessionsDocument, options);
        }
export function useListMasterClassesWithSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>(ListMasterClassesWithSessionsDocument, options);
        }
export type ListMasterClassesWithSessionsQueryHookResult = ReturnType<typeof useListMasterClassesWithSessionsQuery>;
export type ListMasterClassesWithSessionsLazyQueryHookResult = ReturnType<typeof useListMasterClassesWithSessionsLazyQuery>;
export type ListMasterClassesWithSessionsSuspenseQueryHookResult = ReturnType<typeof useListMasterClassesWithSessionsSuspenseQuery>;
export type ListMasterClassesWithSessionsQueryResult = Apollo.QueryResult<ListMasterClassesWithSessionsQuery, ListMasterClassesWithSessionsQueryVariables>;
export const DeleteMasterClassDocument = gql`
    mutation deleteMasterClass($where: MasterClassWhereUniqueInput!) {
  deleteMasterClass(where: $where) {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;
export type DeleteMasterClassMutationFn = Apollo.MutationFunction<DeleteMasterClassMutation, DeleteMasterClassMutationVariables>;

/**
 * __useDeleteMasterClassMutation__
 *
 * To run a mutation, you first call `useDeleteMasterClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterClassMutation, { data, loading, error }] = useDeleteMasterClassMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMasterClassMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMasterClassMutation, DeleteMasterClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMasterClassMutation, DeleteMasterClassMutationVariables>(DeleteMasterClassDocument, options);
      }
export type DeleteMasterClassMutationHookResult = ReturnType<typeof useDeleteMasterClassMutation>;
export type DeleteMasterClassMutationResult = Apollo.MutationResult<DeleteMasterClassMutation>;
export type DeleteMasterClassMutationOptions = Apollo.BaseMutationOptions<DeleteMasterClassMutation, DeleteMasterClassMutationVariables>;
export const OnCreateMasterClassDocument = gql`
    subscription onCreateMasterClass($where: MasterClassWhereInput) {
  onCreateMasterClass(where: $where) {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;

/**
 * __useOnCreateMasterClassSubscription__
 *
 * To run a query within a React component, call `useOnCreateMasterClassSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMasterClassSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMasterClassSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMasterClassSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMasterClassSubscription, OnCreateMasterClassSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMasterClassSubscription, OnCreateMasterClassSubscriptionVariables>(OnCreateMasterClassDocument, options);
      }
export type OnCreateMasterClassSubscriptionHookResult = ReturnType<typeof useOnCreateMasterClassSubscription>;
export type OnCreateMasterClassSubscriptionResult = Apollo.SubscriptionResult<OnCreateMasterClassSubscription>;
export const OnUpdateMasterClassDocument = gql`
    subscription onUpdateMasterClass($where: MasterClassWhereInput) {
  onUpdateMasterClass(where: $where) {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;

/**
 * __useOnUpdateMasterClassSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMasterClassSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMasterClassSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMasterClassSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMasterClassSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMasterClassSubscription, OnUpdateMasterClassSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMasterClassSubscription, OnUpdateMasterClassSubscriptionVariables>(OnUpdateMasterClassDocument, options);
      }
export type OnUpdateMasterClassSubscriptionHookResult = ReturnType<typeof useOnUpdateMasterClassSubscription>;
export type OnUpdateMasterClassSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMasterClassSubscription>;
export const OnDeleteMasterClassDocument = gql`
    subscription onDeleteMasterClass {
  onDeleteMasterClass {
    ...MasterClassFields
  }
}
    ${MasterClassFieldsFragmentDoc}`;

/**
 * __useOnDeleteMasterClassSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMasterClassSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMasterClassSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMasterClassSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteMasterClassSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteMasterClassSubscription, OnDeleteMasterClassSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMasterClassSubscription, OnDeleteMasterClassSubscriptionVariables>(OnDeleteMasterClassDocument, options);
      }
export type OnDeleteMasterClassSubscriptionHookResult = ReturnType<typeof useOnDeleteMasterClassSubscription>;
export type OnDeleteMasterClassSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMasterClassSubscription>;
export const GetMeetingStatsDocument = gql`
    query getMeetingStats($where: MeetingStatsWhereUniqueInput!) {
  getMeetingStats(where: $where) {
    ...MeetingStatsFields
  }
}
    ${MeetingStatsFieldsFragmentDoc}`;

/**
 * __useGetMeetingStatsQuery__
 *
 * To run a query within a React component, call `useGetMeetingStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingStatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMeetingStatsQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingStatsQuery, GetMeetingStatsQueryVariables> & ({ variables: GetMeetingStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingStatsQuery, GetMeetingStatsQueryVariables>(GetMeetingStatsDocument, options);
      }
export function useGetMeetingStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingStatsQuery, GetMeetingStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingStatsQuery, GetMeetingStatsQueryVariables>(GetMeetingStatsDocument, options);
        }
export function useGetMeetingStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeetingStatsQuery, GetMeetingStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeetingStatsQuery, GetMeetingStatsQueryVariables>(GetMeetingStatsDocument, options);
        }
export type GetMeetingStatsQueryHookResult = ReturnType<typeof useGetMeetingStatsQuery>;
export type GetMeetingStatsLazyQueryHookResult = ReturnType<typeof useGetMeetingStatsLazyQuery>;
export type GetMeetingStatsSuspenseQueryHookResult = ReturnType<typeof useGetMeetingStatsSuspenseQuery>;
export type GetMeetingStatsQueryResult = Apollo.QueryResult<GetMeetingStatsQuery, GetMeetingStatsQueryVariables>;
export const UpdateMeetingStatsDocument = gql`
    mutation updateMeetingStats($data: UpdateMeetingStatsInputDTO!) {
  updateMeetingStats(data: $data) {
    ...MeetingStatsFields
  }
}
    ${MeetingStatsFieldsFragmentDoc}`;
export type UpdateMeetingStatsMutationFn = Apollo.MutationFunction<UpdateMeetingStatsMutation, UpdateMeetingStatsMutationVariables>;

/**
 * __useUpdateMeetingStatsMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingStatsMutation, { data, loading, error }] = useUpdateMeetingStatsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMeetingStatsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingStatsMutation, UpdateMeetingStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeetingStatsMutation, UpdateMeetingStatsMutationVariables>(UpdateMeetingStatsDocument, options);
      }
export type UpdateMeetingStatsMutationHookResult = ReturnType<typeof useUpdateMeetingStatsMutation>;
export type UpdateMeetingStatsMutationResult = Apollo.MutationResult<UpdateMeetingStatsMutation>;
export type UpdateMeetingStatsMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingStatsMutation, UpdateMeetingStatsMutationVariables>;
export const OnCreateMeetingStatsDocument = gql`
    subscription onCreateMeetingStats($where: MeetingStatsWhereInput) {
  onCreateMeetingStats(where: $where) {
    ...MeetingStatsFields
  }
}
    ${MeetingStatsFieldsFragmentDoc}`;

/**
 * __useOnCreateMeetingStatsSubscription__
 *
 * To run a query within a React component, call `useOnCreateMeetingStatsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMeetingStatsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMeetingStatsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMeetingStatsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMeetingStatsSubscription, OnCreateMeetingStatsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMeetingStatsSubscription, OnCreateMeetingStatsSubscriptionVariables>(OnCreateMeetingStatsDocument, options);
      }
export type OnCreateMeetingStatsSubscriptionHookResult = ReturnType<typeof useOnCreateMeetingStatsSubscription>;
export type OnCreateMeetingStatsSubscriptionResult = Apollo.SubscriptionResult<OnCreateMeetingStatsSubscription>;
export const OnUpdateMeetingStatsDocument = gql`
    subscription onUpdateMeetingStats($where: MeetingStatsWhereInput) {
  onUpdateMeetingStats(where: $where) {
    ...MeetingStatsFields
  }
}
    ${MeetingStatsFieldsFragmentDoc}`;

/**
 * __useOnUpdateMeetingStatsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMeetingStatsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMeetingStatsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMeetingStatsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMeetingStatsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMeetingStatsSubscription, OnUpdateMeetingStatsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMeetingStatsSubscription, OnUpdateMeetingStatsSubscriptionVariables>(OnUpdateMeetingStatsDocument, options);
      }
export type OnUpdateMeetingStatsSubscriptionHookResult = ReturnType<typeof useOnUpdateMeetingStatsSubscription>;
export type OnUpdateMeetingStatsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMeetingStatsSubscription>;
export const OnDeleteMeetingStatsDocument = gql`
    subscription onDeleteMeetingStats {
  onDeleteMeetingStats {
    ...MeetingStatsFields
  }
}
    ${MeetingStatsFieldsFragmentDoc}`;

/**
 * __useOnDeleteMeetingStatsSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMeetingStatsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMeetingStatsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMeetingStatsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteMeetingStatsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteMeetingStatsSubscription, OnDeleteMeetingStatsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMeetingStatsSubscription, OnDeleteMeetingStatsSubscriptionVariables>(OnDeleteMeetingStatsDocument, options);
      }
export type OnDeleteMeetingStatsSubscriptionHookResult = ReturnType<typeof useOnDeleteMeetingStatsSubscription>;
export type OnDeleteMeetingStatsSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMeetingStatsSubscription>;
export const CreateMeetingDocument = gql`
    mutation createMeeting($data: CreateMeetingInputDTO!) {
  createMeeting(data: $data) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    mutation updateMeeting($data: UpdateMeetingInputDTO!) {
  updateMeeting(data: $data) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;
export type UpdateMeetingMutationFn = Apollo.MutationFunction<UpdateMeetingMutation, UpdateMeetingMutationVariables>;

/**
 * __useUpdateMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingMutation, { data, loading, error }] = useUpdateMeetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(UpdateMeetingDocument, options);
      }
export type UpdateMeetingMutationHookResult = ReturnType<typeof useUpdateMeetingMutation>;
export type UpdateMeetingMutationResult = Apollo.MutationResult<UpdateMeetingMutation>;
export type UpdateMeetingMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>;
export const GetMeetingDocument = gql`
    query getMeeting($where: MeetingWhereUniqueInput!) {
  getMeeting(where: $where) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;

/**
 * __useGetMeetingQuery__
 *
 * To run a query within a React component, call `useGetMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMeetingQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingQuery, GetMeetingQueryVariables> & ({ variables: GetMeetingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingQuery, GetMeetingQueryVariables>(GetMeetingDocument, options);
      }
export function useGetMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingQuery, GetMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingQuery, GetMeetingQueryVariables>(GetMeetingDocument, options);
        }
export function useGetMeetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeetingQuery, GetMeetingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeetingQuery, GetMeetingQueryVariables>(GetMeetingDocument, options);
        }
export type GetMeetingQueryHookResult = ReturnType<typeof useGetMeetingQuery>;
export type GetMeetingLazyQueryHookResult = ReturnType<typeof useGetMeetingLazyQuery>;
export type GetMeetingSuspenseQueryHookResult = ReturnType<typeof useGetMeetingSuspenseQuery>;
export type GetMeetingQueryResult = Apollo.QueryResult<GetMeetingQuery, GetMeetingQueryVariables>;
export const ListMeetingsDocument = gql`
    query listMeetings($where: MeetingWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMeetings(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MeetingFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MeetingFieldsFragmentDoc}`;

/**
 * __useListMeetingsQuery__
 *
 * To run a query within a React component, call `useListMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMeetingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMeetingsQuery(baseOptions?: Apollo.QueryHookOptions<ListMeetingsQuery, ListMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMeetingsQuery, ListMeetingsQueryVariables>(ListMeetingsDocument, options);
      }
export function useListMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMeetingsQuery, ListMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMeetingsQuery, ListMeetingsQueryVariables>(ListMeetingsDocument, options);
        }
export function useListMeetingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMeetingsQuery, ListMeetingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMeetingsQuery, ListMeetingsQueryVariables>(ListMeetingsDocument, options);
        }
export type ListMeetingsQueryHookResult = ReturnType<typeof useListMeetingsQuery>;
export type ListMeetingsLazyQueryHookResult = ReturnType<typeof useListMeetingsLazyQuery>;
export type ListMeetingsSuspenseQueryHookResult = ReturnType<typeof useListMeetingsSuspenseQuery>;
export type ListMeetingsQueryResult = Apollo.QueryResult<ListMeetingsQuery, ListMeetingsQueryVariables>;
export const DeleteMeetingDocument = gql`
    mutation deleteMeeting($where: MeetingWhereUniqueInput!) {
  deleteMeeting(where: $where) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;
export type DeleteMeetingMutationFn = Apollo.MutationFunction<DeleteMeetingMutation, DeleteMeetingMutationVariables>;

/**
 * __useDeleteMeetingMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeetingMutation, { data, loading, error }] = useDeleteMeetingMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMeetingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMeetingMutation, DeleteMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMeetingMutation, DeleteMeetingMutationVariables>(DeleteMeetingDocument, options);
      }
export type DeleteMeetingMutationHookResult = ReturnType<typeof useDeleteMeetingMutation>;
export type DeleteMeetingMutationResult = Apollo.MutationResult<DeleteMeetingMutation>;
export type DeleteMeetingMutationOptions = Apollo.BaseMutationOptions<DeleteMeetingMutation, DeleteMeetingMutationVariables>;
export const ResetMeetingDocument = gql`
    mutation resetMeeting($where: MeetingWhereUniqueInput!, $data: ResetMeetingInputDTO!) {
  resetMeeting(where: $where, data: $data)
}
    `;
export type ResetMeetingMutationFn = Apollo.MutationFunction<ResetMeetingMutation, ResetMeetingMutationVariables>;

/**
 * __useResetMeetingMutation__
 *
 * To run a mutation, you first call `useResetMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMeetingMutation, { data, loading, error }] = useResetMeetingMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResetMeetingMutation(baseOptions?: Apollo.MutationHookOptions<ResetMeetingMutation, ResetMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMeetingMutation, ResetMeetingMutationVariables>(ResetMeetingDocument, options);
      }
export type ResetMeetingMutationHookResult = ReturnType<typeof useResetMeetingMutation>;
export type ResetMeetingMutationResult = Apollo.MutationResult<ResetMeetingMutation>;
export type ResetMeetingMutationOptions = Apollo.BaseMutationOptions<ResetMeetingMutation, ResetMeetingMutationVariables>;
export const CancelMeetingDocument = gql`
    mutation cancelMeeting($where: MeetingWhereUniqueInput!) {
  cancelMeeting(where: $where)
}
    `;
export type CancelMeetingMutationFn = Apollo.MutationFunction<CancelMeetingMutation, CancelMeetingMutationVariables>;

/**
 * __useCancelMeetingMutation__
 *
 * To run a mutation, you first call `useCancelMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMeetingMutation, { data, loading, error }] = useCancelMeetingMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCancelMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CancelMeetingMutation, CancelMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMeetingMutation, CancelMeetingMutationVariables>(CancelMeetingDocument, options);
      }
export type CancelMeetingMutationHookResult = ReturnType<typeof useCancelMeetingMutation>;
export type CancelMeetingMutationResult = Apollo.MutationResult<CancelMeetingMutation>;
export type CancelMeetingMutationOptions = Apollo.BaseMutationOptions<CancelMeetingMutation, CancelMeetingMutationVariables>;
export const OnCreateMeetingDocument = gql`
    subscription onCreateMeeting($where: MeetingWhereInput) {
  onCreateMeeting(where: $where) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;

/**
 * __useOnCreateMeetingSubscription__
 *
 * To run a query within a React component, call `useOnCreateMeetingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMeetingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMeetingSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMeetingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMeetingSubscription, OnCreateMeetingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMeetingSubscription, OnCreateMeetingSubscriptionVariables>(OnCreateMeetingDocument, options);
      }
export type OnCreateMeetingSubscriptionHookResult = ReturnType<typeof useOnCreateMeetingSubscription>;
export type OnCreateMeetingSubscriptionResult = Apollo.SubscriptionResult<OnCreateMeetingSubscription>;
export const OnUpdateMeetingDocument = gql`
    subscription onUpdateMeeting($where: MeetingWhereInput) {
  onUpdateMeeting(where: $where) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;

/**
 * __useOnUpdateMeetingSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMeetingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMeetingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMeetingSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMeetingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMeetingSubscription, OnUpdateMeetingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMeetingSubscription, OnUpdateMeetingSubscriptionVariables>(OnUpdateMeetingDocument, options);
      }
export type OnUpdateMeetingSubscriptionHookResult = ReturnType<typeof useOnUpdateMeetingSubscription>;
export type OnUpdateMeetingSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMeetingSubscription>;
export const OnDeleteMeetingDocument = gql`
    subscription onDeleteMeeting {
  onDeleteMeeting {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;

/**
 * __useOnDeleteMeetingSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMeetingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMeetingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMeetingSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteMeetingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteMeetingSubscription, OnDeleteMeetingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMeetingSubscription, OnDeleteMeetingSubscriptionVariables>(OnDeleteMeetingDocument, options);
      }
export type OnDeleteMeetingSubscriptionHookResult = ReturnType<typeof useOnDeleteMeetingSubscription>;
export type OnDeleteMeetingSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMeetingSubscription>;
export const GetAvailableDatesDocument = gql`
    query getAvailableDates($data: GetAvailableDatesInputDTO!) {
  getAvailableDates(data: $data) {
    date
    totalTeams
    bookedTeams
    availableTeams
    isFullyBooked
  }
}
    `;

/**
 * __useGetAvailableDatesQuery__
 *
 * To run a query within a React component, call `useGetAvailableDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableDatesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAvailableDatesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableDatesQuery, GetAvailableDatesQueryVariables> & ({ variables: GetAvailableDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableDatesQuery, GetAvailableDatesQueryVariables>(GetAvailableDatesDocument, options);
      }
export function useGetAvailableDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableDatesQuery, GetAvailableDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableDatesQuery, GetAvailableDatesQueryVariables>(GetAvailableDatesDocument, options);
        }
export function useGetAvailableDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableDatesQuery, GetAvailableDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableDatesQuery, GetAvailableDatesQueryVariables>(GetAvailableDatesDocument, options);
        }
export type GetAvailableDatesQueryHookResult = ReturnType<typeof useGetAvailableDatesQuery>;
export type GetAvailableDatesLazyQueryHookResult = ReturnType<typeof useGetAvailableDatesLazyQuery>;
export type GetAvailableDatesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableDatesSuspenseQuery>;
export type GetAvailableDatesQueryResult = Apollo.QueryResult<GetAvailableDatesQuery, GetAvailableDatesQueryVariables>;
export const ApproveMeetingDocument = gql`
    mutation approveMeeting($data: ApproveMeetingInputDTO!) {
  approveMeeting(data: $data) {
    ...MeetingFields
  }
}
    ${MeetingFieldsFragmentDoc}`;
export type ApproveMeetingMutationFn = Apollo.MutationFunction<ApproveMeetingMutation, ApproveMeetingMutationVariables>;

/**
 * __useApproveMeetingMutation__
 *
 * To run a mutation, you first call `useApproveMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMeetingMutation, { data, loading, error }] = useApproveMeetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApproveMeetingMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMeetingMutation, ApproveMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMeetingMutation, ApproveMeetingMutationVariables>(ApproveMeetingDocument, options);
      }
export type ApproveMeetingMutationHookResult = ReturnType<typeof useApproveMeetingMutation>;
export type ApproveMeetingMutationResult = Apollo.MutationResult<ApproveMeetingMutation>;
export type ApproveMeetingMutationOptions = Apollo.BaseMutationOptions<ApproveMeetingMutation, ApproveMeetingMutationVariables>;
export const CreateMessageDocument = gql`
    mutation createMessage($data: CreateMessageInputDTO!) {
  createMessage(data: $data) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const ListMessagesDocument = gql`
    query listMessages($where: MessageWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listMessages(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...MessageFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useListMessagesQuery__
 *
 * To run a query within a React component, call `useListMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListMessagesQuery(baseOptions?: Apollo.QueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
      }
export function useListMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
        }
export function useListMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
        }
export type ListMessagesQueryHookResult = ReturnType<typeof useListMessagesQuery>;
export type ListMessagesLazyQueryHookResult = ReturnType<typeof useListMessagesLazyQuery>;
export type ListMessagesSuspenseQueryHookResult = ReturnType<typeof useListMessagesSuspenseQuery>;
export type ListMessagesQueryResult = Apollo.QueryResult<ListMessagesQuery, ListMessagesQueryVariables>;
export const DeleteMessagesDocument = gql`
    mutation deleteMessages($where: MessageWhereInput!) {
  deleteMessages(where: $where) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type DeleteMessagesMutationFn = Apollo.MutationFunction<DeleteMessagesMutation, DeleteMessagesMutationVariables>;

/**
 * __useDeleteMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessagesMutation, { data, loading, error }] = useDeleteMessagesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMessagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessagesMutation, DeleteMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessagesMutation, DeleteMessagesMutationVariables>(DeleteMessagesDocument, options);
      }
export type DeleteMessagesMutationHookResult = ReturnType<typeof useDeleteMessagesMutation>;
export type DeleteMessagesMutationResult = Apollo.MutationResult<DeleteMessagesMutation>;
export type DeleteMessagesMutationOptions = Apollo.BaseMutationOptions<DeleteMessagesMutation, DeleteMessagesMutationVariables>;
export const OnCreateMessageDocument = gql`
    subscription onCreateMessage($where: MessageWhereInput) {
  onCreateMessage(where: $where) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useOnCreateMessageSubscription__
 *
 * To run a query within a React component, call `useOnCreateMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMessageSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateMessageSubscription, OnCreateMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMessageSubscription, OnCreateMessageSubscriptionVariables>(OnCreateMessageDocument, options);
      }
export type OnCreateMessageSubscriptionHookResult = ReturnType<typeof useOnCreateMessageSubscription>;
export type OnCreateMessageSubscriptionResult = Apollo.SubscriptionResult<OnCreateMessageSubscription>;
export const OnUpdateMessageDocument = gql`
    subscription onUpdateMessage($where: MessageWhereInput) {
  onUpdateMessage(where: $where) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useOnUpdateMessageSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMessageSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateMessageSubscription, OnUpdateMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMessageSubscription, OnUpdateMessageSubscriptionVariables>(OnUpdateMessageDocument, options);
      }
export type OnUpdateMessageSubscriptionHookResult = ReturnType<typeof useOnUpdateMessageSubscription>;
export type OnUpdateMessageSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMessageSubscription>;
export const OnDeleteMessageDocument = gql`
    subscription onDeleteMessage {
  onDeleteMessage {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useOnDeleteMessageSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMessageSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteMessageSubscription, OnDeleteMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMessageSubscription, OnDeleteMessageSubscriptionVariables>(OnDeleteMessageDocument, options);
      }
export type OnDeleteMessageSubscriptionHookResult = ReturnType<typeof useOnDeleteMessageSubscription>;
export type OnDeleteMessageSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMessageSubscription>;
export const CreateNpsScoreDocument = gql`
    mutation createNPSScore($data: CreateNPSScoreInputDTO!) {
  createNPSScore(data: $data) {
    ...NPSScoreFields
  }
}
    ${NpsScoreFieldsFragmentDoc}`;
export type CreateNpsScoreMutationFn = Apollo.MutationFunction<CreateNpsScoreMutation, CreateNpsScoreMutationVariables>;

/**
 * __useCreateNpsScoreMutation__
 *
 * To run a mutation, you first call `useCreateNpsScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNpsScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNpsScoreMutation, { data, loading, error }] = useCreateNpsScoreMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNpsScoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateNpsScoreMutation, CreateNpsScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNpsScoreMutation, CreateNpsScoreMutationVariables>(CreateNpsScoreDocument, options);
      }
export type CreateNpsScoreMutationHookResult = ReturnType<typeof useCreateNpsScoreMutation>;
export type CreateNpsScoreMutationResult = Apollo.MutationResult<CreateNpsScoreMutation>;
export type CreateNpsScoreMutationOptions = Apollo.BaseMutationOptions<CreateNpsScoreMutation, CreateNpsScoreMutationVariables>;
export const GetNpsScoreDocument = gql`
    query getNPSScore($where: NPSScoreWhereUniqueInput!) {
  getNPSScore(where: $where) {
    ...NPSScoreFields
  }
}
    ${NpsScoreFieldsFragmentDoc}`;

/**
 * __useGetNpsScoreQuery__
 *
 * To run a query within a React component, call `useGetNpsScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNpsScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNpsScoreQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetNpsScoreQuery(baseOptions: Apollo.QueryHookOptions<GetNpsScoreQuery, GetNpsScoreQueryVariables> & ({ variables: GetNpsScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNpsScoreQuery, GetNpsScoreQueryVariables>(GetNpsScoreDocument, options);
      }
export function useGetNpsScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNpsScoreQuery, GetNpsScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNpsScoreQuery, GetNpsScoreQueryVariables>(GetNpsScoreDocument, options);
        }
export function useGetNpsScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNpsScoreQuery, GetNpsScoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNpsScoreQuery, GetNpsScoreQueryVariables>(GetNpsScoreDocument, options);
        }
export type GetNpsScoreQueryHookResult = ReturnType<typeof useGetNpsScoreQuery>;
export type GetNpsScoreLazyQueryHookResult = ReturnType<typeof useGetNpsScoreLazyQuery>;
export type GetNpsScoreSuspenseQueryHookResult = ReturnType<typeof useGetNpsScoreSuspenseQuery>;
export type GetNpsScoreQueryResult = Apollo.QueryResult<GetNpsScoreQuery, GetNpsScoreQueryVariables>;
export const ListNpsScoresDocument = gql`
    query listNPSScores($where: NPSScoreWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listNPSScores(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...NPSScoreFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${NpsScoreFieldsFragmentDoc}`;

/**
 * __useListNpsScoresQuery__
 *
 * To run a query within a React component, call `useListNpsScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNpsScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNpsScoresQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListNpsScoresQuery(baseOptions?: Apollo.QueryHookOptions<ListNpsScoresQuery, ListNpsScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNpsScoresQuery, ListNpsScoresQueryVariables>(ListNpsScoresDocument, options);
      }
export function useListNpsScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNpsScoresQuery, ListNpsScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNpsScoresQuery, ListNpsScoresQueryVariables>(ListNpsScoresDocument, options);
        }
export function useListNpsScoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListNpsScoresQuery, ListNpsScoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListNpsScoresQuery, ListNpsScoresQueryVariables>(ListNpsScoresDocument, options);
        }
export type ListNpsScoresQueryHookResult = ReturnType<typeof useListNpsScoresQuery>;
export type ListNpsScoresLazyQueryHookResult = ReturnType<typeof useListNpsScoresLazyQuery>;
export type ListNpsScoresSuspenseQueryHookResult = ReturnType<typeof useListNpsScoresSuspenseQuery>;
export type ListNpsScoresQueryResult = Apollo.QueryResult<ListNpsScoresQuery, ListNpsScoresQueryVariables>;
export const OnCreateNpsScoreDocument = gql`
    subscription onCreateNPSScore($where: NPSScoreWhereInput) {
  onCreateNPSScore(where: $where) {
    ...NPSScoreFields
  }
}
    ${NpsScoreFieldsFragmentDoc}`;

/**
 * __useOnCreateNpsScoreSubscription__
 *
 * To run a query within a React component, call `useOnCreateNpsScoreSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateNpsScoreSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateNpsScoreSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateNpsScoreSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateNpsScoreSubscription, OnCreateNpsScoreSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateNpsScoreSubscription, OnCreateNpsScoreSubscriptionVariables>(OnCreateNpsScoreDocument, options);
      }
export type OnCreateNpsScoreSubscriptionHookResult = ReturnType<typeof useOnCreateNpsScoreSubscription>;
export type OnCreateNpsScoreSubscriptionResult = Apollo.SubscriptionResult<OnCreateNpsScoreSubscription>;
export const OnUpdateNpsScoreDocument = gql`
    subscription onUpdateNPSScore($where: NPSScoreWhereInput) {
  onUpdateNPSScore(where: $where) {
    ...NPSScoreFields
  }
}
    ${NpsScoreFieldsFragmentDoc}`;

/**
 * __useOnUpdateNpsScoreSubscription__
 *
 * To run a query within a React component, call `useOnUpdateNpsScoreSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateNpsScoreSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateNpsScoreSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateNpsScoreSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateNpsScoreSubscription, OnUpdateNpsScoreSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateNpsScoreSubscription, OnUpdateNpsScoreSubscriptionVariables>(OnUpdateNpsScoreDocument, options);
      }
export type OnUpdateNpsScoreSubscriptionHookResult = ReturnType<typeof useOnUpdateNpsScoreSubscription>;
export type OnUpdateNpsScoreSubscriptionResult = Apollo.SubscriptionResult<OnUpdateNpsScoreSubscription>;
export const OnDeleteNpsScoreDocument = gql`
    subscription onDeleteNPSScore {
  onDeleteNPSScore {
    ...NPSScoreFields
  }
}
    ${NpsScoreFieldsFragmentDoc}`;

/**
 * __useOnDeleteNpsScoreSubscription__
 *
 * To run a query within a React component, call `useOnDeleteNpsScoreSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteNpsScoreSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteNpsScoreSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteNpsScoreSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteNpsScoreSubscription, OnDeleteNpsScoreSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteNpsScoreSubscription, OnDeleteNpsScoreSubscriptionVariables>(OnDeleteNpsScoreDocument, options);
      }
export type OnDeleteNpsScoreSubscriptionHookResult = ReturnType<typeof useOnDeleteNpsScoreSubscription>;
export type OnDeleteNpsScoreSubscriptionResult = Apollo.SubscriptionResult<OnDeleteNpsScoreSubscription>;
export const GetPatientCaseWithContentDocument = gql`
    query getPatientCaseWithContent($input: PatientCaseFilter!) {
  getPatientCase(input: $input) {
    ...PatientCaseFields
  }
}
    ${PatientCaseFieldsFragmentDoc}`;

/**
 * __useGetPatientCaseWithContentQuery__
 *
 * To run a query within a React component, call `useGetPatientCaseWithContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientCaseWithContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientCaseWithContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPatientCaseWithContentQuery(baseOptions: Apollo.QueryHookOptions<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables> & ({ variables: GetPatientCaseWithContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables>(GetPatientCaseWithContentDocument, options);
      }
export function useGetPatientCaseWithContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables>(GetPatientCaseWithContentDocument, options);
        }
export function useGetPatientCaseWithContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables>(GetPatientCaseWithContentDocument, options);
        }
export type GetPatientCaseWithContentQueryHookResult = ReturnType<typeof useGetPatientCaseWithContentQuery>;
export type GetPatientCaseWithContentLazyQueryHookResult = ReturnType<typeof useGetPatientCaseWithContentLazyQuery>;
export type GetPatientCaseWithContentSuspenseQueryHookResult = ReturnType<typeof useGetPatientCaseWithContentSuspenseQuery>;
export type GetPatientCaseWithContentQueryResult = Apollo.QueryResult<GetPatientCaseWithContentQuery, GetPatientCaseWithContentQueryVariables>;
export const ListPatientCasesDocument = gql`
    query listPatientCases($orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs, $where: PatientCaseWhereInput) {
  listPatientCases(
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
    where: $where
  ) {
    edges {
      node {
        ...UnloadedPatientCaseFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${UnloadedPatientCaseFieldsFragmentDoc}`;

/**
 * __useListPatientCasesQuery__
 *
 * To run a query within a React component, call `useListPatientCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPatientCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPatientCasesQuery({
 *   variables: {
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListPatientCasesQuery(baseOptions?: Apollo.QueryHookOptions<ListPatientCasesQuery, ListPatientCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPatientCasesQuery, ListPatientCasesQueryVariables>(ListPatientCasesDocument, options);
      }
export function useListPatientCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPatientCasesQuery, ListPatientCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPatientCasesQuery, ListPatientCasesQueryVariables>(ListPatientCasesDocument, options);
        }
export function useListPatientCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPatientCasesQuery, ListPatientCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPatientCasesQuery, ListPatientCasesQueryVariables>(ListPatientCasesDocument, options);
        }
export type ListPatientCasesQueryHookResult = ReturnType<typeof useListPatientCasesQuery>;
export type ListPatientCasesLazyQueryHookResult = ReturnType<typeof useListPatientCasesLazyQuery>;
export type ListPatientCasesSuspenseQueryHookResult = ReturnType<typeof useListPatientCasesSuspenseQuery>;
export type ListPatientCasesQueryResult = Apollo.QueryResult<ListPatientCasesQuery, ListPatientCasesQueryVariables>;
export const ListPatientCasesWithContentDocument = gql`
    query listPatientCasesWithContent($orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs, $where: PatientCaseWhereInput) {
  listPatientCases(
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
    where: $where
  ) {
    edges {
      node {
        ...PatientCaseFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${PatientCaseFieldsFragmentDoc}`;

/**
 * __useListPatientCasesWithContentQuery__
 *
 * To run a query within a React component, call `useListPatientCasesWithContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPatientCasesWithContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPatientCasesWithContentQuery({
 *   variables: {
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListPatientCasesWithContentQuery(baseOptions?: Apollo.QueryHookOptions<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>(ListPatientCasesWithContentDocument, options);
      }
export function useListPatientCasesWithContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>(ListPatientCasesWithContentDocument, options);
        }
export function useListPatientCasesWithContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>(ListPatientCasesWithContentDocument, options);
        }
export type ListPatientCasesWithContentQueryHookResult = ReturnType<typeof useListPatientCasesWithContentQuery>;
export type ListPatientCasesWithContentLazyQueryHookResult = ReturnType<typeof useListPatientCasesWithContentLazyQuery>;
export type ListPatientCasesWithContentSuspenseQueryHookResult = ReturnType<typeof useListPatientCasesWithContentSuspenseQuery>;
export type ListPatientCasesWithContentQueryResult = Apollo.QueryResult<ListPatientCasesWithContentQuery, ListPatientCasesWithContentQueryVariables>;
export const CreateOrUpdateSlideStatsDocument = gql`
    mutation createOrUpdateSlideStats($data: CreateOrUpdateSlideStatsDto!) {
  createOrUpdateSlideStats(data: $data) {
    ...SlideStatsFields
  }
}
    ${SlideStatsFieldsFragmentDoc}`;
export type CreateOrUpdateSlideStatsMutationFn = Apollo.MutationFunction<CreateOrUpdateSlideStatsMutation, CreateOrUpdateSlideStatsMutationVariables>;

/**
 * __useCreateOrUpdateSlideStatsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSlideStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSlideStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSlideStatsMutation, { data, loading, error }] = useCreateOrUpdateSlideStatsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrUpdateSlideStatsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateSlideStatsMutation, CreateOrUpdateSlideStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateSlideStatsMutation, CreateOrUpdateSlideStatsMutationVariables>(CreateOrUpdateSlideStatsDocument, options);
      }
export type CreateOrUpdateSlideStatsMutationHookResult = ReturnType<typeof useCreateOrUpdateSlideStatsMutation>;
export type CreateOrUpdateSlideStatsMutationResult = Apollo.MutationResult<CreateOrUpdateSlideStatsMutation>;
export type CreateOrUpdateSlideStatsMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateSlideStatsMutation, CreateOrUpdateSlideStatsMutationVariables>;
export const GetSlideStatsDocument = gql`
    query getSlideStats($where: SlideStatsWhereUniqueInput!) {
  getSlideStats(where: $where) {
    ...SlideStatsFields
  }
}
    ${SlideStatsFieldsFragmentDoc}`;

/**
 * __useGetSlideStatsQuery__
 *
 * To run a query within a React component, call `useGetSlideStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideStatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSlideStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSlideStatsQuery, GetSlideStatsQueryVariables> & ({ variables: GetSlideStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlideStatsQuery, GetSlideStatsQueryVariables>(GetSlideStatsDocument, options);
      }
export function useGetSlideStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlideStatsQuery, GetSlideStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlideStatsQuery, GetSlideStatsQueryVariables>(GetSlideStatsDocument, options);
        }
export function useGetSlideStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSlideStatsQuery, GetSlideStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSlideStatsQuery, GetSlideStatsQueryVariables>(GetSlideStatsDocument, options);
        }
export type GetSlideStatsQueryHookResult = ReturnType<typeof useGetSlideStatsQuery>;
export type GetSlideStatsLazyQueryHookResult = ReturnType<typeof useGetSlideStatsLazyQuery>;
export type GetSlideStatsSuspenseQueryHookResult = ReturnType<typeof useGetSlideStatsSuspenseQuery>;
export type GetSlideStatsQueryResult = Apollo.QueryResult<GetSlideStatsQuery, GetSlideStatsQueryVariables>;
export const ListSlideStatsDocument = gql`
    query listSlideStats($orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs, $where: SlideStatsWhereInput) {
  listSlideStats(
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
    where: $where
  ) {
    edges {
      node {
        ...SlideStatsFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${SlideStatsFieldsFragmentDoc}`;

/**
 * __useListSlideStatsQuery__
 *
 * To run a query within a React component, call `useListSlideStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSlideStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSlideStatsQuery({
 *   variables: {
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListSlideStatsQuery(baseOptions?: Apollo.QueryHookOptions<ListSlideStatsQuery, ListSlideStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSlideStatsQuery, ListSlideStatsQueryVariables>(ListSlideStatsDocument, options);
      }
export function useListSlideStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSlideStatsQuery, ListSlideStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSlideStatsQuery, ListSlideStatsQueryVariables>(ListSlideStatsDocument, options);
        }
export function useListSlideStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSlideStatsQuery, ListSlideStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSlideStatsQuery, ListSlideStatsQueryVariables>(ListSlideStatsDocument, options);
        }
export type ListSlideStatsQueryHookResult = ReturnType<typeof useListSlideStatsQuery>;
export type ListSlideStatsLazyQueryHookResult = ReturnType<typeof useListSlideStatsLazyQuery>;
export type ListSlideStatsSuspenseQueryHookResult = ReturnType<typeof useListSlideStatsSuspenseQuery>;
export type ListSlideStatsQueryResult = Apollo.QueryResult<ListSlideStatsQuery, ListSlideStatsQueryVariables>;
export const OnCreateSlideStatsDocument = gql`
    subscription onCreateSlideStats($where: SlideStatsWhereInput) {
  onCreateSlideStats(where: $where) {
    ...SlideStatsFields
  }
}
    ${SlideStatsFieldsFragmentDoc}`;

/**
 * __useOnCreateSlideStatsSubscription__
 *
 * To run a query within a React component, call `useOnCreateSlideStatsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateSlideStatsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateSlideStatsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateSlideStatsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateSlideStatsSubscription, OnCreateSlideStatsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateSlideStatsSubscription, OnCreateSlideStatsSubscriptionVariables>(OnCreateSlideStatsDocument, options);
      }
export type OnCreateSlideStatsSubscriptionHookResult = ReturnType<typeof useOnCreateSlideStatsSubscription>;
export type OnCreateSlideStatsSubscriptionResult = Apollo.SubscriptionResult<OnCreateSlideStatsSubscription>;
export const OnUpdateSlideStatsDocument = gql`
    subscription onUpdateSlideStats($where: SlideStatsWhereInput) {
  onUpdateSlideStats(where: $where) {
    ...SlideStatsFields
  }
}
    ${SlideStatsFieldsFragmentDoc}`;

/**
 * __useOnUpdateSlideStatsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateSlideStatsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateSlideStatsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateSlideStatsSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateSlideStatsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateSlideStatsSubscription, OnUpdateSlideStatsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateSlideStatsSubscription, OnUpdateSlideStatsSubscriptionVariables>(OnUpdateSlideStatsDocument, options);
      }
export type OnUpdateSlideStatsSubscriptionHookResult = ReturnType<typeof useOnUpdateSlideStatsSubscription>;
export type OnUpdateSlideStatsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateSlideStatsSubscription>;
export const OnDeleteSlideStatsDocument = gql`
    subscription onDeleteSlideStats {
  onDeleteSlideStats {
    ...SlideStatsFields
  }
}
    ${SlideStatsFieldsFragmentDoc}`;

/**
 * __useOnDeleteSlideStatsSubscription__
 *
 * To run a query within a React component, call `useOnDeleteSlideStatsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteSlideStatsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteSlideStatsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteSlideStatsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteSlideStatsSubscription, OnDeleteSlideStatsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteSlideStatsSubscription, OnDeleteSlideStatsSubscriptionVariables>(OnDeleteSlideStatsDocument, options);
      }
export type OnDeleteSlideStatsSubscriptionHookResult = ReturnType<typeof useOnDeleteSlideStatsSubscription>;
export type OnDeleteSlideStatsSubscriptionResult = Apollo.SubscriptionResult<OnDeleteSlideStatsSubscription>;
export const CreateTeamDocument = gql`
    mutation createTeam($data: CreateTeamInputDTO!) {
  createTeam(data: $data) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const GetTeamDocument = gql`
    query getTeam($where: TeamWhereUniqueInput!) {
  getTeam(where: $where) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables> & ({ variables: GetTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export function useGetTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamSuspenseQueryHookResult = ReturnType<typeof useGetTeamSuspenseQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export const ListTeamsDocument = gql`
    query listTeams($where: TeamWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listTeams(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...TeamFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useListTeamsQuery__
 *
 * To run a query within a React component, call `useListTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListTeamsQuery(baseOptions?: Apollo.QueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
      }
export function useListTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
        }
export function useListTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
        }
export type ListTeamsQueryHookResult = ReturnType<typeof useListTeamsQuery>;
export type ListTeamsLazyQueryHookResult = ReturnType<typeof useListTeamsLazyQuery>;
export type ListTeamsSuspenseQueryHookResult = ReturnType<typeof useListTeamsSuspenseQuery>;
export type ListTeamsQueryResult = Apollo.QueryResult<ListTeamsQuery, ListTeamsQueryVariables>;
export const ListTeamswithMembersDocument = gql`
    query listTeamswithMembers($where: TeamWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs, $memberPaginationArgs: PaginationArgs) {
  listTeams(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...TeamFields
        members(paginationArgs: $memberPaginationArgs) {
          edges {
            node {
              ...UserFields
            }
          }
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${TeamFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useListTeamswithMembersQuery__
 *
 * To run a query within a React component, call `useListTeamswithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamswithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamswithMembersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *      memberPaginationArgs: // value for 'memberPaginationArgs'
 *   },
 * });
 */
export function useListTeamswithMembersQuery(baseOptions?: Apollo.QueryHookOptions<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>(ListTeamswithMembersDocument, options);
      }
export function useListTeamswithMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>(ListTeamswithMembersDocument, options);
        }
export function useListTeamswithMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>(ListTeamswithMembersDocument, options);
        }
export type ListTeamswithMembersQueryHookResult = ReturnType<typeof useListTeamswithMembersQuery>;
export type ListTeamswithMembersLazyQueryHookResult = ReturnType<typeof useListTeamswithMembersLazyQuery>;
export type ListTeamswithMembersSuspenseQueryHookResult = ReturnType<typeof useListTeamswithMembersSuspenseQuery>;
export type ListTeamswithMembersQueryResult = Apollo.QueryResult<ListTeamswithMembersQuery, ListTeamswithMembersQueryVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($data: UpdateTeamInputDTO!) {
  updateTeam(data: $data) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($where: TeamWhereUniqueInput!) {
  deleteTeam(where: $where) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const AddUserToTeamDocument = gql`
    mutation addUserToTeam($data: ChangeUserToTeamInputDTO!) {
  addUserToTeam(data: $data) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type AddUserToTeamMutationFn = Apollo.MutationFunction<AddUserToTeamMutation, AddUserToTeamMutationVariables>;

/**
 * __useAddUserToTeamMutation__
 *
 * To run a mutation, you first call `useAddUserToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToTeamMutation, { data, loading, error }] = useAddUserToTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToTeamMutation, AddUserToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToTeamMutation, AddUserToTeamMutationVariables>(AddUserToTeamDocument, options);
      }
export type AddUserToTeamMutationHookResult = ReturnType<typeof useAddUserToTeamMutation>;
export type AddUserToTeamMutationResult = Apollo.MutationResult<AddUserToTeamMutation>;
export type AddUserToTeamMutationOptions = Apollo.BaseMutationOptions<AddUserToTeamMutation, AddUserToTeamMutationVariables>;
export const RemoveUserFromTeamDocument = gql`
    mutation removeUserFromTeam($data: ChangeUserToTeamInputDTO!) {
  removeUserFromTeam(data: $data) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type RemoveUserFromTeamMutationFn = Apollo.MutationFunction<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>;

/**
 * __useRemoveUserFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromTeamMutation, { data, loading, error }] = useRemoveUserFromTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveUserFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>(RemoveUserFromTeamDocument, options);
      }
export type RemoveUserFromTeamMutationHookResult = ReturnType<typeof useRemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationResult = Apollo.MutationResult<RemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>;
export const SetTechnicalManagerDocument = gql`
    mutation setTechnicalManager($data: SetTechnicalManagerInputDTO!) {
  setTechnicalManager(data: $data) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type SetTechnicalManagerMutationFn = Apollo.MutationFunction<SetTechnicalManagerMutation, SetTechnicalManagerMutationVariables>;

/**
 * __useSetTechnicalManagerMutation__
 *
 * To run a mutation, you first call `useSetTechnicalManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTechnicalManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTechnicalManagerMutation, { data, loading, error }] = useSetTechnicalManagerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetTechnicalManagerMutation(baseOptions?: Apollo.MutationHookOptions<SetTechnicalManagerMutation, SetTechnicalManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTechnicalManagerMutation, SetTechnicalManagerMutationVariables>(SetTechnicalManagerDocument, options);
      }
export type SetTechnicalManagerMutationHookResult = ReturnType<typeof useSetTechnicalManagerMutation>;
export type SetTechnicalManagerMutationResult = Apollo.MutationResult<SetTechnicalManagerMutation>;
export type SetTechnicalManagerMutationOptions = Apollo.BaseMutationOptions<SetTechnicalManagerMutation, SetTechnicalManagerMutationVariables>;
export const OnCreateTeamDocument = gql`
    subscription onCreateTeam($where: TeamWhereInput) {
  onCreateTeam(where: $where) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useOnCreateTeamSubscription__
 *
 * To run a query within a React component, call `useOnCreateTeamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateTeamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateTeamSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateTeamSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateTeamSubscription, OnCreateTeamSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateTeamSubscription, OnCreateTeamSubscriptionVariables>(OnCreateTeamDocument, options);
      }
export type OnCreateTeamSubscriptionHookResult = ReturnType<typeof useOnCreateTeamSubscription>;
export type OnCreateTeamSubscriptionResult = Apollo.SubscriptionResult<OnCreateTeamSubscription>;
export const OnUpdateTeamDocument = gql`
    subscription onUpdateTeam($where: TeamWhereInput) {
  onUpdateTeam(where: $where) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useOnUpdateTeamSubscription__
 *
 * To run a query within a React component, call `useOnUpdateTeamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateTeamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateTeamSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateTeamSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateTeamSubscription, OnUpdateTeamSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateTeamSubscription, OnUpdateTeamSubscriptionVariables>(OnUpdateTeamDocument, options);
      }
export type OnUpdateTeamSubscriptionHookResult = ReturnType<typeof useOnUpdateTeamSubscription>;
export type OnUpdateTeamSubscriptionResult = Apollo.SubscriptionResult<OnUpdateTeamSubscription>;
export const OnDeleteTeamDocument = gql`
    subscription onDeleteTeam {
  onDeleteTeam {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useOnDeleteTeamSubscription__
 *
 * To run a query within a React component, call `useOnDeleteTeamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteTeamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteTeamSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteTeamSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteTeamSubscription, OnDeleteTeamSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteTeamSubscription, OnDeleteTeamSubscriptionVariables>(OnDeleteTeamDocument, options);
      }
export type OnDeleteTeamSubscriptionHookResult = ReturnType<typeof useOnDeleteTeamSubscription>;
export type OnDeleteTeamSubscriptionResult = Apollo.SubscriptionResult<OnDeleteTeamSubscription>;
export const CreateExplicitUserAccessDocument = gql`
    mutation createExplicitUserAccess($data: CreateExplicitUserAccessInputDTO!) {
  createExplicitUserAccess(data: $data) {
    ...ExplicitUserAccessFields
  }
}
    ${ExplicitUserAccessFieldsFragmentDoc}`;
export type CreateExplicitUserAccessMutationFn = Apollo.MutationFunction<CreateExplicitUserAccessMutation, CreateExplicitUserAccessMutationVariables>;

/**
 * __useCreateExplicitUserAccessMutation__
 *
 * To run a mutation, you first call `useCreateExplicitUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExplicitUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExplicitUserAccessMutation, { data, loading, error }] = useCreateExplicitUserAccessMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateExplicitUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreateExplicitUserAccessMutation, CreateExplicitUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExplicitUserAccessMutation, CreateExplicitUserAccessMutationVariables>(CreateExplicitUserAccessDocument, options);
      }
export type CreateExplicitUserAccessMutationHookResult = ReturnType<typeof useCreateExplicitUserAccessMutation>;
export type CreateExplicitUserAccessMutationResult = Apollo.MutationResult<CreateExplicitUserAccessMutation>;
export type CreateExplicitUserAccessMutationOptions = Apollo.BaseMutationOptions<CreateExplicitUserAccessMutation, CreateExplicitUserAccessMutationVariables>;
export const ListExplicitUserAccessesDocument = gql`
    query listExplicitUserAccesses($where: ExplicitUserAccessWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listExplicitUserAccesses(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...ExplicitUserAccessFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${ExplicitUserAccessFieldsFragmentDoc}`;

/**
 * __useListExplicitUserAccessesQuery__
 *
 * To run a query within a React component, call `useListExplicitUserAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExplicitUserAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExplicitUserAccessesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListExplicitUserAccessesQuery(baseOptions?: Apollo.QueryHookOptions<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>(ListExplicitUserAccessesDocument, options);
      }
export function useListExplicitUserAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>(ListExplicitUserAccessesDocument, options);
        }
export function useListExplicitUserAccessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>(ListExplicitUserAccessesDocument, options);
        }
export type ListExplicitUserAccessesQueryHookResult = ReturnType<typeof useListExplicitUserAccessesQuery>;
export type ListExplicitUserAccessesLazyQueryHookResult = ReturnType<typeof useListExplicitUserAccessesLazyQuery>;
export type ListExplicitUserAccessesSuspenseQueryHookResult = ReturnType<typeof useListExplicitUserAccessesSuspenseQuery>;
export type ListExplicitUserAccessesQueryResult = Apollo.QueryResult<ListExplicitUserAccessesQuery, ListExplicitUserAccessesQueryVariables>;
export const DeleteExplicitUserAccessDocument = gql`
    mutation deleteExplicitUserAccess($where: ExplicitUserAccessWhereUniqueInput!) {
  deleteExplicitUserAccess(where: $where) {
    ...ExplicitUserAccessFields
  }
}
    ${ExplicitUserAccessFieldsFragmentDoc}`;
export type DeleteExplicitUserAccessMutationFn = Apollo.MutationFunction<DeleteExplicitUserAccessMutation, DeleteExplicitUserAccessMutationVariables>;

/**
 * __useDeleteExplicitUserAccessMutation__
 *
 * To run a mutation, you first call `useDeleteExplicitUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExplicitUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExplicitUserAccessMutation, { data, loading, error }] = useDeleteExplicitUserAccessMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteExplicitUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExplicitUserAccessMutation, DeleteExplicitUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExplicitUserAccessMutation, DeleteExplicitUserAccessMutationVariables>(DeleteExplicitUserAccessDocument, options);
      }
export type DeleteExplicitUserAccessMutationHookResult = ReturnType<typeof useDeleteExplicitUserAccessMutation>;
export type DeleteExplicitUserAccessMutationResult = Apollo.MutationResult<DeleteExplicitUserAccessMutation>;
export type DeleteExplicitUserAccessMutationOptions = Apollo.BaseMutationOptions<DeleteExplicitUserAccessMutation, DeleteExplicitUserAccessMutationVariables>;
export const OnCreateExplicitUserAccessDocument = gql`
    subscription onCreateExplicitUserAccess($where: ExplicitUserAccessWhereInput) {
  onCreateExplicitUserAccess(where: $where) {
    ...ExplicitUserAccessFields
  }
}
    ${ExplicitUserAccessFieldsFragmentDoc}`;

/**
 * __useOnCreateExplicitUserAccessSubscription__
 *
 * To run a query within a React component, call `useOnCreateExplicitUserAccessSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateExplicitUserAccessSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateExplicitUserAccessSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateExplicitUserAccessSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateExplicitUserAccessSubscription, OnCreateExplicitUserAccessSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateExplicitUserAccessSubscription, OnCreateExplicitUserAccessSubscriptionVariables>(OnCreateExplicitUserAccessDocument, options);
      }
export type OnCreateExplicitUserAccessSubscriptionHookResult = ReturnType<typeof useOnCreateExplicitUserAccessSubscription>;
export type OnCreateExplicitUserAccessSubscriptionResult = Apollo.SubscriptionResult<OnCreateExplicitUserAccessSubscription>;
export const OnUpdateExplicitUserAccessDocument = gql`
    subscription onUpdateExplicitUserAccess($where: ExplicitUserAccessWhereInput) {
  onUpdateExplicitUserAccess(where: $where) {
    ...ExplicitUserAccessFields
  }
}
    ${ExplicitUserAccessFieldsFragmentDoc}`;

/**
 * __useOnUpdateExplicitUserAccessSubscription__
 *
 * To run a query within a React component, call `useOnUpdateExplicitUserAccessSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateExplicitUserAccessSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateExplicitUserAccessSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateExplicitUserAccessSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateExplicitUserAccessSubscription, OnUpdateExplicitUserAccessSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateExplicitUserAccessSubscription, OnUpdateExplicitUserAccessSubscriptionVariables>(OnUpdateExplicitUserAccessDocument, options);
      }
export type OnUpdateExplicitUserAccessSubscriptionHookResult = ReturnType<typeof useOnUpdateExplicitUserAccessSubscription>;
export type OnUpdateExplicitUserAccessSubscriptionResult = Apollo.SubscriptionResult<OnUpdateExplicitUserAccessSubscription>;
export const OnDeleteExplicitUserAccessDocument = gql`
    subscription onDeleteExplicitUserAccess {
  onDeleteExplicitUserAccess {
    ...ExplicitUserAccessFields
  }
}
    ${ExplicitUserAccessFieldsFragmentDoc}`;

/**
 * __useOnDeleteExplicitUserAccessSubscription__
 *
 * To run a query within a React component, call `useOnDeleteExplicitUserAccessSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteExplicitUserAccessSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteExplicitUserAccessSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteExplicitUserAccessSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteExplicitUserAccessSubscription, OnDeleteExplicitUserAccessSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteExplicitUserAccessSubscription, OnDeleteExplicitUserAccessSubscriptionVariables>(OnDeleteExplicitUserAccessDocument, options);
      }
export type OnDeleteExplicitUserAccessSubscriptionHookResult = ReturnType<typeof useOnDeleteExplicitUserAccessSubscription>;
export type OnDeleteExplicitUserAccessSubscriptionResult = Apollo.SubscriptionResult<OnDeleteExplicitUserAccessSubscription>;
export const ListUserMeetingJoinsDocument = gql`
    query listUserMeetingJoins($where: UserMeetingJoinWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listUserMeetingJoins(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...UserMeetingJoinFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${UserMeetingJoinFieldsFragmentDoc}`;

/**
 * __useListUserMeetingJoinsQuery__
 *
 * To run a query within a React component, call `useListUserMeetingJoinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserMeetingJoinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserMeetingJoinsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListUserMeetingJoinsQuery(baseOptions?: Apollo.QueryHookOptions<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>(ListUserMeetingJoinsDocument, options);
      }
export function useListUserMeetingJoinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>(ListUserMeetingJoinsDocument, options);
        }
export function useListUserMeetingJoinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>(ListUserMeetingJoinsDocument, options);
        }
export type ListUserMeetingJoinsQueryHookResult = ReturnType<typeof useListUserMeetingJoinsQuery>;
export type ListUserMeetingJoinsLazyQueryHookResult = ReturnType<typeof useListUserMeetingJoinsLazyQuery>;
export type ListUserMeetingJoinsSuspenseQueryHookResult = ReturnType<typeof useListUserMeetingJoinsSuspenseQuery>;
export type ListUserMeetingJoinsQueryResult = Apollo.QueryResult<ListUserMeetingJoinsQuery, ListUserMeetingJoinsQueryVariables>;
export const ListUserMeetingJoinsWithUsersDocument = gql`
    query listUserMeetingJoinsWithUsers($where: UserMeetingJoinWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listUserMeetingJoins(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...UserMeetingJoinFields
        ...UserMeetingJoinRelationUser
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${UserMeetingJoinFieldsFragmentDoc}
${UserMeetingJoinRelationUserFragmentDoc}`;

/**
 * __useListUserMeetingJoinsWithUsersQuery__
 *
 * To run a query within a React component, call `useListUserMeetingJoinsWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserMeetingJoinsWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserMeetingJoinsWithUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListUserMeetingJoinsWithUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>(ListUserMeetingJoinsWithUsersDocument, options);
      }
export function useListUserMeetingJoinsWithUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>(ListUserMeetingJoinsWithUsersDocument, options);
        }
export function useListUserMeetingJoinsWithUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>(ListUserMeetingJoinsWithUsersDocument, options);
        }
export type ListUserMeetingJoinsWithUsersQueryHookResult = ReturnType<typeof useListUserMeetingJoinsWithUsersQuery>;
export type ListUserMeetingJoinsWithUsersLazyQueryHookResult = ReturnType<typeof useListUserMeetingJoinsWithUsersLazyQuery>;
export type ListUserMeetingJoinsWithUsersSuspenseQueryHookResult = ReturnType<typeof useListUserMeetingJoinsWithUsersSuspenseQuery>;
export type ListUserMeetingJoinsWithUsersQueryResult = Apollo.QueryResult<ListUserMeetingJoinsWithUsersQuery, ListUserMeetingJoinsWithUsersQueryVariables>;
export const ListMeetingLiveParticipantsDocument = gql`
    query listMeetingLiveParticipants($meetingId: String!) {
  listMeetingLiveParticipants(meetingId: $meetingId) {
    ...LiveMeetingParticipantsFields
  }
}
    ${LiveMeetingParticipantsFieldsFragmentDoc}`;

/**
 * __useListMeetingLiveParticipantsQuery__
 *
 * To run a query within a React component, call `useListMeetingLiveParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMeetingLiveParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMeetingLiveParticipantsQuery({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useListMeetingLiveParticipantsQuery(baseOptions: Apollo.QueryHookOptions<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables> & ({ variables: ListMeetingLiveParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables>(ListMeetingLiveParticipantsDocument, options);
      }
export function useListMeetingLiveParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables>(ListMeetingLiveParticipantsDocument, options);
        }
export function useListMeetingLiveParticipantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables>(ListMeetingLiveParticipantsDocument, options);
        }
export type ListMeetingLiveParticipantsQueryHookResult = ReturnType<typeof useListMeetingLiveParticipantsQuery>;
export type ListMeetingLiveParticipantsLazyQueryHookResult = ReturnType<typeof useListMeetingLiveParticipantsLazyQuery>;
export type ListMeetingLiveParticipantsSuspenseQueryHookResult = ReturnType<typeof useListMeetingLiveParticipantsSuspenseQuery>;
export type ListMeetingLiveParticipantsQueryResult = Apollo.QueryResult<ListMeetingLiveParticipantsQuery, ListMeetingLiveParticipantsQueryVariables>;
export const JoinMeetingParticipantsDocument = gql`
    mutation joinMeetingParticipants($meetingId: String!) {
  joinMeetingParticipants(meetingId: $meetingId) {
    ...LiveMeetingParticipantsFields
  }
}
    ${LiveMeetingParticipantsFieldsFragmentDoc}`;
export type JoinMeetingParticipantsMutationFn = Apollo.MutationFunction<JoinMeetingParticipantsMutation, JoinMeetingParticipantsMutationVariables>;

/**
 * __useJoinMeetingParticipantsMutation__
 *
 * To run a mutation, you first call `useJoinMeetingParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinMeetingParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinMeetingParticipantsMutation, { data, loading, error }] = useJoinMeetingParticipantsMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useJoinMeetingParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<JoinMeetingParticipantsMutation, JoinMeetingParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinMeetingParticipantsMutation, JoinMeetingParticipantsMutationVariables>(JoinMeetingParticipantsDocument, options);
      }
export type JoinMeetingParticipantsMutationHookResult = ReturnType<typeof useJoinMeetingParticipantsMutation>;
export type JoinMeetingParticipantsMutationResult = Apollo.MutationResult<JoinMeetingParticipantsMutation>;
export type JoinMeetingParticipantsMutationOptions = Apollo.BaseMutationOptions<JoinMeetingParticipantsMutation, JoinMeetingParticipantsMutationVariables>;
export const LeaveMeetingParticipantsDocument = gql`
    mutation leaveMeetingParticipants($meetingId: String!) {
  leaveMeetingParticipants(meetingId: $meetingId) {
    ...LiveMeetingParticipantsFields
  }
}
    ${LiveMeetingParticipantsFieldsFragmentDoc}`;
export type LeaveMeetingParticipantsMutationFn = Apollo.MutationFunction<LeaveMeetingParticipantsMutation, LeaveMeetingParticipantsMutationVariables>;

/**
 * __useLeaveMeetingParticipantsMutation__
 *
 * To run a mutation, you first call `useLeaveMeetingParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveMeetingParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveMeetingParticipantsMutation, { data, loading, error }] = useLeaveMeetingParticipantsMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useLeaveMeetingParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<LeaveMeetingParticipantsMutation, LeaveMeetingParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveMeetingParticipantsMutation, LeaveMeetingParticipantsMutationVariables>(LeaveMeetingParticipantsDocument, options);
      }
export type LeaveMeetingParticipantsMutationHookResult = ReturnType<typeof useLeaveMeetingParticipantsMutation>;
export type LeaveMeetingParticipantsMutationResult = Apollo.MutationResult<LeaveMeetingParticipantsMutation>;
export type LeaveMeetingParticipantsMutationOptions = Apollo.BaseMutationOptions<LeaveMeetingParticipantsMutation, LeaveMeetingParticipantsMutationVariables>;
export const MeetingParticipantsHeartbeatDocument = gql`
    mutation meetingParticipantsHeartbeat($meetingId: String!) {
  meetingParticipantsHeartbeat(meetingId: $meetingId)
}
    `;
export type MeetingParticipantsHeartbeatMutationFn = Apollo.MutationFunction<MeetingParticipantsHeartbeatMutation, MeetingParticipantsHeartbeatMutationVariables>;

/**
 * __useMeetingParticipantsHeartbeatMutation__
 *
 * To run a mutation, you first call `useMeetingParticipantsHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeetingParticipantsHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [meetingParticipantsHeartbeatMutation, { data, loading, error }] = useMeetingParticipantsHeartbeatMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useMeetingParticipantsHeartbeatMutation(baseOptions?: Apollo.MutationHookOptions<MeetingParticipantsHeartbeatMutation, MeetingParticipantsHeartbeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MeetingParticipantsHeartbeatMutation, MeetingParticipantsHeartbeatMutationVariables>(MeetingParticipantsHeartbeatDocument, options);
      }
export type MeetingParticipantsHeartbeatMutationHookResult = ReturnType<typeof useMeetingParticipantsHeartbeatMutation>;
export type MeetingParticipantsHeartbeatMutationResult = Apollo.MutationResult<MeetingParticipantsHeartbeatMutation>;
export type MeetingParticipantsHeartbeatMutationOptions = Apollo.BaseMutationOptions<MeetingParticipantsHeartbeatMutation, MeetingParticipantsHeartbeatMutationVariables>;
export const OnCreateUserMeetingJoinDocument = gql`
    subscription onCreateUserMeetingJoin($where: UserMeetingJoinWhereInput) {
  onCreateUserMeetingJoin(where: $where) {
    ...UserMeetingJoinFields
  }
}
    ${UserMeetingJoinFieldsFragmentDoc}`;

/**
 * __useOnCreateUserMeetingJoinSubscription__
 *
 * To run a query within a React component, call `useOnCreateUserMeetingJoinSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateUserMeetingJoinSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateUserMeetingJoinSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateUserMeetingJoinSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateUserMeetingJoinSubscription, OnCreateUserMeetingJoinSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateUserMeetingJoinSubscription, OnCreateUserMeetingJoinSubscriptionVariables>(OnCreateUserMeetingJoinDocument, options);
      }
export type OnCreateUserMeetingJoinSubscriptionHookResult = ReturnType<typeof useOnCreateUserMeetingJoinSubscription>;
export type OnCreateUserMeetingJoinSubscriptionResult = Apollo.SubscriptionResult<OnCreateUserMeetingJoinSubscription>;
export const OnDeleteUserMeetingJoinDocument = gql`
    subscription onDeleteUserMeetingJoin {
  onDeleteUserMeetingJoin {
    ...UserMeetingJoinFields
  }
}
    ${UserMeetingJoinFieldsFragmentDoc}`;

/**
 * __useOnDeleteUserMeetingJoinSubscription__
 *
 * To run a query within a React component, call `useOnDeleteUserMeetingJoinSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteUserMeetingJoinSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteUserMeetingJoinSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteUserMeetingJoinSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteUserMeetingJoinSubscription, OnDeleteUserMeetingJoinSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteUserMeetingJoinSubscription, OnDeleteUserMeetingJoinSubscriptionVariables>(OnDeleteUserMeetingJoinDocument, options);
      }
export type OnDeleteUserMeetingJoinSubscriptionHookResult = ReturnType<typeof useOnDeleteUserMeetingJoinSubscription>;
export type OnDeleteUserMeetingJoinSubscriptionResult = Apollo.SubscriptionResult<OnDeleteUserMeetingJoinSubscription>;
export const OnMeetingLiveParticipantsChangeDocument = gql`
    subscription onMeetingLiveParticipantsChange($meetingId: String!) {
  onMeetingLiveParticipantsChange(meetingId: $meetingId) {
    ...MeetingParticipantsChangePacketFields
  }
}
    ${MeetingParticipantsChangePacketFieldsFragmentDoc}`;

/**
 * __useOnMeetingLiveParticipantsChangeSubscription__
 *
 * To run a query within a React component, call `useOnMeetingLiveParticipantsChangeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMeetingLiveParticipantsChangeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMeetingLiveParticipantsChangeSubscription({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useOnMeetingLiveParticipantsChangeSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnMeetingLiveParticipantsChangeSubscription, OnMeetingLiveParticipantsChangeSubscriptionVariables> & ({ variables: OnMeetingLiveParticipantsChangeSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMeetingLiveParticipantsChangeSubscription, OnMeetingLiveParticipantsChangeSubscriptionVariables>(OnMeetingLiveParticipantsChangeDocument, options);
      }
export type OnMeetingLiveParticipantsChangeSubscriptionHookResult = ReturnType<typeof useOnMeetingLiveParticipantsChangeSubscription>;
export type OnMeetingLiveParticipantsChangeSubscriptionResult = Apollo.SubscriptionResult<OnMeetingLiveParticipantsChangeSubscription>;
export const GetUserDocument = gql`
    query getUser($where: UserWhereUniqueInput!) {
  getUser(where: $where) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const ListUsersDocument = gql`
    query listUsers($where: UserWhereInput, $orderByArgs: OrderByArgs, $paginationArgs: PaginationArgs) {
  listUsers(
    where: $where
    orderByArgs: $orderByArgs
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        ...UserFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByArgs: // value for 'orderByArgs'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($data: CreateUserInputDTO!) {
  createUser(data: $data) {
    user {
      ...UserFields
    }
    temporaryPassword
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const OnCreateUserDocument = gql`
    subscription onCreateUser($where: UserWhereInput) {
  onCreateUser(where: $where) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useOnCreateUserSubscription__
 *
 * To run a query within a React component, call `useOnCreateUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateUserSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnCreateUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateUserSubscription, OnCreateUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateUserSubscription, OnCreateUserSubscriptionVariables>(OnCreateUserDocument, options);
      }
export type OnCreateUserSubscriptionHookResult = ReturnType<typeof useOnCreateUserSubscription>;
export type OnCreateUserSubscriptionResult = Apollo.SubscriptionResult<OnCreateUserSubscription>;
export const OnUpdateUserDocument = gql`
    subscription onUpdateUser($where: UserWhereInput) {
  onUpdateUser(where: $where) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useOnUpdateUserSubscription__
 *
 * To run a query within a React component, call `useOnUpdateUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateUserSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOnUpdateUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnUpdateUserSubscription, OnUpdateUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateUserSubscription, OnUpdateUserSubscriptionVariables>(OnUpdateUserDocument, options);
      }
export type OnUpdateUserSubscriptionHookResult = ReturnType<typeof useOnUpdateUserSubscription>;
export type OnUpdateUserSubscriptionResult = Apollo.SubscriptionResult<OnUpdateUserSubscription>;
export const OnDeleteUserDocument = gql`
    subscription onDeleteUser {
  onDeleteUser {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useOnDeleteUserSubscription__
 *
 * To run a query within a React component, call `useOnDeleteUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteUserSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDeleteUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDeleteUserSubscription, OnDeleteUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteUserSubscription, OnDeleteUserSubscriptionVariables>(OnDeleteUserDocument, options);
      }
export type OnDeleteUserSubscriptionHookResult = ReturnType<typeof useOnDeleteUserSubscription>;
export type OnDeleteUserSubscriptionResult = Apollo.SubscriptionResult<OnDeleteUserSubscription>;